/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 81);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(42);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(41);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(43);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(44);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(45);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(46);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(47);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(48);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(49);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(50);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(51);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(52);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(53);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(54);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(55);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(56);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(57);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(58);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(59);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(60);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(61);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(62);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(63);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(64);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(65);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(66);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(67);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(68);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(69);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(70);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(71);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(72);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(73);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(74);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(75);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(76);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(77);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(78);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(79);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(80);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-banner{min-height:135px;width:100%;background:var(--neutral-white) 0% 0% no-repeat padding-box;box-shadow:0px 1px 7px #22204633;display:flex;flex-direction:column}.fm-banner .fm-banner-row{display:flex;flex:1}.fm-banner .fm-banner__icon-box{width:106px;min-width:106px;background-color:grey;display:flex;justify-content:center;align-items:flex-start;padding-top:34px;color:var(--neutral-white)}.fm-banner .fm-banner__text-box{padding:24px}.fm-banner .fm-banner__text-box .fm-banner__text-box__heading::slotted(*){color:var(--neutral-grey-1-text);font-family:'Roboto';font-size:var(--fm-font-size-20);margin:0px 0px 8px 0px;padding:0px}.fm-banner .fm-banner__text-box .fm-banner__text-box__body::slotted(*){color:var(--neutral-grey-1-text);font-family:'Roboto';font-size:var(--fm-font-size-16);margin-bottom:16px}.fm-banner .fm-banner__text-box .fm-banner__text-box__lines{color:var(--neutral-grey-1-text);font-family:'Roboto';font-size:var(--fm-font-size-16);line-height:24px}.fm-banner .fm-banner__text-box .fm-banner__text-box__lines::slotted(*){font-size:var(--fm-font-size-16)}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}.fm-banner-mobile-bar{display:none}@media (max-width: 600px){.fm-banner-mobile-bar{display:block;background-color:grey;height:8px;width:100%}.fm-banner{max-width:280px}.fm-banner .fm-banner__icon-box{background-color:var(--neutral-white);color:grey;padding-top:14.67px;width:auto;min-width:auto;padding-left:12px}.fm-banner .fm-banner__text-box{padding:22px 16px}.fm-banner .fm-banner__text-box .fm-banner__text-box__heading::slotted(*){font-size:16px;font-weight:500}.fm-banner .fm-banner__text-box .fm-banner__text-box__body::slotted(*){margin-bottom:8px;color:var(--neutral-grey-1-text);font-weight:100}.fm-banner .fm-banner__text-box .fm-banner__text-box__lines::slotted(*){line-height:20px}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-icon{fill:#fff}@keyframes rotation{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fm-icon-roate{transform:translate(-2.228 -2);transform-origin:50% 50% 0}.material-icons{font-family:'Material Icons'}.material-icons.md-32{font-size:32px}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{display:inline-flex;justify-content:center;align-items:center;min-width:96px;height:48px;opacity:1;border-radius:8px;box-shadow:0px 1px 3px #22204633;padding:13px 24px;border:none;font-size:var(--fm-font-size-16);font-style:var(--fm-font-style-normal);font-weight:400;font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0-38);line-height:var(--fm-line-spacing-24);white-space:nowrap;box-sizing:border-box}.fm-button-disabled{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button .fm-icon-check-circle{margin-right:16px}.fm-button:hover:not(.fm-button-disabled){box-shadow:0px 1px 8px #22204633;cursor:pointer}.fm-button:disabled,.fm-button-loading:hover{cursor:not-allowed}.fm-button:focus{box-shadow:none;outline:4px solid #00c6c680}.fm-button:focus:not(.focus-visible){outline:none}.fm-button:focus-visible{box-shadow:none;outline:4px solid #00c6c680}.fm-button:active:not(.fm-button-disabled){box-shadow:none;border-color:var(--accent-links-hover)}.fm-button:active>.fm-button__slot_label{text-decoration:underline}.material-icons{font-family:'Material Icons';font-size:var(--fm-font-size-24)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{min-width:56px;right:0;height:56px;border-radius:28px;padding:13px;background:var(--accent-links) 0% 0% no-repeat padding-box;background-color:var(--accent-links);border:none;color:var(--neutral-white);font-size:var(--fm-font-size-16);transition:background-color 300ms ease-out}.fm-button__floating-action__icon{color:var(--neutral-white);font-size:var(--fm-font-size-30)}.fm-button .fm-button__floating-action__label{max-width:0px;display:inline-block;overflow:hidden;transition:max-width 300ms ease-out}.fm-button:hover{background-color:var(--accent-links-hover)}.fm-button:hover>.fm-button__floating-action__icon{padding-right:9.3px}.fm-button:hover>.fm-button__floating-action__label{max-width:100%}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{background:var(--accent-links) 0% 0% no-repeat padding-box;font-size:var(--fm-font-size-16);letter-spacing:var(--fm-character-spacing-0-38);line-height:var(--fm-line-spacing-16);color:var(--neutral-white);border-radius:8px}.fm-button-loading{background:var(--accent-links-hover) 0% 0% no-repeat padding-box;border-color:var(--accent-links-hover)}.fm-button-disabled{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box;color:var(--neutral-grey-2-lighter-text);box-shadow:none;border-color:var(--neutral-grey-4-light-bg)}.fm-button:focus{background:var(--accent-links-hover) 0% 0% no-repeat padding-box}.fm-button:hover:not(.fm-button-disabled):not(:focus){background:var(--accent-links-hover) 0% 0% no-repeat padding-box;border-color:var(--accent-links-hover)}.fm-button:active:not(.fm-button-disabled){background:var(--accent-links-hover) 0% 0% no-repeat padding-box;box-shadow:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--accent-links);color:var(--accent-links);font-size:var(--fm-font-size-16);letter-spacing:var(--fm-character-spacing-0-38);line-height:var(--fm-line-spacing-16)}.fm-button-disabled{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box;color:var(--neutral-grey-2-lighter-text);box-shadow:none;border:none}.fm-button-loading{border-color:var(--accent-links-hover)}.fm-button .fm-icon{fill:var(--accent-links)}.fm-button-loading .fm-icon{fill:var(--accent-links-hover)}.fm-button .fm-icon-check-circle{color:var(--accent-links)}.fm-button:hover:not(.fm-button-disabled):not(:focus){background:var(--neutral-white) 0% 0% no-repeat padding-box;border-color:var(--accent-links-hover)}.fm-button:hover:not(.fm-button-disabled){color:var(--accent-links-hover)}.fm-button:hover>.fm-icon-check-circle{color:var(--accent-links-hover)}.fm-button:focus{background:var(--neutral-white) 0% 0% no-repeat padding-box}.fm-button:active:not(:disabled){background:var(--neutral-white) 0% 0% no-repeat padding-box;border:solid 2px var(--accent-links-hover);color:var(--accent-links-hover)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-card{display:inline-block;background:var(--neutral-white) 0% 0% no-repeat padding-box;box-shadow:0px 1px 7px #22204633;border-radius:16px}.fm-card.expand-height{height:100%}.fm-card.expand-width{width:100%}.clickable-card{cursor:pointer}.clickable-card:focus{outline:4px solid var(--brand-light)}.clickable-card:focus:not(.focus-visible){outline:none}.clickable-card:focus-visible{outline:4px solid var(--brand-light)}.clickable-card:hover{box-shadow:0px 1px 16px #22204633}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-menu-contents{position:absolute;width:fit-content;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:1px solid var(--neutral-grey-3-borders);border-radius:7px;box-shadow:0px 1px 7px #22204633;display:none;opacity:0;transition:opacity 200ms ease-in-out}.fm-menu-contents.visible{display:inline-block;opacity:1}.fm-menu-contents__list{width:fit-content;list-style-type:none;padding:0;margin:0;text-align:left}.fm-menu-contents__list__item{border-bottom:1px solid var(--neutral-grey-3-borders);box-sizing:border-box}.fm-menu-contents__list__item:last-child{border-bottom:1px solid transparent}.fm-menu-contents__list__item__text{display:inline-block;width:100%;font:var(--fm-font-style-normal) normal var(--fm-font-weight-normal) var(--fm-font-size-16)/var(--fm-line-spacing-24) var(--fm-font-family-roboto);color:var(--accent-links);letter-spacing:var(--fm-character-spacing-0-38);white-space:nowrap;text-decoration:none;padding:12px 16px;box-sizing:border-box}.fm-menu-contents__list__item__text:hover{color:var(--accent-links-hover);cursor:pointer}.fm-menu-contents__list__item__text:focus{color:var(--accent-links);outline:4px solid #00c6c680}.fm-menu-contents__list__item__text:focus:not(.focus-visible){outline:none}.fm-menu-contents__list__item__text:focus-visible{color:var(--accent-links);outline:4px solid #00c6c680}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-inline-menu{position:relative}.fm-inline-menu.hide{display:none}.fm-inline-menu .activator-container .activator:focus{outline:4px solid var(--brand-light)}.fm-inline-menu .activator-container .activator:focus:not(.focus-visible){outline:none}.fm-inline-menu .activator-container .activator:focus-visible{outline:4px solid #00c6c680}.fm-inline-menu .material-icons{font-family:'Material Icons';font-size:24px;color:var(--accent-links);user-select:none;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-topline-card-action-bar{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;height:56px;width:100%;padding:18px 20px;border-top:1px solid var(--neutral-grey-3-borders);box-sizing:border-box}.fm-topline-card-action-bar .option{margin-right:16px;text-decoration:none}.fm-topline-card-action-bar .option:focus{outline:4px solid var(--brand-light)}.fm-topline-card-action-bar .option:focus:not(.focus-visible){outline:none}.fm-topline-card-action-bar .option:focus-visible{outline:4px solid var(--brand-light)}.fm-topline-card-action-bar .action-bar{margin-right:0;margin-left:auto}.fm-topline-card-action-bar .material-icons{font-family:'Material Icons';font-size:24px;color:var(--accent-links);user-select:none;cursor:pointer}@media screen and (min-width: 756px){.fm-topline-card-action-bar{flex-direction:column;height:232px;width:56px;padding:18px 20px;border-top:none;text-align:center}.fm-topline-card-action-bar .option{margin-right:0;margin-bottom:16px}.fm-topline-card-action-bar .action-bar{margin-bottom:0px;margin-top:auto}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-card-topline-layout{display:grid;grid-template-areas:\"meta meta\" \"main image\" \"action action\";grid-template-columns:auto 91px;grid-template-rows:44px 127px 56px;height:227px;width:100%;min-width:380px;padding:0}.fm-card-topline-layout .image-container{grid-area:image;padding:16px 8px;height:75px;width:75px}.fm-card-topline-layout .meta-container{grid-area:meta;height:44px;width:100%;padding:0px 10px;border-bottom:1px solid var(--neutral-grey-3-borders);box-sizing:border-box}.fm-card-topline-layout .main-content-container{grid-area:main;height:100%;width:100%;padding:16px 0 16px 16px;overflow:hidden;box-sizing:border-box}.fm-card-topline-layout .action-bar-container{grid-area:action;border-bottom-left-radius:16px;border-bottom-right-radius:16px;width:100%}.fm-card-topline-layout.collapse-image{grid-template-areas:\"meta\" \"main\" \"action\";grid-template-columns:auto;grid-template-rows:44px 127px 56px}.fm-card-topline-layout.collapse-image .image-container{display:none}.fm-card-topline-layout.collapse-image .main-content-container{padding-right:16px}@media screen and (min-width: 756px){.fm-card-topline-layout{grid-template-areas:\"image meta action\" \"image main action\";grid-template-columns:236px auto 56px;grid-template-rows:44px 188px;height:232px}.fm-card-topline-layout .image-container{padding:0;border-top-left-radius:16px;border-bottom-left-radius:16px;height:232px;width:236px;overflow:hidden}.fm-card-topline-layout .meta-container{height:44px;padding:16px 16px 12px 16px;border-bottom:none}.fm-card-topline-layout .main-content-container{padding-right:16px}.fm-card-topline-layout .action-bar-container{border-bottom-left-radius:unset;border-top-right-radius:16px}.fm-card-topline-layout.collapse-image{grid-template-areas:\"meta action\" \"main action\";grid-template-columns:auto 56px;grid-template-rows:44px 188px}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".container{width:100%;height:16px;background-color:var(--brand-dark)}.manager{box-sizing:border-box;width:100%;height:64px;box-shadow:0px 1px 8px #22204633;opacity:1;display:flex;flex-direction:row;align-items:center;padding:22px 24px}.manager span{white-space:nowrap;font-family:var(--fm-font-family-roboto);font-size:var(--fm-font-size-16);line-height:var(--fm-line-spacing-24);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-white);text-align:left;opacity:1}.manager span.dark-text{color:var(--neutral-grey-1-text)}.manager span.current-cluster{font-size:var(--fm-font-size-30);line-height:--fm-line-spacing-38;font-weight:bold;margin-left:16px;cursor:pointer}.manager .spacer{flex:1}.manager .cluster-select{position:relative;display:flex;flex-direction:column}.manager .cluster-select .material-icons.toggle{font-family:'Material Icons';user-select:none;font-size:26px;height:24px;width:24px;cursor:pointer}.manager .cluster-select .material-icons.toggle:focus{outline:4px solid var(--brand-light)}.manager .cluster-select .material-icons.toggle:focus:not(.focus-visible){outline:none}.manager .cluster-select .material-icons.toggle:focus-visible{outline:4px solid var(--brand-light)}.manager .cluster-select .triangle{position:absolute;margin-left:auto;margin-right:auto;left:0;right:0;top:-10px;width:0;height:0;content:'';border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid white}.manager .cluster-select .options-dropdown{position:absolute;z-index:1000;align-self:center;margin-left:3px;top:44px;background-color:var(--neutral-white);box-shadow:0px 0px 0px #ffffffff, 0px 16px 24px #00000033, 0px 16px 24px #00000033;border-radius:3px;white-space:nowrap;display:none;opacity:0;transition:opacity 0.2s ease-in-out}.manager .cluster-select .options-dropdown.visible{display:block;opacity:1;transition:opacity 0.2s ease-in-out}.manager .cluster-select hr{margin:0;border:0;border-top:1px solid var(--neutral-grey-3-borders)}.manager .cluster-select .list-item{height:48px;padding:14px 16px;box-sizing:border-box;border-radius:8px;display:flex;justify-content:space-between;cursor:pointer}.manager .cluster-select .list-item span{font-size:var(--fm-font-size-16);line-height:var(--fm-line-spacing-24);font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0-38);color:var(--accent-links);text-align:left;opacity:1}.manager .cluster-select .list-item span.material-icons{height:16px;width:16px;font-family:'Material Icons';user-select:none;font-size:20px}.manager .cluster-select :focus{outline:4px solid #00c6c680;outline-offset:-4px}.manager .cluster-select :focus:not(.focus-visible){outline:none}.manager .cluster-select :focus-visible{outline:4px solid #00c6c680;outline-offset:-4px}@media (max-width: 768px){.container{display:none}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-banner .fm-banner__icon-box{background:var(--notification--error) 0% 0% no-repeat padding-box}.fm-banner .fm-banner__text-box .fm-banner__text-box__lines{color:var(--notification--error);text-decoration:var(--fm-decoration-underline);font-family:'Roboto';line-height:12px;font-size:var(--fm-font-size-16)}@media (max-width: 600px){.fm-banner-mobile-bar{background-color:var(--notification--error)}.fm-banner .fm-banner__icon-box{background-color:var(--neutral-white);color:var(--notification--error)}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-banner .fm-banner__icon-box{background:var(--notification--info) 0% 0% no-repeat padding-box}@media (max-width: 600px){.fm-banner-mobile-bar{background-color:var(--notification--info)}.fm-banner .fm-banner__icon-box{background-color:var(--neutral-white);color:var(--notification--info)}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-heading{display:block}.fm-heading ::slotted(*){display:inline-block;margin:0;padding:0;font-family:var(--fm-font-family-roboto);color:var(--neutral-grey-1-text);letter-spacing:var(--fm-character-spacing-0);font-weight:var(--fm-font-weight-medium)}.fm-heading ::slotted(h1){font-size:36px;color:var(--neutral-grey-1-text);font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0)}.fm-heading ::slotted(h2){font-size:30px}.fm-heading ::slotted(h3){font-size:24px}.fm-heading ::slotted(h4){font-size:20px}.fm-heading ::slotted(h5){font-size:16px;color:var(--neutral-grey-2-lighter-text);text-transform:uppercase;letter-spacing:var(--fm-character-spacing-2)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "html{overflow:scroll}::-webkit-scrollbar{width:0px;background:transparent}h5,h4,span{white-space:nowrap}.container{background:var(--neutral-white) 0% 0% no-repeat padding-box;box-shadow:0px 1px 8px #22204633;width:286px;height:100%;overflow:auto;display:flex;flex-direction:column;justify-content:space-between;transition:width 0.5s}.container .nav-items{display:flex;flex-direction:column;justify-content:space-between;margin-top:24px;padding-left:var(--fm-line-spacing-24);height:calc(100%-80px)}.container .nav-items .nav-group span.divider{border-top:1px solid var(--neutral-grey-3-borders);width:100%;margin-top:30px;margin-bottom:30px}.container .nav-items .nav-group span.divider.invisible{border-top:1px solid transparent}.container .nav-items .nav-group .nav-item{height:48px;display:flex;flex-direction:row;align-items:center;cursor:pointer}.container .nav-items .nav-group .nav-item span{height:48px;width:8px;background-color:transparent;transition:background-color 0.15s linear}.container .nav-items .nav-group .nav-item span.active{transition:background-color 0.15s 0.15s linear;background-color:var(--brand-light)}.container .nav-items .nav-group .nav-item .icon-area{margin-left:8px;height:32px;width:32px;display:flex;justify-content:center;align-items:center}.container .nav-items .nav-group .nav-item h4{margin:0 0 0 16px}.container .nav-items .nav-group :focus{outline:4px solid var(--brand-light);outline-offset:-5px}.container .nav-items .nav-group :focus:not(.focus-visible){outline:none}.container .nav-items .nav-group :focus-visible{outline:4px solid var(--brand-light);outline-offset:-5px}.container .get-help{display:flex;align-items:center;height:36px;margin-left:var(--fm-line-spacing-24);padding-bottom:24px;font-size:var(--fm-font-size-16);font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0-38);color:var(--accent-links)}.container .get-help fm-icon-help-purple{cursor:pointer}.container .get-help :focus{outline:4px solid var(--brand-light)}.container .get-help :focus:not(.focus-visible){outline:none}.container .get-help :focus-visible{outline:4px solid var(--brand-light)}.container .get-help span{cursor:pointer;margin-left:6px}.container .footer{margin-top:80px}.container .collapse-controls{cursor:pointer;font-family:var(--fm-font-family-roboto);font-size:var(--fm-font-size-16);line-height:var(--fm-line-spacing-24);letter-spacing:var(--fm-character-spacing-0-38);color:var(--accent-links) !important;opacity:1;background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box;height:48px;display:flex;flex-direction:row;align-items:center}.container .collapse-controls .icon{height:16px;width:16px;margin-left:12px;display:flex;justify-content:center}.container .collapse-controls .icon fm-icon-double-chevron-right{display:none}.container .collapse-controls :focus{outline:4px solid var(--brand-light)}.container .collapse-controls :focus:not(.focus-visible){outline:none}.container .collapse-controls :focus-visible{outline:4px solid var(--brand-light)}.container .collapse-controls span{margin:3px 0 0 4px}.container.collapsed{transition:width 0.5s;width:64px}.container.collapsed .nav-group span.divider{border-top:1px solid var(--neutral-grey-3-borders);width:100%;margin-top:30px;margin-bottom:39px}.container.collapsed .nav-items{padding-left:0;transition:all 0.5s}.container.collapsed .footer span{display:none}.container.collapsed .footer .collapse-controls{justify-content:center}.container.collapsed .footer .collapse-controls .icon{margin:0}.container.collapsed .footer .collapse-controls .icon fm-icon-double-chevron-left{display:none}.container.collapsed .footer .collapse-controls .icon fm-icon-double-chevron-right{display:block}@media (max-width: 768px){.container{display:none}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-link{font-size:var(--fm-font-size-16);font-style:var(--fm-font-style-medium);font-weight:400;font-family:var(--fm-font-family-roboto);color:var(--accent-links);text-decoration:underline}.fm-link:hover{color:var(--accent-links-hover);cursor:pointer}.fm-link:focus{color:var(--accent-links);outline:4px solid #00c6c680}.fm-link:focus:not(.focus-visible){outline:none}.fm-link:focus-visible{color:var(--accent-links);outline:4px solid #00c6c680}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-modal{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:var(--fm-zindex-layer-two);display:none}.fm-modal-visible{display:flex;justify-content:center;align-items:center}.fm-modal__backdrop{background:#424145b3 0% 0% no-repeat padding-box;position:absolute;top:0;left:0;width:100vw;height:100vh;user-select:none;z-index:var(--fm-zindex-layer-three)}.fm-modal__content-container{position:absolute;padding:24px 24px 32px 24px;z-index:var(--fm-zindex-layer-three);max-height:97vh;max-width:812px;background:var(--neutral-white) 0% 0% no-repeat padding-box;margin:0 auto}.fm-modal__content-container__content{font-family:'Roboto';color:var(--neutral-grey-1-text)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".container{width:100%;height:auto;padding-top:48px;display:flex;flex-direction:row;background-color:var(--neutral-grey-4-light-bg);border-bottom:24px solid var(--brand-light)}.container .image-container{flex:3 1 0}.container img{margin-left:50px;max-width:236px;width:auto;height:auto;align-self:start;flex:1 1 auto}.container h5{margin:0}.container .menu-list{width:236px;margin-bottom:48px;flex:2 2 0}.container .menu-list ul{display:block;list-style:none;margin:8px 0 0 0;padding:0}.container .menu-list li{margin:15px 0}.container :focus{outline:none !important}.container hr,.container fm-icon-chevron-down{display:none}.container .spacer{flex:1}@media (max-width: 1180px){.image-container{flex:2 1 0}.image-container img{width:150px}.spacer{display:none}ul{display:block}}@media (max-width: 899px){.container{flex-direction:column;padding:0;height:auto}.container .image-container{width:100%;padding:0 20%;box-sizing:border-box}.container .image-container img{display:block;margin:auto}.container .menu-list{width:100%;box-sizing:border-box;padding:17px;margin:0}.container .menu-list .toggle-menu{cursor:pointer;box-sizing:border-box;display:flex;justify-content:space-between;align-items:center}.container .menu-list .toggle-menu fm-icon-chevron-down{transition:all 0.5s ease-in-out;display:block;color:var(--accent-links)}.container .menu-list :focus{outline:4px solid var(--brand-light) !important}.container .menu-list :focus:not(.focus-visible){outline:none !important}.container .menu-list :focus-visible{outline:4px solid var(--brand-light) !important}.container .menu-list ul{display:none;overflow:hidden}.container .menu-list ul.hidden{max-height:0;transition:max-height 0.5s ease-out}.container .menu-list ul.expanded{max-height:500px;transition:max-height 0.5s ease-in}.container hr{display:block;margin:0;border:0;border-top:1px solid var(--neutral-grey-3-borders)}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-pill{display:inline-flex;align-items:center;height:19px;width:auto;background:var(--neutral-grey-3-borders) 0% 0% no-repeat padding-box;border-radius:14px;text-align:left;font:var(--fm-font-style-normal) normal var(--fm-font-weight-medium) var(--fm-font-size-14)/var(--fm-line-spacing-24) var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);padding:4px 12px}.fm-pill__no-right-padding{padding-right:0}.fm-pill .fm-pill__label{justify-self:flex-start;font:inherit;white-space:nowrap}.fm-pill .fm-pill__close-icon{display:flex;justify-content:center;align-items:center;justify-self:flex-end;height:27px;width:27px;background:transparent;border-bottom-right-radius:14px;border-top-right-radius:14px;cursor:pointer}.fm-pill .fm-pill__close-icon:hover,.fm-pill .fm-pill__close-icon:focus{background:var(--accent-links-hover) 0% 0% no-repeat padding-box;color:var(--neutral-white)}.fm-pill .fm-pill__close-icon:focus{outline:4px solid #00c6c680}.fm-pill .fm-pill__close-icon:focus:not(.focus-visible){outline:none}.fm-pill .fm-pill__close-icon:focus-visible{outline:4px solid var(--brand-light)}.fm-pill .fm-pill__close-icon .material-icons{font-family:'Material Icons';font-size:16px;user-select:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-banner .fm-banner__icon-box{background:var(--notification--success) 0% 0% no-repeat padding-box}@media (max-width: 600px){.fm-banner-mobile-bar{background-color:var(--notification--success)}.fm-banner .fm-banner__icon-box{background-color:var(--neutral-white);color:var(--notification--success)}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{background:var(--neutral-white) 0% 0% no-repeat padding-box;box-shadow:0px 1px 3px #22204633;border-radius:8px;border:none;color:var(--accent-links)}.fm-button-disabled{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box;color:var(--neutral-grey-2-lighter-text);box-shadow:none}.fm-button-loading{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button .fm-icon{color:pink;fill:var(--accent-links)}.fm-button:hover:not(.fm-button-disabled){color:var(--accent-links-hover);background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button:focus{box-shadow:none;background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button:active{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{background:none;border:none;box-shadow:none;color:var(--accent-links);min-width:80px;height:36px}.fm-button.fm-button-tertiary-icon:hover{color:var(--accent-links-hover);background:none;border:none;box-shadow:none}.fm-button:focus{background:none;box-shadow:none}.fm-button:active{background:none;border:none;box-shadow:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-button{background:var(--neutral-white) 0% 0% no-repeat padding-box;box-shadow:0px 1px 3px #22204633;border-radius:8px;border:none;color:var(--accent-links);min-width:80px;height:36px;padding:7px 16px}.fm-button-disabled{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box;color:var(--neutral-grey-2-lighter-text);box-shadow:none}.fm-button-loading{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button .fm-icon{color:pink;fill:var(--accent-links)}.fm-button:hover:not(.fm-button-disabled){color:var(--accent-links-hover);background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}.fm-button:focus{box-shadow:none}.fm-button:active{background:var(--neutral-grey-4-light-bg) 0% 0% no-repeat padding-box}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-more-menu{position:relative;height:100%}.fm-more-menu.hide{display:none}.fm-more-menu .activator-container{display:flex;align-items:center;height:100%}.fm-more-menu .activator-container .activator{font:var(--fm-font-style-normal) normal bold var(--fm-font-size-16)/var(--fm-line-spacing-24) var(--fm-font-family-roboto);color:var(--neutral-grey-1-text);text-align:left;text-transform:var(--fm-text-transform-uppercase);white-space:nowrap;padding:0 24px;cursor:pointer}.fm-more-menu .activator-container .activator:focus{outline:4px solid var(--brand-light)}.fm-more-menu .activator-container .activator:focus:not(.focus-visible){outline:none}.fm-more-menu .activator-container .activator:focus-visible{outline:4px solid var(--brand-light)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-user-menu{position:relative}.fm-user-menu.hide{display:none}.fm-user-menu .activator{display:flex;justify-content:space-evenly;align-items:center;width:104px;height:48px;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);border-radius:8px}.fm-user-menu .activator:focus{outline:4px solid var(--brand-light)}.fm-user-menu .activator:focus:not(.focus-visible){outline:none}.fm-user-menu .activator:focus-visible{outline:4px solid var(--brand-light)}.fm-user-menu .activator__user-initials{display:flex;justify-content:center;align-items:center;width:32px;height:32px;background:var(--brand-dark) 0% 0% no-repeat padding-box;border-radius:50%}.fm-user-menu .activator__user-initials__text{font:var(--fm-font-style-normal) normal var(--fm-font-weight-medium) var(--fm-font-size-16)/var(--fm-line-spacing-16) var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-white);text-align:left}.fm-user-menu .activator__icon-container{display:flex;justify-content:center;align-items:center;width:24px;height:24px}.fm-user-menu .activator__icon-container__chevron-icon{font-family:'Material Icons';font-size:24px;color:var(--neutral-grey-1-text)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-top-nav{display:flex;align-items:center;width:100%;height:80px;background:#FFFFFF58 0% 0% no-repeat padding-box;box-shadow:0px 1px 8px #22204633}.fm-top-nav__products{display:inline-flex;justify-content:flex-start;align-items:center;padding:0 24px;height:100%}.fm-top-nav__products__item{height:100%;padding:0px 0px;box-sizing:border-box;border-top:8px solid transparent;user-select:none}.fm-top-nav__products__item.nav-item-more-menu{display:none}.fm-top-nav__products__item.active{border-top:8px solid var(--brand-light)}.fm-top-nav__products__item.active.border-color-override{border-color:var(--accent-links-hover)}.fm-top-nav__products__item .nav-link{display:flex;align-items:center;text-decoration:none;height:100%}.fm-top-nav__products__item .nav-link:focus{outline:4px solid var(--brand-light)}.fm-top-nav__products__item .nav-link:focus:not(.focus-visible){outline:none}.fm-top-nav__products__item .nav-link:focus-visible{outline:4px solid var(--brand-light)}.fm-top-nav__products__item .nav-image{height:100%;padding:0 24px}.fm-top-nav__products__item .logo-futuri{height:48px}.fm-top-nav__products__item .logo-topicpulse,.fm-top-nav__products__item .logo-prepplus,.fm-top-nav__products__item .logo-post,.fm-top-nav__products__item .logo-topline{height:60px}.fm-top-nav__products__item .logo-all-products,.fm-top-nav__products__item .logo-more-products{font:var(--fm-font-style-normal) normal bold var(--fm-font-size-16)/var(--fm-line-spacing-24) var(--fm-font-family-roboto);color:var(--neutral-grey-1-text);text-align:left;text-transform:var(--fm-text-transform-uppercase);white-space:nowrap;padding:0 24px}.fm-top-nav__right{display:inline-flex;align-items:center;height:100%;justify-self:flex-end;margin-left:auto;padding:0 0}.fm-top-nav__right__item{display:flex;align-items:center;height:100%;padding:0px 24px;box-sizing:border-box;user-select:none}.fm-top-nav__right__item .beamer-container{height:32px;width:57px}.fm-top-nav__right__item.nav-item-mobile-menu{display:none}@media screen and (max-width: 1280px){.fm-top-nav__products__item:not(.active){display:none}.fm-top-nav__products__item.nav-item-futuri{display:block}.fm-top-nav__products__item.nav-item-all-products{display:none}.fm-top-nav__products__item.nav-item-more-menu{display:block}}@media screen and (max-width: 815px){.fm-top-nav{height:64px}.fm-top-nav__products{padding:0 16px}.fm-top-nav__products__item{border-top:none}.fm-top-nav__products__item.active{border-top:none}.fm-top-nav__products__item.nav-item-all-products{display:none}.fm-top-nav__products__item.nav-item-more-menu{display:none}.fm-top-nav__products__item .nav-image{height:100%;padding:0 10px}.fm-top-nav__products__item .logo-futuri{height:32px}.fm-top-nav__products__item .logo-topicpulse,.fm-top-nav__products__item .logo-prepplus,.fm-top-nav__products__item .logo-post,.fm-top-nav__products__item .logo-topline{height:48px}.fm-top-nav__right__item:not(.nav-item-mobile-menu){display:none}.fm-top-nav__right__item.nav-item-mobile-menu{display:flex;justify-content:center;align-items:center;height:64px;width:64px}.fm-top-nav__right__item.nav-item-mobile-menu .mobile-menu-activator{font-family:'Material Icons';font-size:24px;color:var(--accent-links);user-select:none;cursor:pointer}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-banner .fm-banner__icon-box{background:var(--notification--warning) 0% 0% no-repeat padding-box}@media (max-width: 600px){.fm-banner-mobile-bar{background-color:var(--notification--warning)}.fm-banner .fm-banner__icon-box{background-color:var(--neutral-white);color:var(--notification--warning)}}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-modal-action-row{display:flex;flex-direction:row;justify-content:flex-end;margin-top:32px}.fm-modal-action-row .fm-button-tertiary{margin-right:24px}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".material-icons{font-family:'Material Icons';font-size:var(--fm-font-size-24)}.fm-modal-control-row{display:flex;justify-content:flex-end;position:absolute;top:0;right:0;padding:16px}.fm-modal-control-row .fm-modal-control-row__button{border:none;background:none;color:var(--neutral-grey-1-text)}.fm-modal-control-row .fm-modal-control-row__button:hover{cursor:pointer}.fm-modal-control-row .fm-modal-control-row__button:focus{outline:4px solid #00c6c680}.fm-modal-control-row .fm-modal-control-row__button:focus:not(.focus-visible){outline:none}.fm-modal-control-row .fm-modal-control-row__button:focus-visible{outline:4px solid #00c6c680}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-body{display:inline-block;margin:0;padding:0;font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);font-size:20px}.fm-body ::slotted(a){color:var(--accent-links)}.fm-body-large{line-height:28px;letter-spacing:var(--fm-character-spacing-0)}.fm-body-medium{font-size:16px;letter-spacing:var(--fm-character-spacing-0);line-height:24px}.fm-body-disclaimer{font-size:14px;color:var(--neutral-grey-2-lighter-text);line-height:21px;letter-spacing:var(--fm-character-spacing-0)}.fm-body-disclaimer ::slotted(b){font-weight:400}.fm-body-button-text{font-size:16px;color:var(--accent-links);line-height:24px;font-weight:500;letter-spacing:var(--fm-character-spacing-0-38)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-input{display:inline-flex;flex-direction:column;width:100%}.fm-input .fm-input__input{background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);background:#ffffff 0% 0% no-repeat padding-box;border:2px solid #dadae0;border-radius:8px;opacity:1;padding:14px 16px;font-size:16px}.fm-input .fm-input__input::placeholder{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-2-lighter-text);text-align:left;letter-spacing:0px;opacity:1}.fm-input:hover:not(.fm-input-error) .fm-input__input{border:2px solid var(--neutral-grey-2-lighter-text)}.fm-input .fm-input__input:focus{outline:4px solid #00c6c680;border:2px solid var(--neutral-grey-1-text)}.fm-input__label-row{margin-bottom:8px;display:inline-flex;width:100%;justify-content:space-between}.fm-input .fm-input__label-row .fm-input__label{font-family:var(--fm-font-family-roboto);font-weight:500;letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);text-align:left;font:Medium 16px/24px Roboto;letter-spacing:0px;opacity:1}.fm-input .fm-input__label-row .fm-input__assistive-link__button{border:none;background:none}.fm-input .fm-input__label-row .fm-input__assistive-link__button :hover{cursor:pointer}.fm-input .fm-input__label-row .fm-input__assistive-link__button:focus{outline:4px solid #00c6c680}.fm-input .fm-input__label-row .fm-input__assistive-link__label{text-decoration:var(--fm-decoration-underline);letter-spacing:var(--fm-character-spacing-0);color:var(--accent-links);text-align:right;text-decoration:underline;letter-spacing:0px;font-family:var(--fm-font-family-roboto);opacity:1;font-size:14px}.fm-input .fm-input__assistive-row{margin-top:4px}.fm-input .fm-input__assistive-row .fm-input__assistive-row__assistive-text{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-2-lighter-text);text-align:left;letter-spacing:0px;color:#6e6e7a;opacity:1;font-size:14px}.fm-input-error .fm-input__input{border:2px solid var(--notification--error)}.fm-input-error .fm-input__error-row{display:flex;align-items:center}.fm-input-error .fm-input__error-row .fm-input__error-icon{padding-right:6px;color:var(--notification--error)}.fm-input-error .fm-input__error-row .fm-input__error-row__label{letter-spacing:var(--fm-character-spacing-0);color:var(--notification--error);text-align:left;letter-spacing:0px;opacity:1;font-size:14px;font-family:var(--fm-font-family-roboto)}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "*{box-sizing:border-box}.fm-search-bar{display:inline-flex;flex-direction:column;box-sizing:border-box;width:100%}.fm-search-bar .input-wrap{width:100%;box-sizing:border-box;position:relative}.fm-search-bar .input-wrap .fm-search-bar__input{box-sizing:border-box;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);background:#ffffff 0% 0% no-repeat padding-box;border:2px solid #dadae0;border-radius:8px;opacity:1;padding:14px 0px 13px 56px;font-size:16px;width:100%}.fm-search-bar .input-wrap .fm-search-bar__icon{position:absolute;top:25%;left:0;color:var(--neutral-grey-1-text);margin-left:18px}.fm-search-bar .fm-search-bar__button{position:absolute;top:0;right:0;height:40px;margin:4px;width:102px;background:var(--accent-links) 0% 0% no-repeat padding-box;border-radius:0px 4px 4px 0px;opacity:1;border:none}.fm-search-bar .fm-search-bar__button .search-button-label{font-size:16px;font-weight:500;letter-spacing:var(--fm-character-spacing-0-38);color:var(--neutral-white);text-align:center;font:Medium 16px/24px Roboto;letter-spacing:0.38px;color:#ffffff;opacity:1;font-family:var(--fm-font-family-roboto)}.fm-search-bar .fm-search-bar__button:focus{outline:4px solid #00c6c680}.fm-search-bar .fm-search-bar__button:focus:not(.focus-visible){outline:none}.fm-search-bar .fm-search-bar__button:focus-visible{box-shadow:none;outline:4px solid #00c6c680}.fm-search-bar .fm-search-bar__button:hover{cursor:pointer}.fm-search-bar .input-wrap .fm-search-bar__input::placeholder{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-2-lighter-text);text-align:left;letter-spacing:0px;opacity:1}.fm-search-bar .input-wrap .fm-search-bar__input:hover{border:2px solid var(--neutral-grey-2-lighter-text)}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}.fm-search-bar .input-wrap .fm-search-bar__input:focus{outline:4px solid #00c6c680}.fm-search-bar .input-wrap .fm-search-bar__input:focus:not(.focus-visible){outline:none}.fm-search-bar .input-wrap .fm-search-bar__input:focus-visible{outline:4px solid #00c6c680}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-select{width:100%}.fm-select .select-wrapper{position:relative}.fm-select .fm-select__input{display:block;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);border-radius:8px;opacity:1;width:100%;padding:14px 35px 14px 16px;font-size:16px;height:52px;text-overflow:ellipsis;-moz-appearance:none;-webkit-appearance:none}.fm-select .fm-select__input:hover{cursor:pointer;border:2px solid var(--neutral-grey-1-text)}.fm-select .fm-select__input:focus{outline:4px solid #00c6c680}.fm-select .fm-select__input:focus:not(.focus-visible){outline:none}.fm-select .fm-select__input:focus-visible{box-shadow:none;outline:4px solid #00c6c680}.fm-select .fm-select__input .fm-select__placeholder{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);text-align:left;font:Regular 16px/24px Roboto;letter-spacing:0px;color:#222046;opacity:1}.material-icons{font-family:'Material Icons';font-size:26px;position:absolute;pointer-events:none;top:22%;right:0;margin-right:19px}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-field-label{margin-bottom:8px;display:inline-flex;width:100%;justify-content:space-between}.fm-field-label .fm-field-label__label{font-family:var(--fm-font-family-roboto);font-weight:500;letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);text-align:left;font:Medium 16px/24px Roboto;letter-spacing:0px;opacity:1}.fm-field-label__assistive-link__button{border:none;background:none}.fm-field-label__assistive-link__button :hover{cursor:pointer}.fm-field-label__assistive-link__button:focus{outline:4px solid #00c6c680}.fm-field-label__assistive-link__button:focus:not(.focus-visible){outline:none}.fm-field-label__assistive-link__button:focus-visible{outline:4px solid #00c6c680}.fm-field-label__assistive-link__button .fm-field-label__assistive-link__label{text-decoration:var(--fm-decoration-underline);letter-spacing:var(--fm-character-spacing-0);color:var(--accent-links);text-align:right;text-decoration:underline;letter-spacing:0px;font-family:var(--fm-font-family-roboto);opacity:1;font-size:14px}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-assistive{margin-top:4px}.fm-assistive .fm-assistive__text-row .fm-assistive__assistive-text{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-2-lighter-text);text-align:left;letter-spacing:0px;color:#6e6e7a;opacity:1;font-size:14px}.fm-assistive-error .fm-assistive__error-row{display:flex;align-items:center}.fm-assistive-error .fm-assistive__error-row .fm-assistive__error-icon{padding-right:6px;color:var(--notification--error)}.fm-assistive-error .fm-assistive__error-row .fm-assistive__error-label{letter-spacing:var(--fm-character-spacing-0);color:var(--notification--error);text-align:left;letter-spacing:0px;opacity:1;font-size:14px;font-family:var(--fm-font-family-roboto)}.fm-assistive__error-row__hide{visibility:hidden}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-time-picker-container{display:inline-flex;flex-direction:column;width:100%}.fm-date-picker{background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);border-radius:8px;opacity:1;padding:0px 16px;box-sizing:border-box;font-family:var(--fm-font-family-roboto);font-size:16px;color:var(--neutral-grey-1-text);height:48px;width:100%}.fm-date-picker:active{border-color:var(--neutral-grey-1-text)}.fm-date-picker:focus{outline:4px solid #00c6c680;border-color:var(--neutral-grey-1-text)}.fm-date-picker:focus:not(.focus-visible){outline:none}.fm-date-picker:focus-visible{box-shadow:none;outline:4px solid #00c6c680}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-time-picker-container{display:inline-flex;flex-direction:column;width:100%}.fm-time-picker{box-sizing:border-box;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-3-borders);border-radius:8px;opacity:1;padding:0px 16px;font-family:var(--fm-font-family-roboto);font-size:16px;color:var(--neutral-grey-1-text);height:48px;width:100%}.fm-time-picker::before{content:attr(data-label);margin-right:10px}.fm-time-picker::-webkit-calendar-picker-indicator{-webkit-appearance:none}.fm-time-picker:hover{cursor:pointer}.fm-time-picker:active{border-color:var(--neutral-grey-1-text)}.material-icons{font-family:'Material Icons';font-size:26px;user-select:none}.fm-time-picker:focus{outline:4px solid #00c6c680;border-color:var(--neutral-grey-1-text)}.fm-time-picker:focus:not(.focus-visible){outline:none}.fm-time-picker:focus-visible{box-shadow:none;outline:4px solid #00c6c680}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-table{font-family:var(--fm-font-family-roboto);border-collapse:collapse;width:100%}.fm-table__checkbox{display:inline-block;background:var(--neutral-white) 0% 0% no-repeat padding-box;border:2px solid var(--neutral-grey-1-text);border-radius:4px;opacity:1;width:24px;height:24px;margin-right:18px}.fm-table__checkbox-header{margin-right:64px}.fm-table__header{font-family:var(--fm-font-family-roboto);letter-spacing:var(--fm-character-spacing-0);color:var(--neutral-grey-1-text);text-align:left;letter-spacing:0px;opacity:1;height:56px;background-color:#ffffff00}.fm-table__header th .fm-table-header__drop-down{font-size:28px;color:var(--neutral-grey-1-text)}.fm-table__header th .fm-table__header-highlight{color:#16c9a5}.fm-table__header th:hover{cursor:pointer}.fm-table__header th:focus{outline:4px solid #00c6c680}.fm-table__header th:focus:not(.focus-visible){outline:none}.fm-table__header th:focus-visible{box-shadow:none;outline:4px solid #00c6c680}.checkbox-checked{width:25px;height:25px;background:#00856a;border-radius:4px;display:flex;justify-content:center;align-items:center;margin-right:16px;margin-left:5px}.checkbox-checked .material-icons{color:#fff;user-select:none;pointer-events:none}.material-icons{font-family:'Material Icons'}.fm-table__row-playing{background-color:#f5f5f5}.fm-table__row:hover{box-shadow:0px 1px 7px #22204633}.fm-table__row:nth-of-type(odd){background-color:#f5f5f5}th,td{padding-bottom:15px;padding-top:15px;text-align:left;border-bottom:1px solid var(--neutral-grey-3-borders);vertical-align:center}.center{display:flex;align-items:center}.action-buttons{margin-left:35px;display:inline-flex;height:auto}.action-buttons .action-button{border:none;background:none}.action-buttons .action-button :hover{cursor:pointer}.action-buttons .action-button span{font-size:24px}.action-buttons .action-two{margin-left:19px}.fm-table__play-button{border:none;background-color:var(--accent-links);color:var(--neutral-white);width:32px;height:32px;border-radius:28px;font-size:20px;margin-right:18px}.fm-table__play-button-playing{background-color:#00856a}.fm-table__play-button:hover{cursor:pointer}.fm-table__play-button:focus{outline:4px solid #00c6c680}.fm-table__play-button:focus:not(.focus-visible){outline:none}.fm-table__play-button:focus-visible{box-shadow:none;outline:4px solid #00c6c680}tr{background:var(--neutral-white) 0% 0% no-repeat padding-box}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(1);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fm-drawer{width:0px;opacity:0;position:fixed;top:0;right:0;height:100vh;z-index:var(--layer-three);background:var(--neutral-white) 0% 0% no-repeat padding-box;transition:opacity 300ms ease-out}.fm-drawer-visible{opacity:1}.fm-drawer__backdrop{background:#424145b3 0% 0% no-repeat padding-box;display:none}.fm-drawer__backdrop-visible{display:block;position:fixed;top:0;left:0;width:100vw;height:100vh;user-select:none;z-index:var(--layer-two)}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Table", function() { return /* reexport */ table_Table; });
__webpack_require__.d(__webpack_exports__, "Banner", function() { return /* reexport */ banner_Banner; });
__webpack_require__.d(__webpack_exports__, "Body", function() { return /* reexport */ body_Body; });
__webpack_require__.d(__webpack_exports__, "Button", function() { return /* reexport */ button_Button; });
__webpack_require__.d(__webpack_exports__, "ButtonFloatingAction", function() { return /* reexport */ floatingAction_ButtonFloatingAction; });
__webpack_require__.d(__webpack_exports__, "ButtonPrimary", function() { return /* reexport */ primary_ButtonPrimary; });
__webpack_require__.d(__webpack_exports__, "ButtonSecondary", function() { return /* reexport */ secondary_ButtonSecondary; });
__webpack_require__.d(__webpack_exports__, "DatePicker", function() { return /* reexport */ datePicker_DatePicker; });
__webpack_require__.d(__webpack_exports__, "Card", function() { return /* reexport */ cards_Card; });
__webpack_require__.d(__webpack_exports__, "CardActionBar", function() { return /* reexport */ actionBar_CardActionBar; });
__webpack_require__.d(__webpack_exports__, "CardLayout", function() { return /* reexport */ cardLayout_CardLayout; });
__webpack_require__.d(__webpack_exports__, "ClusterSwitcherBar", function() { return /* reexport */ clusterSwitcherBar_ClusterSwitcherBar; });
__webpack_require__.d(__webpack_exports__, "ErrorBanner", function() { return /* reexport */ error_ErrorBanner; });
__webpack_require__.d(__webpack_exports__, "FieldAssistive", function() { return /* reexport */ assistive_FieldAssistive; });
__webpack_require__.d(__webpack_exports__, "FieldLabel", function() { return /* reexport */ label_FieldLabel; });
__webpack_require__.d(__webpack_exports__, "Heading", function() { return /* reexport */ heading_Heading; });
__webpack_require__.d(__webpack_exports__, "InfoBanner", function() { return /* reexport */ info_InfoBanner; });
__webpack_require__.d(__webpack_exports__, "Input", function() { return /* reexport */ input_Input; });
__webpack_require__.d(__webpack_exports__, "InlineMenu", function() { return /* reexport */ inlineMenu_InlineMenu; });
__webpack_require__.d(__webpack_exports__, "LeftNavigation", function() { return /* reexport */ leftNavigation_LeftNavigation; });
__webpack_require__.d(__webpack_exports__, "Link", function() { return /* reexport */ components_link_Link; });
__webpack_require__.d(__webpack_exports__, "Modal", function() { return /* reexport */ modal_Modal; });
__webpack_require__.d(__webpack_exports__, "ModalActionRow", function() { return /* reexport */ actionRow_ModalActionRow; });
__webpack_require__.d(__webpack_exports__, "ModalControlRow", function() { return /* reexport */ controlRow_ModalControlRow; });
__webpack_require__.d(__webpack_exports__, "SearchBar", function() { return /* reexport */ searchBar_SearchBar; });
__webpack_require__.d(__webpack_exports__, "Select", function() { return /* reexport */ select_Select; });
__webpack_require__.d(__webpack_exports__, "NavFooter", function() { return /* reexport */ footer_NavFooter; });
__webpack_require__.d(__webpack_exports__, "Pill", function() { return /* reexport */ pill_Pill; });
__webpack_require__.d(__webpack_exports__, "SuccessBanner", function() { return /* reexport */ success_SuccessBanner; });
__webpack_require__.d(__webpack_exports__, "TertiaryButton", function() { return /* reexport */ tertiary_TertiaryButton; });
__webpack_require__.d(__webpack_exports__, "TertiaryButtonIcon", function() { return /* reexport */ tertiaryIcon_TertiaryButtonIcon; });
__webpack_require__.d(__webpack_exports__, "TertiaryButtonSmall", function() { return /* reexport */ tertiarySmall_TertiaryButtonSmall; });
__webpack_require__.d(__webpack_exports__, "TimePicker", function() { return /* reexport */ timePicker_TimePicker; });
__webpack_require__.d(__webpack_exports__, "WarningBanner", function() { return /* reexport */ warning_WarningBanner; });
__webpack_require__.d(__webpack_exports__, "Drawer", function() { return /* reexport */ drawer_Drawer; });
__webpack_require__.d(__webpack_exports__, "TopNavigation", function() { return /* reexport */ topNavigation_TopNavigation; });
__webpack_require__.d(__webpack_exports__, "MenuContent", function() { return /* reexport */ menuContent_MenuContent; });
__webpack_require__.d(__webpack_exports__, "MoreMenu", function() { return /* reexport */ moreMenu_MoreMenu; });
__webpack_require__.d(__webpack_exports__, "UserMenu", function() { return /* reexport */ userMenu_UserMenu; });

// CONCATENATED MODULE: ./node_modules/lit-html/lib/dom.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * True if the custom elements polyfill is in use.
 */
const isCEPolyfill = typeof window !== 'undefined' &&
    window.customElements != null &&
    window.customElements.polyfillWrapFlushCallback !==
        undefined;
/**
 * Reparents nodes, starting from `start` (inclusive) to `end` (exclusive),
 * into another container (could be the same container), before `before`. If
 * `before` is null, it appends the nodes to the container.
 */
const reparentNodes = (container, start, end = null, before = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
/**
 * Removes nodes, starting from `start` (inclusive) to `end` (exclusive), from
 * `container`.
 */
const removeNodes = (container, start, end = null) => {
    while (start !== end) {
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};
//# sourceMappingURL=dom.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/template.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */
const marker = `{{lit-${String(Math.random()).slice(2)}}}`;
/**
 * An expression marker used text-positions, multi-binding attributes, and
 * attributes with markup-like text values.
 */
const nodeMarker = `<!--${marker}-->`;
const markerRegex = new RegExp(`${marker}|${nodeMarker}`);
/**
 * Suffix appended to all bound attribute names.
 */
const boundAttributeSuffix = '$lit$';
/**
 * An updatable Template that tracks the location of dynamic parts.
 */
class Template {
    constructor(result, element) {
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings, values: { length } } = result;
        while (partIndex < length) {
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for (let i = 0; i < length; i++) {
                        if (endsWith(attributes[i].name, boundAttributeSuffix)) {
                            count++;
                        }
                    }
                    while (count-- > 0) {
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = lastAttributeNameRegex.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + boundAttributeSuffix;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split(markerRegex);
                        this.parts.push({ type: 'attribute', index, name, strings: statics });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            }
            else if (node.nodeType === 3 /* Node.TEXT_NODE */) {
                const data = node.data;
                if (data.indexOf(marker) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split(markerRegex);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for (let i = 0; i < lastIndex; i++) {
                        let insert;
                        let s = strings[i];
                        if (s === '') {
                            insert = createMarker();
                        }
                        else {
                            const match = lastAttributeNameRegex.exec(s);
                            if (match !== null && endsWith(match[2], boundAttributeSuffix)) {
                                s = s.slice(0, match.index) + match[1] +
                                    match[2].slice(0, -boundAttributeSuffix.length) + match[3];
                            }
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({ type: 'node', index: ++index });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === '') {
                        parent.insertBefore(createMarker(), node);
                        nodesToRemove.push(node);
                    }
                    else {
                        node.data = strings[lastIndex];
                    }
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            }
            else if (node.nodeType === 8 /* Node.COMMENT_NODE */) {
                if (node.data === marker) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore(createMarker(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({ type: 'node', index });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) {
                        node.data = '';
                    }
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                }
                else {
                    let i = -1;
                    while ((i = node.data.indexOf(marker, i + 1)) !== -1) {
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({ type: 'node', index: -1 });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove) {
            n.parentNode.removeChild(n);
        }
    }
}
const endsWith = (str, suffix) => {
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const isTemplatePartActive = (part) => part.index !== -1;
// Allows `document.createComment('')` to be renamed for a
// small manual size-savings.
const createMarker = () => document.createComment('');
/**
 * This regex extracts the attribute name preceding an attribute-position
 * expression. It does this by matching the syntax allowed for attributes
 * against the string literal directly preceding the expression, assuming that
 * the expression is in an attribute-value position.
 *
 * See attributes in the HTML spec:
 * https://www.w3.org/TR/html5/syntax.html#elements-attributes
 *
 * " \x09\x0a\x0c\x0d" are HTML space characters:
 * https://www.w3.org/TR/html5/infrastructure.html#space-characters
 *
 * "\0-\x1F\x7F-\x9F" are Unicode control characters, which includes every
 * space character except " ".
 *
 * So an attribute is:
 *  * The name: any character except a control character, space character, ('),
 *    ("), ">", "=", or "/"
 *  * Followed by zero or more space characters
 *  * Followed by "="
 *  * Followed by zero or more space characters
 *  * Followed by:
 *    * Any character except space, ('), ("), "<", ">", "=", (`), or
 *    * (") then any non-("), or
 *    * (') then any non-(')
 */
const lastAttributeNameRegex = 
// eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
//# sourceMappingURL=template.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/modify-template.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module shady-render
 */

const walkerNodeFilter = 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */;
/**
 * Removes the list of nodes from a Template safely. In addition to removing
 * nodes from the Template, the Template part indices are updated to match
 * the mutated Template DOM.
 *
 * As the template is walked the removal state is tracked and
 * part indices are adjusted as needed.
 *
 * div
 *   div#1 (remove) <-- start removing (removing node is div#1)
 *     div
 *       div#2 (remove)  <-- continue removing (removing node is still div#1)
 *         div
 * div <-- stop removing since previous sibling is the removing node (div#1,
 * removed 4 nodes)
 */
function removeNodesFromTemplate(template, nodesToRemove) {
    const { element: { content }, parts } = template;
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let part = parts[partIndex];
    let nodeIndex = -1;
    let removeCount = 0;
    const nodesToRemoveInTemplate = [];
    let currentRemovingNode = null;
    while (walker.nextNode()) {
        nodeIndex++;
        const node = walker.currentNode;
        // End removal if stepped past the removing node
        if (node.previousSibling === currentRemovingNode) {
            currentRemovingNode = null;
        }
        // A node to remove was found in the template
        if (nodesToRemove.has(node)) {
            nodesToRemoveInTemplate.push(node);
            // Track node we're removing
            if (currentRemovingNode === null) {
                currentRemovingNode = node;
            }
        }
        // When removing, increment count by which to adjust subsequent part indices
        if (currentRemovingNode !== null) {
            removeCount++;
        }
        while (part !== undefined && part.index === nodeIndex) {
            // If part is in a removed node deactivate it by setting index to -1 or
            // adjust the index as needed.
            part.index = currentRemovingNode !== null ? -1 : part.index - removeCount;
            // go to the next active part.
            partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
            part = parts[partIndex];
        }
    }
    nodesToRemoveInTemplate.forEach((n) => n.parentNode.removeChild(n));
}
const countNodes = (node) => {
    let count = (node.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */) ? 0 : 1;
    const walker = document.createTreeWalker(node, walkerNodeFilter, null, false);
    while (walker.nextNode()) {
        count++;
    }
    return count;
};
const nextActiveIndexInTemplateParts = (parts, startIndex = -1) => {
    for (let i = startIndex + 1; i < parts.length; i++) {
        const part = parts[i];
        if (isTemplatePartActive(part)) {
            return i;
        }
    }
    return -1;
};
/**
 * Inserts the given node into the Template, optionally before the given
 * refNode. In addition to inserting the node into the Template, the Template
 * part indices are updated to match the mutated Template DOM.
 */
function insertNodeIntoTemplate(template, node, refNode = null) {
    const { element: { content }, parts } = template;
    // If there's no refNode, then put node at end of template.
    // No part indices need to be shifted in this case.
    if (refNode === null || refNode === undefined) {
        content.appendChild(node);
        return;
    }
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let insertCount = 0;
    let walkerIndex = -1;
    while (walker.nextNode()) {
        walkerIndex++;
        const walkerNode = walker.currentNode;
        if (walkerNode === refNode) {
            insertCount = countNodes(node);
            refNode.parentNode.insertBefore(node, refNode);
        }
        while (partIndex !== -1 && parts[partIndex].index === walkerIndex) {
            // If we've inserted the node, simply adjust all subsequent parts
            if (insertCount > 0) {
                while (partIndex !== -1) {
                    parts[partIndex].index += insertCount;
                    partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
                }
                return;
            }
            partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
        }
    }
}
//# sourceMappingURL=modify-template.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/directive.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const directives = new WeakMap();
/**
 * Brands a function as a directive factory function so that lit-html will call
 * the function during template rendering, rather than passing as a value.
 *
 * A _directive_ is a function that takes a Part as an argument. It has the
 * signature: `(part: Part) => void`.
 *
 * A directive _factory_ is a function that takes arguments for data and
 * configuration and returns a directive. Users of directive usually refer to
 * the directive factory as the directive. For example, "The repeat directive".
 *
 * Usually a template author will invoke a directive factory in their template
 * with relevant arguments, which will then return a directive function.
 *
 * Here's an example of using the `repeat()` directive factory that takes an
 * array and a function to render an item:
 *
 * ```js
 * html`<ul><${repeat(items, (item) => html`<li>${item}</li>`)}</ul>`
 * ```
 *
 * When `repeat` is invoked, it returns a directive function that closes over
 * `items` and the template function. When the outer template is rendered, the
 * return directive function is called with the Part for the expression.
 * `repeat` then performs it's custom logic to render multiple items.
 *
 * @param f The directive factory function. Must be a function that returns a
 * function of the signature `(part: Part) => void`. The returned function will
 * be called with the part object.
 *
 * @example
 *
 * import {directive, html} from 'lit-html';
 *
 * const immutable = directive((v) => (part) => {
 *   if (part.value !== v) {
 *     part.setValue(v)
 *   }
 * });
 */
const directive_directive = (f) => ((...args) => {
    const d = f(...args);
    directives.set(d, true);
    return d;
});
const isDirective = (o) => {
    return typeof o === 'function' && directives.has(o);
};
//# sourceMappingURL=directive.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/part.js
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */
const noChange = {};
/**
 * A sentinel value that signals a NodePart to fully clear its content.
 */
const nothing = {};
//# sourceMappingURL=part.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/template-instance.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module lit-html
 */


/**
 * An instance of a `Template` that can be attached to the DOM and updated
 * with new values.
 */
class template_instance_TemplateInstance {
    constructor(template, processor, options) {
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts) {
            if (part !== undefined) {
                part.setValue(values[i]);
            }
            i++;
        }
        for (const part of this.__parts) {
            if (part !== undefined) {
                part.commit();
            }
        }
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = isCEPolyfill ?
            this.template.element.content.cloneNode(true) :
            document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while (partIndex < parts.length) {
            part = parts[partIndex];
            if (!isTemplatePartActive(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while (nodeIndex < part.index) {
                nodeIndex++;
                if (node.nodeName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === 'node') {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            }
            else {
                this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            }
            partIndex++;
        }
        if (isCEPolyfill) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}
//# sourceMappingURL=template-instance.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/template-result.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module lit-html
 */


const commentMarker = ` ${marker} `;
/**
 * The return type of `html`, which holds a Template and the values from
 * interpolated expressions.
 */
class template_result_TemplateResult {
    constructor(strings, values, type, processor) {
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */
    getHTML() {
        const l = this.strings.length - 1;
        let html = '';
        let isCommentBinding = false;
        for (let i = 0; i < l; i++) {
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf('<!--');
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) &&
                s.indexOf('-->', commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = lastAttributeNameRegex.exec(s);
            if (attributeMatch === null) {
                // We're only in this branch if we don't have a attribute-like
                // preceding sequence. For comments, this guards against unusual
                // attribute values like <div foo="<!--${'bar'}">. Cases like
                // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
                // below.
                html += s + (isCommentBinding ? commentMarker : nodeMarker);
            }
            else {
                // For attributes we use just a marker sentinel, and also append a
                // $lit$ suffix to the name to opt-out of attribute-specific parsing
                // that IE and Edge do for style and certain SVG attributes.
                html += s.substr(0, attributeMatch.index) + attributeMatch[1] +
                    attributeMatch[2] + boundAttributeSuffix + attributeMatch[3] +
                    marker;
            }
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement('template');
        template.innerHTML = this.getHTML();
        return template;
    }
}
/**
 * A TemplateResult for SVG fragments.
 *
 * This class wraps HTML in an `<svg>` tag in order to parse its contents in the
 * SVG namespace, then modifies the template to remove the `<svg>` tag so that
 * clones only container the original fragment.
 */
class template_result_SVGTemplateResult extends template_result_TemplateResult {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        reparentNodes(content, svgElement.firstChild);
        return template;
    }
}
//# sourceMappingURL=template-result.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/parts.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module lit-html
 */






const isPrimitive = (value) => {
    return (value === null ||
        !(typeof value === 'object' || typeof value === 'function'));
};
const isIterable = (value) => {
    return Array.isArray(value) ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !!(value && value[Symbol.iterator]);
};
/**
 * Writes attribute values to the DOM for a group of AttributeParts bound to a
 * single attribute. The value is only set once even if there are multiple parts
 * for an attribute.
 */
class AttributeCommitter {
    constructor(element, name, strings) {
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for (let i = 0; i < strings.length - 1; i++) {
            this.parts[i] = this._createPart();
        }
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */
    _createPart() {
        return new parts_AttributePart(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        let text = '';
        for (let i = 0; i < l; i++) {
            text += strings[i];
            const part = this.parts[i];
            if (part !== undefined) {
                const v = part.value;
                if (isPrimitive(v) || !isIterable(v)) {
                    text += typeof v === 'string' ? v : String(v);
                }
                else {
                    for (const t of v) {
                        text += typeof t === 'string' ? t : String(t);
                    }
                }
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
/**
 * A Part that controls all or part of an attribute value.
 */
class parts_AttributePart {
    constructor(committer) {
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== noChange && (!isPrimitive(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!isDirective(value)) {
                this.committer.dirty = true;
            }
        }
    }
    commit() {
        while (isDirective(this.value)) {
            const directive = this.value;
            this.value = noChange;
            directive(this);
        }
        if (this.value === noChange) {
            return;
        }
        this.committer.commit();
    }
}
/**
 * A Part that controls a location within a Node tree. Like a Range, NodePart
 * has start and end locations and can set and update the Nodes between those
 * locations.
 *
 * NodeParts support several value types: primitives, Nodes, TemplateResults,
 * as well as arrays and iterables of those types.
 */
class parts_NodePart {
    constructor(options) {
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    appendInto(container) {
        this.startNode = container.appendChild(createMarker());
        this.endNode = container.appendChild(createMarker());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    appendIntoPart(part) {
        part.__insert(this.startNode = createMarker());
        part.__insert(this.endNode = createMarker());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    insertAfterPart(ref) {
        ref.__insert(this.startNode = createMarker());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) {
            return;
        }
        while (isDirective(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = noChange;
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === noChange) {
            return;
        }
        if (isPrimitive(value)) {
            if (value !== this.value) {
                this.__commitText(value);
            }
        }
        else if (value instanceof template_result_TemplateResult) {
            this.__commitTemplateResult(value);
        }
        else if (value instanceof Node) {
            this.__commitNode(value);
        }
        else if (isIterable(value)) {
            this.__commitIterable(value);
        }
        else if (value === nothing) {
            this.value = nothing;
            this.clear();
        }
        else {
            // Fallback, will render the string representation
            this.__commitText(value);
        }
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) {
            return;
        }
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? '' : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === 'string' ? value : String(value);
        if (node === this.endNode.previousSibling &&
            node.nodeType === 3 /* Node.TEXT_NODE */) {
            // If we only have a single text node between the markers, we can just
            // set its value, rather than replacing it.
            // TODO(justinfagnani): Can we just check if this.value is primitive?
            node.data = valueAsString;
        }
        else {
            this.__commitNode(document.createTextNode(valueAsString));
        }
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof template_instance_TemplateInstance &&
            this.value.template === template) {
            this.value.update(value.values);
        }
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new template_instance_TemplateInstance(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value) {
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new parts_NodePart(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) {
                    itemPart.appendIntoPart(this);
                }
                else {
                    itemPart.insertAfterPart(itemParts[partIndex - 1]);
                }
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        removeNodes(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
/**
 * Implements a boolean attribute, roughly as defined in the HTML
 * specification.
 *
 * If the value is truthy, then the attribute is present with a value of
 * ''. If the value is falsey, the attribute is removed.
 */
class parts_BooleanAttributePart {
    constructor(element, name, strings) {
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== '' || strings[1] !== '') {
            throw new Error('Boolean attributes can only contain a single expression');
        }
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while (isDirective(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = noChange;
            directive(this);
        }
        if (this.__pendingValue === noChange) {
            return;
        }
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) {
                this.element.setAttribute(this.name, '');
            }
            else {
                this.element.removeAttribute(this.name);
            }
            this.value = value;
        }
        this.__pendingValue = noChange;
    }
}
/**
 * Sets attribute values for PropertyParts, so that the value is only set once
 * even if there are multiple parts for a property.
 *
 * If an expression controls the whole property value, then the value is simply
 * assigned to the property under control. If there are string literals or
 * multiple expressions, then the strings are expressions are interpolated into
 * a string first.
 */
class PropertyCommitter extends AttributeCommitter {
    constructor(element, name, strings) {
        super(element, name, strings);
        this.single =
            (strings.length === 2 && strings[0] === '' && strings[1] === '');
    }
    _createPart() {
        return new PropertyPart(this);
    }
    _getValue() {
        if (this.single) {
            return this.parts[0].value;
        }
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class PropertyPart extends parts_AttributePart {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(() => {
    try {
        const options = {
            get capture() {
                eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener('test', options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener('test', options, options);
    }
    catch (_e) {
        // event options not supported
    }
})();
class parts_EventPart {
    constructor(element, eventName, eventContext) {
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e) => this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while (isDirective(this.__pendingValue)) {
            const directive = this.__pendingValue;
            this.__pendingValue = noChange;
            directive(this);
        }
        if (this.__pendingValue === noChange) {
            return;
        }
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null ||
            oldListener != null &&
                (newListener.capture !== oldListener.capture ||
                    newListener.once !== oldListener.once ||
                    newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) {
            this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        if (shouldAddListener) {
            this.__options = getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = noChange;
    }
    handleEvent(event) {
        if (typeof this.value === 'function') {
            this.value.call(this.eventContext || this.element, event);
        }
        else {
            this.value.handleEvent(event);
        }
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const getOptions = (o) => o &&
    (eventOptionsSupported ?
        { capture: o.capture, passive: o.passive, once: o.once } :
        o.capture);
//# sourceMappingURL=parts.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/template-factory.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * The default TemplateFactory which caches Templates keyed on
 * result.type and result.strings.
 */
function templateFactory(result) {
    let templateCache = templateCaches.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        templateCaches.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
        return template;
    }
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join(marker);
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new Template(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const templateCaches = new Map();
//# sourceMappingURL=template-factory.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/render.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @module lit-html
 */



const render_parts = new WeakMap();
/**
 * Renders a template result or other value to a container.
 *
 * To update a container with new values, reevaluate the template literal and
 * call `render` with the new result.
 *
 * @param result Any value renderable by NodePart - typically a TemplateResult
 *     created by evaluating a template tag like `html` or `svg`.
 * @param container A DOM parent to render to. The entire contents are either
 *     replaced, or efficiently updated if the same result type was previous
 *     rendered there.
 * @param options RenderOptions for the entire render tree rendered to this
 *     container. Render options must *not* change between renders to the same
 *     container, as those changes will not effect previously rendered DOM.
 */
const render = (result, container, options) => {
    let part = render_parts.get(container);
    if (part === undefined) {
        removeNodes(container, container.firstChild);
        render_parts.set(container, part = new parts_NodePart(Object.assign({ templateFactory: templateFactory }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};
//# sourceMappingURL=render.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/default-template-processor.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * Creates Parts when a template is instantiated.
 */
class default_template_processor_DefaultTemplateProcessor {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */
    handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === '.') {
            const committer = new PropertyCommitter(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === '@') {
            return [new parts_EventPart(element, name.slice(1), options.eventContext)];
        }
        if (prefix === '?') {
            return [new parts_BooleanAttributePart(element, name.slice(1), strings)];
        }
        const committer = new AttributeCommitter(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */
    handleTextExpression(options) {
        return new parts_NodePart(options);
    }
}
const defaultTemplateProcessor = new default_template_processor_DefaultTemplateProcessor();
//# sourceMappingURL=default-template-processor.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lit-html.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @module lit-html
 * @preferred
 */
/**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */




// TODO(justinfagnani): remove line when we get NodePart moving methods








// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== 'undefined') {
    (window['litHtmlVersions'] || (window['litHtmlVersions'] = [])).push('1.2.1');
}
/**
 * Interprets a template literal as an HTML template that can efficiently
 * render to and update a container.
 */
const lit_html_html = (strings, ...values) => new template_result_TemplateResult(strings, values, 'html', defaultTemplateProcessor);
/**
 * Interprets a template literal as an SVG template that can efficiently
 * render to and update a container.
 */
const svg = (strings, ...values) => new template_result_SVGTemplateResult(strings, values, 'svg', defaultTemplateProcessor);
//# sourceMappingURL=lit-html.js.map
// CONCATENATED MODULE: ./node_modules/lit-html/lib/shady-render.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * Module to add shady DOM/shady CSS polyfill support to lit-html template
 * rendering. See the [[render]] method for details.
 *
 * @module shady-render
 * @preferred
 */
/**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */







// Get a key to lookup in `templateCaches`.
const getTemplateCacheKey = (type, scopeName) => `${type}--${scopeName}`;
let compatibleShadyCSSVersion = true;
if (typeof window.ShadyCSS === 'undefined') {
    compatibleShadyCSSVersion = false;
}
else if (typeof window.ShadyCSS.prepareTemplateDom === 'undefined') {
    console.warn(`Incompatible ShadyCSS version detected. ` +
        `Please update to at least @webcomponents/webcomponentsjs@2.0.2 and ` +
        `@webcomponents/shadycss@1.3.1.`);
    compatibleShadyCSSVersion = false;
}
/**
 * Template factory which scopes template DOM using ShadyCSS.
 * @param scopeName {string}
 */
const shadyTemplateFactory = (scopeName) => (result) => {
    const cacheKey = getTemplateCacheKey(result.type, scopeName);
    let templateCache = templateCaches.get(cacheKey);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        templateCaches.set(cacheKey, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
        return template;
    }
    const key = result.strings.join(marker);
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        const element = result.getTemplateElement();
        if (compatibleShadyCSSVersion) {
            window.ShadyCSS.prepareTemplateDom(element, scopeName);
        }
        template = new Template(result, element);
        templateCache.keyString.set(key, template);
    }
    templateCache.stringsArray.set(result.strings, template);
    return template;
};
const TEMPLATE_TYPES = ['html', 'svg'];
/**
 * Removes all style elements from Templates for the given scopeName.
 */
const removeStylesFromLitTemplates = (scopeName) => {
    TEMPLATE_TYPES.forEach((type) => {
        const templates = templateCaches.get(getTemplateCacheKey(type, scopeName));
        if (templates !== undefined) {
            templates.keyString.forEach((template) => {
                const { element: { content } } = template;
                // IE 11 doesn't support the iterable param Set constructor
                const styles = new Set();
                Array.from(content.querySelectorAll('style')).forEach((s) => {
                    styles.add(s);
                });
                removeNodesFromTemplate(template, styles);
            });
        }
    });
};
const shadyRenderSet = new Set();
/**
 * For the given scope name, ensures that ShadyCSS style scoping is performed.
 * This is done just once per scope name so the fragment and template cannot
 * be modified.
 * (1) extracts styles from the rendered fragment and hands them to ShadyCSS
 * to be scoped and appended to the document
 * (2) removes style elements from all lit-html Templates for this scope name.
 *
 * Note, <style> elements can only be placed into templates for the
 * initial rendering of the scope. If <style> elements are included in templates
 * dynamically rendered to the scope (after the first scope render), they will
 * not be scoped and the <style> will be left in the template and rendered
 * output.
 */
const prepareTemplateStyles = (scopeName, renderedDOM, template) => {
    shadyRenderSet.add(scopeName);
    // If `renderedDOM` is stamped from a Template, then we need to edit that
    // Template's underlying template element. Otherwise, we create one here
    // to give to ShadyCSS, which still requires one while scoping.
    const templateElement = !!template ? template.element : document.createElement('template');
    // Move styles out of rendered DOM and store.
    const styles = renderedDOM.querySelectorAll('style');
    const { length } = styles;
    // If there are no styles, skip unnecessary work
    if (length === 0) {
        // Ensure prepareTemplateStyles is called to support adding
        // styles via `prepareAdoptedCssText` since that requires that
        // `prepareTemplateStyles` is called.
        //
        // ShadyCSS will only update styles containing @apply in the template
        // given to `prepareTemplateStyles`. If no lit Template was given,
        // ShadyCSS will not be able to update uses of @apply in any relevant
        // template. However, this is not a problem because we only create the
        // template for the purpose of supporting `prepareAdoptedCssText`,
        // which doesn't support @apply at all.
        window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
        return;
    }
    const condensedStyle = document.createElement('style');
    // Collect styles into a single style. This helps us make sure ShadyCSS
    // manipulations will not prevent us from being able to fix up template
    // part indices.
    // NOTE: collecting styles is inefficient for browsers but ShadyCSS
    // currently does this anyway. When it does not, this should be changed.
    for (let i = 0; i < length; i++) {
        const style = styles[i];
        style.parentNode.removeChild(style);
        condensedStyle.textContent += style.textContent;
    }
    // Remove styles from nested templates in this scope.
    removeStylesFromLitTemplates(scopeName);
    // And then put the condensed style into the "root" template passed in as
    // `template`.
    const content = templateElement.content;
    if (!!template) {
        insertNodeIntoTemplate(template, condensedStyle, content.firstChild);
    }
    else {
        content.insertBefore(condensedStyle, content.firstChild);
    }
    // Note, it's important that ShadyCSS gets the template that `lit-html`
    // will actually render so that it can update the style inside when
    // needed (e.g. @apply native Shadow DOM case).
    window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
    const style = content.querySelector('style');
    if (window.ShadyCSS.nativeShadow && style !== null) {
        // When in native Shadow DOM, ensure the style created by ShadyCSS is
        // included in initially rendered output (`renderedDOM`).
        renderedDOM.insertBefore(style.cloneNode(true), renderedDOM.firstChild);
    }
    else if (!!template) {
        // When no style is left in the template, parts will be broken as a
        // result. To fix this, we put back the style node ShadyCSS removed
        // and then tell lit to remove that node from the template.
        // There can be no style in the template in 2 cases (1) when Shady DOM
        // is in use, ShadyCSS removes all styles, (2) when native Shadow DOM
        // is in use ShadyCSS removes the style if it contains no content.
        // NOTE, ShadyCSS creates its own style so we can safely add/remove
        // `condensedStyle` here.
        content.insertBefore(condensedStyle, content.firstChild);
        const removes = new Set();
        removes.add(condensedStyle);
        removeNodesFromTemplate(template, removes);
    }
};
/**
 * Extension to the standard `render` method which supports rendering
 * to ShadowRoots when the ShadyDOM (https://github.com/webcomponents/shadydom)
 * and ShadyCSS (https://github.com/webcomponents/shadycss) polyfills are used
 * or when the webcomponentsjs
 * (https://github.com/webcomponents/webcomponentsjs) polyfill is used.
 *
 * Adds a `scopeName` option which is used to scope element DOM and stylesheets
 * when native ShadowDOM is unavailable. The `scopeName` will be added to
 * the class attribute of all rendered DOM. In addition, any style elements will
 * be automatically re-written with this `scopeName` selector and moved out
 * of the rendered DOM and into the document `<head>`.
 *
 * It is common to use this render method in conjunction with a custom element
 * which renders a shadowRoot. When this is done, typically the element's
 * `localName` should be used as the `scopeName`.
 *
 * In addition to DOM scoping, ShadyCSS also supports a basic shim for css
 * custom properties (needed only on older browsers like IE11) and a shim for
 * a deprecated feature called `@apply` that supports applying a set of css
 * custom properties to a given location.
 *
 * Usage considerations:
 *
 * * Part values in `<style>` elements are only applied the first time a given
 * `scopeName` renders. Subsequent changes to parts in style elements will have
 * no effect. Because of this, parts in style elements should only be used for
 * values that will never change, for example parts that set scope-wide theme
 * values or parts which render shared style elements.
 *
 * * Note, due to a limitation of the ShadyDOM polyfill, rendering in a
 * custom element's `constructor` is not supported. Instead rendering should
 * either done asynchronously, for example at microtask timing (for example
 * `Promise.resolve()`), or be deferred until the first time the element's
 * `connectedCallback` runs.
 *
 * Usage considerations when using shimmed custom properties or `@apply`:
 *
 * * Whenever any dynamic changes are made which affect
 * css custom properties, `ShadyCSS.styleElement(element)` must be called
 * to update the element. There are two cases when this is needed:
 * (1) the element is connected to a new parent, (2) a class is added to the
 * element that causes it to match different custom properties.
 * To address the first case when rendering a custom element, `styleElement`
 * should be called in the element's `connectedCallback`.
 *
 * * Shimmed custom properties may only be defined either for an entire
 * shadowRoot (for example, in a `:host` rule) or via a rule that directly
 * matches an element with a shadowRoot. In other words, instead of flowing from
 * parent to child as do native css custom properties, shimmed custom properties
 * flow only from shadowRoots to nested shadowRoots.
 *
 * * When using `@apply` mixing css shorthand property names with
 * non-shorthand names (for example `border` and `border-width`) is not
 * supported.
 */
const shady_render_render = (result, container, options) => {
    if (!options || typeof options !== 'object' || !options.scopeName) {
        throw new Error('The `scopeName` option is required.');
    }
    const scopeName = options.scopeName;
    const hasRendered = render_parts.has(container);
    const needsScoping = compatibleShadyCSSVersion &&
        container.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */ &&
        !!container.host;
    // Handle first render to a scope specially...
    const firstScopeRender = needsScoping && !shadyRenderSet.has(scopeName);
    // On first scope render, render into a fragment; this cannot be a single
    // fragment that is reused since nested renders can occur synchronously.
    const renderContainer = firstScopeRender ? document.createDocumentFragment() : container;
    render(result, renderContainer, Object.assign({ templateFactory: shadyTemplateFactory(scopeName) }, options));
    // When performing first scope render,
    // (1) We've rendered into a fragment so that there's a chance to
    // `prepareTemplateStyles` before sub-elements hit the DOM
    // (which might cause them to render based on a common pattern of
    // rendering in a custom element's `connectedCallback`);
    // (2) Scope the template with ShadyCSS one time only for this scope.
    // (3) Render the fragment into the container and make sure the
    // container knows its `part` is the one we just rendered. This ensures
    // DOM will be re-used on subsequent renders.
    if (firstScopeRender) {
        const part = render_parts.get(renderContainer);
        render_parts.delete(renderContainer);
        // ShadyCSS might have style sheets (e.g. from `prepareAdoptedCssText`)
        // that should apply to `renderContainer` even if the rendered value is
        // not a TemplateInstance. However, it will only insert scoped styles
        // into the document if `prepareTemplateStyles` has already been called
        // for the given scope name.
        const template = part.value instanceof template_instance_TemplateInstance ?
            part.value.template :
            undefined;
        prepareTemplateStyles(scopeName, renderContainer, template);
        removeNodes(container, container.firstChild);
        container.appendChild(renderContainer);
        render_parts.set(container, part);
    }
    // After elements have hit the DOM, update styling if this is the
    // initial render to this container.
    // This is needed whenever dynamic changes are made so it would be
    // safest to do every render; however, this would regress performance
    // so we leave it up to the user to call `ShadyCSS.styleElement`
    // for dynamic changes.
    if (!hasRendered && needsScoping) {
        window.ShadyCSS.styleElement(container.host);
    }
};
//# sourceMappingURL=shady-render.js.map
// CONCATENATED MODULE: ./node_modules/lit-element/lib/updating-element.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
var updating_element_a;
/**
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is
 * replaced at compile time by the munged name for object[property]. We cannot
 * alias this function, so we have to use a small shim that has the same
 * behavior when not compiling.
 */
window.JSCompiler_renameProperty =
    (prop, _obj) => prop;
const defaultConverter = {
    toAttribute(value, type) {
        switch (type) {
            case Boolean:
                return value ? '' : null;
            case Object:
            case Array:
                // if the value is `null` or `undefined` pass this through
                // to allow removing/no change behavior.
                return value == null ? value : JSON.stringify(value);
        }
        return value;
    },
    fromAttribute(value, type) {
        switch (type) {
            case Boolean:
                return value !== null;
            case Number:
                return value === null ? null : Number(value);
            case Object:
            case Array:
                return JSON.parse(value);
        }
        return value;
    }
};
/**
 * Change function that returns true if `value` is different from `oldValue`.
 * This method is used as the default for a property's `hasChanged` function.
 */
const notEqual = (value, old) => {
    // This ensures (old==NaN, value==NaN) always returns false
    return old !== value && (old === old || value === value);
};
const defaultPropertyDeclaration = {
    attribute: true,
    type: String,
    converter: defaultConverter,
    reflect: false,
    hasChanged: notEqual
};
const STATE_HAS_UPDATED = 1;
const STATE_UPDATE_REQUESTED = 1 << 2;
const STATE_IS_REFLECTING_TO_ATTRIBUTE = 1 << 3;
const STATE_IS_REFLECTING_TO_PROPERTY = 1 << 4;
/**
 * The Closure JS Compiler doesn't currently have good support for static
 * property semantics where "this" is dynamic (e.g.
 * https://github.com/google/closure-compiler/issues/3177 and others) so we use
 * this hack to bypass any rewriting by the compiler.
 */
const finalized = 'finalized';
/**
 * Base element class which manages element properties and attributes. When
 * properties change, the `update` method is asynchronously called. This method
 * should be supplied by subclassers to render updates as desired.
 */
class UpdatingElement extends HTMLElement {
    constructor() {
        super();
        this._updateState = 0;
        this._instanceProperties = undefined;
        // Initialize to an unresolved Promise so we can make sure the element has
        // connected before first update.
        this._updatePromise = new Promise((res) => this._enableUpdatingResolver = res);
        /**
         * Map with keys for any properties that have changed since the last
         * update cycle with previous values.
         */
        this._changedProperties = new Map();
        /**
         * Map with keys of properties that should be reflected when updated.
         */
        this._reflectingProperties = undefined;
        this.initialize();
    }
    /**
     * Returns a list of attributes corresponding to the registered properties.
     * @nocollapse
     */
    static get observedAttributes() {
        // note: piggy backing on this to ensure we're finalized.
        this.finalize();
        const attributes = [];
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this._classProperties.forEach((v, p) => {
            const attr = this._attributeNameForProperty(p, v);
            if (attr !== undefined) {
                this._attributeToPropertyMap.set(attr, p);
                attributes.push(attr);
            }
        });
        return attributes;
    }
    /**
     * Ensures the private `_classProperties` property metadata is created.
     * In addition to `finalize` this is also called in `createProperty` to
     * ensure the `@property` decorator can add property metadata.
     */
    /** @nocollapse */
    static _ensureClassProperties() {
        // ensure private storage for property declarations.
        if (!this.hasOwnProperty(JSCompiler_renameProperty('_classProperties', this))) {
            this._classProperties = new Map();
            // NOTE: Workaround IE11 not supporting Map constructor argument.
            const superProperties = Object.getPrototypeOf(this)._classProperties;
            if (superProperties !== undefined) {
                superProperties.forEach((v, k) => this._classProperties.set(k, v));
            }
        }
    }
    /**
     * Creates a property accessor on the element prototype if one does not exist
     * and stores a PropertyDeclaration for the property with the given options.
     * The property setter calls the property's `hasChanged` property option
     * or uses a strict identity check to determine whether or not to request
     * an update.
     *
     * This method may be overridden to customize properties; however,
     * when doing so, it's important to call `super.createProperty` to ensure
     * the property is setup correctly. This method calls
     * `getPropertyDescriptor` internally to get a descriptor to install.
     * To customize what properties do when they are get or set, override
     * `getPropertyDescriptor`. To customize the options for a property,
     * implement `createProperty` like this:
     *
     * static createProperty(name, options) {
     *   options = Object.assign(options, {myOption: true});
     *   super.createProperty(name, options);
     * }
     *
     * @nocollapse
     */
    static createProperty(name, options = defaultPropertyDeclaration) {
        // Note, since this can be called by the `@property` decorator which
        // is called before `finalize`, we ensure storage exists for property
        // metadata.
        this._ensureClassProperties();
        this._classProperties.set(name, options);
        // Do not generate an accessor if the prototype already has one, since
        // it would be lost otherwise and that would never be the user's intention;
        // Instead, we expect users to call `requestUpdate` themselves from
        // user-defined accessors. Note that if the super has an accessor we will
        // still overwrite it
        if (options.noAccessor || this.prototype.hasOwnProperty(name)) {
            return;
        }
        const key = typeof name === 'symbol' ? Symbol() : `__${name}`;
        const descriptor = this.getPropertyDescriptor(name, key, options);
        if (descriptor !== undefined) {
            Object.defineProperty(this.prototype, name, descriptor);
        }
    }
    /**
     * Returns a property descriptor to be defined on the given named property.
     * If no descriptor is returned, the property will not become an accessor.
     * For example,
     *
     *   class MyElement extends LitElement {
     *     static getPropertyDescriptor(name, key, options) {
     *       const defaultDescriptor =
     *           super.getPropertyDescriptor(name, key, options);
     *       const setter = defaultDescriptor.set;
     *       return {
     *         get: defaultDescriptor.get,
     *         set(value) {
     *           setter.call(this, value);
     *           // custom action.
     *         },
     *         configurable: true,
     *         enumerable: true
     *       }
     *     }
     *   }
     *
     * @nocollapse
     */
    static getPropertyDescriptor(name, key, _options) {
        return {
            // tslint:disable-next-line:no-any no symbol in index
            get() {
                return this[key];
            },
            set(value) {
                const oldValue = this[name];
                this[key] = value;
                this._requestUpdate(name, oldValue);
            },
            configurable: true,
            enumerable: true
        };
    }
    /**
     * Returns the property options associated with the given property.
     * These options are defined with a PropertyDeclaration via the `properties`
     * object or the `@property` decorator and are registered in
     * `createProperty(...)`.
     *
     * Note, this method should be considered "final" and not overridden. To
     * customize the options for a given property, override `createProperty`.
     *
     * @nocollapse
     * @final
     */
    static getPropertyOptions(name) {
        return this._classProperties && this._classProperties.get(name) ||
            defaultPropertyDeclaration;
    }
    /**
     * Creates property accessors for registered properties and ensures
     * any superclasses are also finalized.
     * @nocollapse
     */
    static finalize() {
        // finalize any superclasses
        const superCtor = Object.getPrototypeOf(this);
        if (!superCtor.hasOwnProperty(finalized)) {
            superCtor.finalize();
        }
        this[finalized] = true;
        this._ensureClassProperties();
        // initialize Map populated in observedAttributes
        this._attributeToPropertyMap = new Map();
        // make any properties
        // Note, only process "own" properties since this element will inherit
        // any properties defined on the superClass, and finalization ensures
        // the entire prototype chain is finalized.
        if (this.hasOwnProperty(JSCompiler_renameProperty('properties', this))) {
            const props = this.properties;
            // support symbols in properties (IE11 does not support this)
            const propKeys = [
                ...Object.getOwnPropertyNames(props),
                ...(typeof Object.getOwnPropertySymbols === 'function') ?
                    Object.getOwnPropertySymbols(props) :
                    []
            ];
            // This for/of is ok because propKeys is an array
            for (const p of propKeys) {
                // note, use of `any` is due to TypeSript lack of support for symbol in
                // index types
                // tslint:disable-next-line:no-any no symbol in index
                this.createProperty(p, props[p]);
            }
        }
    }
    /**
     * Returns the property name for the given attribute `name`.
     * @nocollapse
     */
    static _attributeNameForProperty(name, options) {
        const attribute = options.attribute;
        return attribute === false ?
            undefined :
            (typeof attribute === 'string' ?
                attribute :
                (typeof name === 'string' ? name.toLowerCase() : undefined));
    }
    /**
     * Returns true if a property should request an update.
     * Called when a property value is set and uses the `hasChanged`
     * option for the property if present or a strict identity check.
     * @nocollapse
     */
    static _valueHasChanged(value, old, hasChanged = notEqual) {
        return hasChanged(value, old);
    }
    /**
     * Returns the property value for the given attribute value.
     * Called via the `attributeChangedCallback` and uses the property's
     * `converter` or `converter.fromAttribute` property option.
     * @nocollapse
     */
    static _propertyValueFromAttribute(value, options) {
        const type = options.type;
        const converter = options.converter || defaultConverter;
        const fromAttribute = (typeof converter === 'function' ? converter : converter.fromAttribute);
        return fromAttribute ? fromAttribute(value, type) : value;
    }
    /**
     * Returns the attribute value for the given property value. If this
     * returns undefined, the property will *not* be reflected to an attribute.
     * If this returns null, the attribute will be removed, otherwise the
     * attribute will be set to the value.
     * This uses the property's `reflect` and `type.toAttribute` property options.
     * @nocollapse
     */
    static _propertyValueToAttribute(value, options) {
        if (options.reflect === undefined) {
            return;
        }
        const type = options.type;
        const converter = options.converter;
        const toAttribute = converter && converter.toAttribute ||
            defaultConverter.toAttribute;
        return toAttribute(value, type);
    }
    /**
     * Performs element initialization. By default captures any pre-set values for
     * registered properties.
     */
    initialize() {
        this._saveInstanceProperties();
        // ensures first update will be caught by an early access of
        // `updateComplete`
        this._requestUpdate();
    }
    /**
     * Fixes any properties set on the instance before upgrade time.
     * Otherwise these would shadow the accessor and break these properties.
     * The properties are stored in a Map which is played back after the
     * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
     * (<=41), properties created for native platform properties like (`id` or
     * `name`) may not have default values set in the element constructor. On
     * these browsers native properties appear on instances and therefore their
     * default value will overwrite any element default (e.g. if the element sets
     * this.id = 'id' in the constructor, the 'id' will become '' since this is
     * the native platform default).
     */
    _saveInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this.constructor
            ._classProperties.forEach((_v, p) => {
            if (this.hasOwnProperty(p)) {
                const value = this[p];
                delete this[p];
                if (!this._instanceProperties) {
                    this._instanceProperties = new Map();
                }
                this._instanceProperties.set(p, value);
            }
        });
    }
    /**
     * Applies previously saved instance properties.
     */
    _applyInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        // tslint:disable-next-line:no-any
        this._instanceProperties.forEach((v, p) => this[p] = v);
        this._instanceProperties = undefined;
    }
    connectedCallback() {
        // Ensure first connection completes an update. Updates cannot complete
        // before connection.
        this.enableUpdating();
    }
    enableUpdating() {
        if (this._enableUpdatingResolver !== undefined) {
            this._enableUpdatingResolver();
            this._enableUpdatingResolver = undefined;
        }
    }
    /**
     * Allows for `super.disconnectedCallback()` in extensions while
     * reserving the possibility of making non-breaking feature additions
     * when disconnecting at some point in the future.
     */
    disconnectedCallback() {
    }
    /**
     * Synchronizes property values when attributes change.
     */
    attributeChangedCallback(name, old, value) {
        if (old !== value) {
            this._attributeToProperty(name, value);
        }
    }
    _propertyToAttribute(name, value, options = defaultPropertyDeclaration) {
        const ctor = this.constructor;
        const attr = ctor._attributeNameForProperty(name, options);
        if (attr !== undefined) {
            const attrValue = ctor._propertyValueToAttribute(value, options);
            // an undefined value does not change the attribute.
            if (attrValue === undefined) {
                return;
            }
            // Track if the property is being reflected to avoid
            // setting the property again via `attributeChangedCallback`. Note:
            // 1. this takes advantage of the fact that the callback is synchronous.
            // 2. will behave incorrectly if multiple attributes are in the reaction
            // stack at time of calling. However, since we process attributes
            // in `update` this should not be possible (or an extreme corner case
            // that we'd like to discover).
            // mark state reflecting
            this._updateState = this._updateState | STATE_IS_REFLECTING_TO_ATTRIBUTE;
            if (attrValue == null) {
                this.removeAttribute(attr);
            }
            else {
                this.setAttribute(attr, attrValue);
            }
            // mark state not reflecting
            this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_ATTRIBUTE;
        }
    }
    _attributeToProperty(name, value) {
        // Use tracking info to avoid deserializing attribute value if it was
        // just set from a property setter.
        if (this._updateState & STATE_IS_REFLECTING_TO_ATTRIBUTE) {
            return;
        }
        const ctor = this.constructor;
        // Note, hint this as an `AttributeMap` so closure clearly understands
        // the type; it has issues with tracking types through statics
        // tslint:disable-next-line:no-unnecessary-type-assertion
        const propName = ctor._attributeToPropertyMap.get(name);
        if (propName !== undefined) {
            const options = ctor.getPropertyOptions(propName);
            // mark state reflecting
            this._updateState = this._updateState | STATE_IS_REFLECTING_TO_PROPERTY;
            this[propName] =
                // tslint:disable-next-line:no-any
                ctor._propertyValueFromAttribute(value, options);
            // mark state not reflecting
            this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_PROPERTY;
        }
    }
    /**
     * This private version of `requestUpdate` does not access or return the
     * `updateComplete` promise. This promise can be overridden and is therefore
     * not free to access.
     */
    _requestUpdate(name, oldValue) {
        let shouldRequestUpdate = true;
        // If we have a property key, perform property update steps.
        if (name !== undefined) {
            const ctor = this.constructor;
            const options = ctor.getPropertyOptions(name);
            if (ctor._valueHasChanged(this[name], oldValue, options.hasChanged)) {
                if (!this._changedProperties.has(name)) {
                    this._changedProperties.set(name, oldValue);
                }
                // Add to reflecting properties set.
                // Note, it's important that every change has a chance to add the
                // property to `_reflectingProperties`. This ensures setting
                // attribute + property reflects correctly.
                if (options.reflect === true &&
                    !(this._updateState & STATE_IS_REFLECTING_TO_PROPERTY)) {
                    if (this._reflectingProperties === undefined) {
                        this._reflectingProperties = new Map();
                    }
                    this._reflectingProperties.set(name, options);
                }
            }
            else {
                // Abort the request if the property should not be considered changed.
                shouldRequestUpdate = false;
            }
        }
        if (!this._hasRequestedUpdate && shouldRequestUpdate) {
            this._updatePromise = this._enqueueUpdate();
        }
    }
    /**
     * Requests an update which is processed asynchronously. This should
     * be called when an element should update based on some state not triggered
     * by setting a property. In this case, pass no arguments. It should also be
     * called when manually implementing a property setter. In this case, pass the
     * property `name` and `oldValue` to ensure that any configured property
     * options are honored. Returns the `updateComplete` Promise which is resolved
     * when the update completes.
     *
     * @param name {PropertyKey} (optional) name of requesting property
     * @param oldValue {any} (optional) old value of requesting property
     * @returns {Promise} A Promise that is resolved when the update completes.
     */
    requestUpdate(name, oldValue) {
        this._requestUpdate(name, oldValue);
        return this.updateComplete;
    }
    /**
     * Sets up the element to asynchronously update.
     */
    async _enqueueUpdate() {
        this._updateState = this._updateState | STATE_UPDATE_REQUESTED;
        try {
            // Ensure any previous update has resolved before updating.
            // This `await` also ensures that property changes are batched.
            await this._updatePromise;
        }
        catch (e) {
            // Ignore any previous errors. We only care that the previous cycle is
            // done. Any error should have been handled in the previous update.
        }
        const result = this.performUpdate();
        // If `performUpdate` returns a Promise, we await it. This is done to
        // enable coordinating updates with a scheduler. Note, the result is
        // checked to avoid delaying an additional microtask unless we need to.
        if (result != null) {
            await result;
        }
        return !this._hasRequestedUpdate;
    }
    get _hasRequestedUpdate() {
        return (this._updateState & STATE_UPDATE_REQUESTED);
    }
    get hasUpdated() {
        return (this._updateState & STATE_HAS_UPDATED);
    }
    /**
     * Performs an element update. Note, if an exception is thrown during the
     * update, `firstUpdated` and `updated` will not be called.
     *
     * You can override this method to change the timing of updates. If this
     * method is overridden, `super.performUpdate()` must be called.
     *
     * For instance, to schedule updates to occur just before the next frame:
     *
     * ```
     * protected async performUpdate(): Promise<unknown> {
     *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
     *   super.performUpdate();
     * }
     * ```
     */
    performUpdate() {
        // Mixin instance properties once, if they exist.
        if (this._instanceProperties) {
            this._applyInstanceProperties();
        }
        let shouldUpdate = false;
        const changedProperties = this._changedProperties;
        try {
            shouldUpdate = this.shouldUpdate(changedProperties);
            if (shouldUpdate) {
                this.update(changedProperties);
            }
            else {
                this._markUpdated();
            }
        }
        catch (e) {
            // Prevent `firstUpdated` and `updated` from running when there's an
            // update exception.
            shouldUpdate = false;
            // Ensure element can accept additional updates after an exception.
            this._markUpdated();
            throw e;
        }
        if (shouldUpdate) {
            if (!(this._updateState & STATE_HAS_UPDATED)) {
                this._updateState = this._updateState | STATE_HAS_UPDATED;
                this.firstUpdated(changedProperties);
            }
            this.updated(changedProperties);
        }
    }
    _markUpdated() {
        this._changedProperties = new Map();
        this._updateState = this._updateState & ~STATE_UPDATE_REQUESTED;
    }
    /**
     * Returns a Promise that resolves when the element has completed updating.
     * The Promise value is a boolean that is `true` if the element completed the
     * update without triggering another update. The Promise result is `false` if
     * a property was set inside `updated()`. If the Promise is rejected, an
     * exception was thrown during the update.
     *
     * To await additional asynchronous work, override the `_getUpdateComplete`
     * method. For example, it is sometimes useful to await a rendered element
     * before fulfilling this Promise. To do this, first await
     * `super._getUpdateComplete()`, then any subsequent state.
     *
     * @returns {Promise} The Promise returns a boolean that indicates if the
     * update resolved without triggering another update.
     */
    get updateComplete() {
        return this._getUpdateComplete();
    }
    /**
     * Override point for the `updateComplete` promise.
     *
     * It is not safe to override the `updateComplete` getter directly due to a
     * limitation in TypeScript which means it is not possible to call a
     * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
     * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
     * This method should be overridden instead. For example:
     *
     *   class MyElement extends LitElement {
     *     async _getUpdateComplete() {
     *       await super._getUpdateComplete();
     *       await this._myChild.updateComplete;
     *     }
     *   }
     */
    _getUpdateComplete() {
        return this._updatePromise;
    }
    /**
     * Controls whether or not `update` should be called when the element requests
     * an update. By default, this method always returns `true`, but this can be
     * customized to control when to update.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    shouldUpdate(_changedProperties) {
        return true;
    }
    /**
     * Updates the element. This method reflects property values to attributes.
     * It can be overridden to render and keep updated element DOM.
     * Setting properties inside this method will *not* trigger
     * another update.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    update(_changedProperties) {
        if (this._reflectingProperties !== undefined &&
            this._reflectingProperties.size > 0) {
            // Use forEach so this works even if for/of loops are compiled to for
            // loops expecting arrays
            this._reflectingProperties.forEach((v, k) => this._propertyToAttribute(k, this[k], v));
            this._reflectingProperties = undefined;
        }
        this._markUpdated();
    }
    /**
     * Invoked whenever the element is updated. Implement to perform
     * post-updating tasks via DOM APIs, for example, focusing an element.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    updated(_changedProperties) {
    }
    /**
     * Invoked when the element is first updated. Implement to perform one time
     * work on the element after update.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */
    firstUpdated(_changedProperties) {
    }
}
updating_element_a = finalized;
/**
 * Marks class as having finished creating properties.
 */
UpdatingElement[updating_element_a] = true;
//# sourceMappingURL=updating-element.js.map
// CONCATENATED MODULE: ./node_modules/lit-element/lib/decorators.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const legacyCustomElement = (tagName, clazz) => {
    window.customElements.define(tagName, clazz);
    // Cast as any because TS doesn't recognize the return type as being a
    // subtype of the decorated class when clazz is typed as
    // `Constructor<HTMLElement>` for some reason.
    // `Constructor<HTMLElement>` is helpful to make sure the decorator is
    // applied to elements however.
    // tslint:disable-next-line:no-any
    return clazz;
};
const standardCustomElement = (tagName, descriptor) => {
    const { kind, elements } = descriptor;
    return {
        kind,
        elements,
        // This callback is called once the class is otherwise fully defined
        finisher(clazz) {
            window.customElements.define(tagName, clazz);
        }
    };
};
/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```
 * @customElement('my-element')
 * class MyElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 *
 * @param tagName The name of the custom element to define.
 */
const customElement = (tagName) => (classOrDescriptor) => (typeof classOrDescriptor === 'function') ?
    legacyCustomElement(tagName, classOrDescriptor) :
    standardCustomElement(tagName, classOrDescriptor);
const standardProperty = (options, element) => {
    // When decorating an accessor, pass it through and add property metadata.
    // Note, the `hasOwnProperty` check in `createProperty` ensures we don't
    // stomp over the user's accessor.
    if (element.kind === 'method' && element.descriptor &&
        !('value' in element.descriptor)) {
        return Object.assign(Object.assign({}, element), { finisher(clazz) {
                clazz.createProperty(element.key, options);
            } });
    }
    else {
        // createProperty() takes care of defining the property, but we still
        // must return some kind of descriptor, so return a descriptor for an
        // unused prototype field. The finisher calls createProperty().
        return {
            kind: 'field',
            key: Symbol(),
            placement: 'own',
            descriptor: {},
            // When @babel/plugin-proposal-decorators implements initializers,
            // do this instead of the initializer below. See:
            // https://github.com/babel/babel/issues/9260 extras: [
            //   {
            //     kind: 'initializer',
            //     placement: 'own',
            //     initializer: descriptor.initializer,
            //   }
            // ],
            initializer() {
                if (typeof element.initializer === 'function') {
                    this[element.key] = element.initializer.call(this);
                }
            },
            finisher(clazz) {
                clazz.createProperty(element.key, options);
            }
        };
    }
};
const legacyProperty = (options, proto, name) => {
    proto.constructor
        .createProperty(name, options);
};
/**
 * A property decorator which creates a LitElement property which reflects a
 * corresponding attribute value. A `PropertyDeclaration` may optionally be
 * supplied to configure property features.
 *
 * This decorator should only be used for public fields. Private or protected
 * fields should use the internalProperty decorator.
 *
 * @example
 *
 *     class MyElement {
 *       @property({ type: Boolean })
 *       clicked = false;
 *     }
 *
 * @ExportDecoratedItems
 */
function property(options) {
    // tslint:disable-next-line:no-any decorator
    return (protoOrDescriptor, name) => (name !== undefined) ?
        legacyProperty(options, protoOrDescriptor, name) :
        standardProperty(options, protoOrDescriptor);
}
/**
 * Declares a private or protected property that still triggers updates to the
 * element when it changes.
 *
 * Properties declared this way must not be used from HTML or HTML templating
 * systems, they're solely for properties internal to the element. These
 * properties may be renamed by optimization tools like closure compiler.
 */
function internalProperty(options) {
    return property({ attribute: false, hasChanged: options === null || options === void 0 ? void 0 : options.hasChanged });
}
/**
 * A property decorator that converts a class property into a getter that
 * executes a querySelector on the element's renderRoot.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
 *
 * @example
 *
 *     class MyElement {
 *       @query('#first')
 *       first;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 *
 */
function query(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
// Note, in the future, we may extend this decorator to support the use case
// where the queried element may need to do work to become ready to interact
// with (e.g. load some implementation code). If so, we might elect to
// add a second argument defining a function that can be run to make the
// queried element loaded/updated/ready.
/**
 * A property decorator that converts a class property into a getter that
 * returns a promise that resolves to the result of a querySelector on the
 * element's renderRoot done after the element's `updateComplete` promise
 * resolves. When the queried property may change with element state, this
 * decorator can be used instead of requiring users to await the
 * `updateComplete` before accessing the property.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
 *
 * @example
 *
 *     class MyElement {
 *       @queryAsync('#first')
 *       first;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 *
 *     // external usage
 *     async doSomethingWithFirst() {
 *      (await aMyElement.first).doSomething();
 *     }
 */
function queryAsync(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            async get() {
                await this.updateComplete;
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
/**
 * A property decorator that converts a class property into a getter
 * that executes a querySelectorAll on the element's renderRoot.
 *
 * @param selector A DOMString containing one or more selectors to match.
 *
 * See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelectorAll
 *
 * @example
 *
 *     class MyElement {
 *       @queryAll('div')
 *       divs;
 *
 *       render() {
 *         return html`
 *           <div id="first"></div>
 *           <div id="second"></div>
 *         `;
 *       }
 *     }
 */
function queryAll(selector) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                return this.renderRoot.querySelectorAll(selector);
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
const legacyQuery = (descriptor, proto, name) => {
    Object.defineProperty(proto, name, descriptor);
};
const standardQuery = (descriptor, element) => ({
    kind: 'method',
    placement: 'prototype',
    key: element.key,
    descriptor,
});
const standardEventOptions = (options, element) => {
    return Object.assign(Object.assign({}, element), { finisher(clazz) {
            Object.assign(clazz.prototype[element.key], options);
        } });
};
const legacyEventOptions = 
// tslint:disable-next-line:no-any legacy decorator
(options, proto, name) => {
    Object.assign(proto[name], options);
};
/**
 * Adds event listener options to a method used as an event listener in a
 * lit-html template.
 *
 * @param options An object that specifies event listener options as accepted by
 * `EventTarget#addEventListener` and `EventTarget#removeEventListener`.
 *
 * Current browsers support the `capture`, `passive`, and `once` options. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Parameters
 *
 * @example
 *
 *     class MyElement {
 *       clicked = false;
 *
 *       render() {
 *         return html`
 *           <div @click=${this._onClick}`>
 *             <button></button>
 *           </div>
 *         `;
 *       }
 *
 *       @eventOptions({capture: true})
 *       _onClick(e) {
 *         this.clicked = true;
 *       }
 *     }
 */
function eventOptions(options) {
    // Return value typed as any to prevent TypeScript from complaining that
    // standard decorator function signature does not match TypeScript decorator
    // signature
    // TODO(kschaaf): unclear why it was only failing on this decorator and not
    // the others
    return ((protoOrDescriptor, name) => (name !== undefined) ?
        legacyEventOptions(options, protoOrDescriptor, name) :
        standardEventOptions(options, protoOrDescriptor));
}
/**
 * A property decorator that converts a class property into a getter that
 * returns the `assignedNodes` of the given named `slot`. Note, the type of
 * this property should be annotated as `NodeListOf<HTMLElement>`.
 *
 */
function queryAssignedNodes(slotName = '', flatten = false) {
    return (protoOrDescriptor, 
    // tslint:disable-next-line:no-any decorator
    name) => {
        const descriptor = {
            get() {
                const selector = `slot${slotName ? `[name=${slotName}]` : ''}`;
                const slot = this.renderRoot.querySelector(selector);
                return slot && slot.assignedNodes({ flatten });
            },
            enumerable: true,
            configurable: true,
        };
        return (name !== undefined) ?
            legacyQuery(descriptor, protoOrDescriptor, name) :
            standardQuery(descriptor, protoOrDescriptor);
    };
}
//# sourceMappingURL=decorators.js.map
// CONCATENATED MODULE: ./node_modules/lit-element/lib/css-tag.js
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
const supportsAdoptingStyleSheets = ('adoptedStyleSheets' in Document.prototype) &&
    ('replace' in CSSStyleSheet.prototype);
const constructionToken = Symbol();
class CSSResult {
    constructor(cssText, safeToken) {
        if (safeToken !== constructionToken) {
            throw new Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
        }
        this.cssText = cssText;
    }
    // Note, this is a getter so that it's lazy. In practice, this means
    // stylesheets are not created until the first element instance is made.
    get styleSheet() {
        if (this._styleSheet === undefined) {
            // Note, if `adoptedStyleSheets` is supported then we assume CSSStyleSheet
            // is constructable.
            if (supportsAdoptingStyleSheets) {
                this._styleSheet = new CSSStyleSheet();
                this._styleSheet.replaceSync(this.cssText);
            }
            else {
                this._styleSheet = null;
            }
        }
        return this._styleSheet;
    }
    toString() {
        return this.cssText;
    }
}
/**
 * Wrap a value for interpolation in a css tagged template literal.
 *
 * This is unsafe because untrusted CSS text can be used to phone home
 * or exfiltrate data to an attacker controlled site. Take care to only use
 * this with trusted input.
 */
const unsafeCSS = (value) => {
    return new CSSResult(String(value), constructionToken);
};
const textFromCSSResult = (value) => {
    if (value instanceof CSSResult) {
        return value.cssText;
    }
    else if (typeof value === 'number') {
        return value;
    }
    else {
        throw new Error(`Value passed to 'css' function must be a 'css' function result: ${value}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`);
    }
};
/**
 * Template tag which which can be used with LitElement's `style` property to
 * set element styles. For security reasons, only literal string values may be
 * used. To incorporate non-literal values `unsafeCSS` may be used inside a
 * template string part.
 */
const css = (strings, ...values) => {
    const cssText = values.reduce((acc, v, idx) => acc + textFromCSSResult(v) + strings[idx + 1], strings[0]);
    return new CSSResult(cssText, constructionToken);
};
//# sourceMappingURL=css-tag.js.map
// CONCATENATED MODULE: ./node_modules/lit-element/lit-element.js
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */







// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for LitElement usage.
// TODO(justinfagnani): inject version number at build time
(window['litElementVersions'] || (window['litElementVersions'] = []))
    .push('2.3.1');
/**
 * Sentinal value used to avoid calling lit-html's render function when
 * subclasses do not implement `render`
 */
const renderNotImplemented = {};
class lit_element_LitElement extends UpdatingElement {
    /**
     * Return the array of styles to apply to the element.
     * Override this method to integrate into a style management system.
     *
     * @nocollapse
     */
    static getStyles() {
        return this.styles;
    }
    /** @nocollapse */
    static _getUniqueStyles() {
        // Only gather styles once per class
        if (this.hasOwnProperty(JSCompiler_renameProperty('_styles', this))) {
            return;
        }
        // Take care not to call `this.getStyles()` multiple times since this
        // generates new CSSResults each time.
        // TODO(sorvell): Since we do not cache CSSResults by input, any
        // shared styles will generate new stylesheet objects, which is wasteful.
        // This should be addressed when a browser ships constructable
        // stylesheets.
        const userStyles = this.getStyles();
        if (userStyles === undefined) {
            this._styles = [];
        }
        else if (Array.isArray(userStyles)) {
            // De-duplicate styles preserving the _last_ instance in the set.
            // This is a performance optimization to avoid duplicated styles that can
            // occur especially when composing via subclassing.
            // The last item is kept to try to preserve the cascade order with the
            // assumption that it's most important that last added styles override
            // previous styles.
            const addStyles = (styles, set) => styles.reduceRight((set, s) => 
            // Note: On IE set.add() does not return the set
            Array.isArray(s) ? addStyles(s, set) : (set.add(s), set), set);
            // Array.from does not work on Set in IE, otherwise return
            // Array.from(addStyles(userStyles, new Set<CSSResult>())).reverse()
            const set = addStyles(userStyles, new Set());
            const styles = [];
            set.forEach((v) => styles.unshift(v));
            this._styles = styles;
        }
        else {
            this._styles = [userStyles];
        }
    }
    /**
     * Performs element initialization. By default this calls `createRenderRoot`
     * to create the element `renderRoot` node and captures any pre-set values for
     * registered properties.
     */
    initialize() {
        super.initialize();
        this.constructor._getUniqueStyles();
        this.renderRoot =
            this.createRenderRoot();
        // Note, if renderRoot is not a shadowRoot, styles would/could apply to the
        // element's getRootNode(). While this could be done, we're choosing not to
        // support this now since it would require different logic around de-duping.
        if (window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot) {
            this.adoptStyles();
        }
    }
    /**
     * Returns the node into which the element should render and by default
     * creates and returns an open shadowRoot. Implement to customize where the
     * element's DOM is rendered. For example, to render into the element's
     * childNodes, return `this`.
     * @returns {Element|DocumentFragment} Returns a node into which to render.
     */
    createRenderRoot() {
        return this.attachShadow({ mode: 'open' });
    }
    /**
     * Applies styling to the element shadowRoot using the `static get styles`
     * property. Styling will apply using `shadowRoot.adoptedStyleSheets` where
     * available and will fallback otherwise. When Shadow DOM is polyfilled,
     * ShadyCSS scopes styles and adds them to the document. When Shadow DOM
     * is available but `adoptedStyleSheets` is not, styles are appended to the
     * end of the `shadowRoot` to [mimic spec
     * behavior](https://wicg.github.io/construct-stylesheets/#using-constructed-stylesheets).
     */
    adoptStyles() {
        const styles = this.constructor._styles;
        if (styles.length === 0) {
            return;
        }
        // There are three separate cases here based on Shadow DOM support.
        // (1) shadowRoot polyfilled: use ShadyCSS
        // (2) shadowRoot.adoptedStyleSheets available: use it.
        // (3) shadowRoot.adoptedStyleSheets polyfilled: append styles after
        // rendering
        if (window.ShadyCSS !== undefined && !window.ShadyCSS.nativeShadow) {
            window.ShadyCSS.ScopingShim.prepareAdoptedCssText(styles.map((s) => s.cssText), this.localName);
        }
        else if (supportsAdoptingStyleSheets) {
            this.renderRoot.adoptedStyleSheets =
                styles.map((s) => s.styleSheet);
        }
        else {
            // This must be done after rendering so the actual style insertion is done
            // in `update`.
            this._needsShimAdoptedStyleSheets = true;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        // Note, first update/render handles styleElement so we only call this if
        // connected after first update.
        if (this.hasUpdated && window.ShadyCSS !== undefined) {
            window.ShadyCSS.styleElement(this);
        }
    }
    /**
     * Updates the element. This method reflects property values to attributes
     * and calls `render` to render DOM via lit-html. Setting properties inside
     * this method will *not* trigger another update.
     * @param _changedProperties Map of changed properties with old values
     */
    update(changedProperties) {
        // Setting properties in `render` should not trigger an update. Since
        // updates are allowed after super.update, it's important to call `render`
        // before that.
        const templateResult = this.render();
        super.update(changedProperties);
        // If render is not implemented by the component, don't call lit-html render
        if (templateResult !== renderNotImplemented) {
            this.constructor
                .render(templateResult, this.renderRoot, { scopeName: this.localName, eventContext: this });
        }
        // When native Shadow DOM is used but adoptedStyles are not supported,
        // insert styling after rendering to ensure adoptedStyles have highest
        // priority.
        if (this._needsShimAdoptedStyleSheets) {
            this._needsShimAdoptedStyleSheets = false;
            this.constructor._styles.forEach((s) => {
                const style = document.createElement('style');
                style.textContent = s.cssText;
                this.renderRoot.appendChild(style);
            });
        }
    }
    /**
     * Invoked on each update to perform rendering tasks. This method may return
     * any value renderable by lit-html's NodePart - typically a TemplateResult.
     * Setting properties inside this method will *not* trigger the element to
     * update.
     */
    render() {
        return renderNotImplemented;
    }
}
/**
 * Ensure this class is marked as `finalized` as an optimization ensuring
 * it will not needlessly try to `finalize`.
 *
 * Note this property name is a string to prevent breaking Closure JS Compiler
 * optimizations. See updating-element.ts for more information.
 */
lit_element_LitElement['finalized'] = true;
/**
 * Render method used to render the value to the element's DOM.
 * @param result The value to render.
 * @param container Node into which to render.
 * @param options Element name.
 * @nocollapse
 */
lit_element_LitElement.render = shady_render_render;
//# sourceMappingURL=lit-element.js.map
// EXTERNAL MODULE: ./src/components/banner/banner.scss
var banner = __webpack_require__(2);

// CONCATENATED MODULE: ./src/components/banner/index.ts
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let banner_Banner = class Banner extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.icon = 'done';
    }
    static get styles() {
        return [unsafeCSS(banner)];
    }
    render() {
        return lit_html_html `
      <div class="fm-banner">
        <div class="fm-banner-mobile-bar"></div>
        <div class="fm-banner-row">
          <div class="fm-banner__icon-box">
            <span class="material-icons">${this.icon}</span>
          </div>
          <div class="fm-banner__text-box">
            <slot class="fm-banner__text-box__heading" name="heading"></slot>
            <slot class="fm-banner__text-box__body" name="body"></slot>
            <slot name="tertiary" class="fm-banner__text-box__lines"></slot>
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], banner_Banner.prototype, "icon", void 0);
banner_Banner = __decorate([
    customElement('fm-banner')
], banner_Banner);


// CONCATENATED MODULE: ./node_modules/lit-html/directives/class-map.js
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

// IE11 doesn't support classList on SVG elements, so we emulate it with a Set
class ClassList {
    constructor(element) {
        this.classes = new Set();
        this.changed = false;
        this.element = element;
        const classList = (element.getAttribute('class') || '').split(/\s+/);
        for (const cls of classList) {
            this.classes.add(cls);
        }
    }
    add(cls) {
        this.classes.add(cls);
        this.changed = true;
    }
    remove(cls) {
        this.classes.delete(cls);
        this.changed = true;
    }
    commit() {
        if (this.changed) {
            let classString = '';
            this.classes.forEach((cls) => classString += cls + ' ');
            this.element.setAttribute('class', classString);
        }
    }
}
/**
 * Stores the ClassInfo object applied to a given AttributePart.
 * Used to unset existing values when a new ClassInfo object is applied.
 */
const previousClassesCache = new WeakMap();
/**
 * A directive that applies CSS classes. This must be used in the `class`
 * attribute and must be the only part used in the attribute. It takes each
 * property in the `classInfo` argument and adds the property name to the
 * element's `class` if the property value is truthy; if the property value is
 * falsey, the property name is removed from the element's `class`. For example
 * `{foo: bar}` applies the class `foo` if the value of `bar` is truthy.
 * @param classInfo {ClassInfo}
 */
const classMap = directive_directive((classInfo) => (part) => {
    if (!(part instanceof parts_AttributePart) || (part instanceof PropertyPart) ||
        part.committer.name !== 'class' || part.committer.parts.length > 1) {
        throw new Error('The `classMap` directive must be used in the `class` attribute ' +
            'and must be the only part in the attribute.');
    }
    const { committer } = part;
    const { element } = committer;
    let previousClasses = previousClassesCache.get(part);
    if (previousClasses === undefined) {
        // Write static classes once
        // Use setAttribute() because className isn't a string on SVG elements
        element.setAttribute('class', committer.strings.join(' '));
        previousClassesCache.set(part, previousClasses = new Set());
    }
    const classList = (element.classList || new ClassList(element));
    // Remove old classes that no longer apply
    // We use forEach() instead of for-of so that re don't require down-level
    // iteration.
    previousClasses.forEach((name) => {
        if (!(name in classInfo)) {
            classList.remove(name);
            previousClasses.delete(name);
        }
    });
    // Add or remove classes based on their classMap value
    for (const name in classInfo) {
        const value = classInfo[name];
        if (value != previousClasses.has(name)) {
            // We explicitly want a loose truthy check of `value` because it seems
            // more convenient that '' and 0 are skipped.
            if (value) {
                classList.add(name);
                previousClasses.add(name);
            }
            else {
                classList.remove(name);
                previousClasses.delete(name);
            }
        }
    }
    if (typeof classList.commit === 'function') {
        classList.commit();
    }
});
//# sourceMappingURL=class-map.js.map
// CONCATENATED MODULE: ./src/components/icons/loading.ts
var loading_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

let loading_FuturiIconLoading = class FuturiIconLoading extends lit_element_LitElement {
    static get styles() {
        return [
            css `
        @keyframes rotation {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(359deg);
          }
        }

        .fm-icon {
          fill: #fff;
          fill: blue;
        }

        .Futuri-Icon-Loading {
          animation: rotation 2s infinite linear;
          transform: translate(-2.228 -2);
          /* 
          Using transform-origin to ensure rotation
          is centered. - Trevor Kirpaul
        */
          transform-origin: 50% 50% 0;
        }
      `
        ];
    }
    /**
     * In order to style this element from host
     * elements, we're electing to not render
     * in a shadow DOM by using createRenderRoot
     * -Trevor Kirpaul
     */
    createRenderRoot() {
        return this;
    }
    render() {
        return lit_html_html `
      <style>
        /**
          @TODO: Resolve this issue - Trevor Kirpaul
        */
        @keyframes rotation {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(359deg);
          }
        }

        .fm-icon {
          fill: #fff;
        }

        .Futuri-Icon-Loading {
          animation: rotation 2s infinite linear;
          transform: translate(-2.228 -2);
          /* 
          Using transform-origin to ensure rotation
          is centered. - Trevor Kirpaul
        */
          transform-origin: 50% 50% 0;
        }
      </style>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.654"
        height="20"
        viewBox="0 0 24 24"
      >
        <path
          class="fm-icon Futuri-Icon-Loading"
          d="M12.056,2a10.063,10.063,0,0,0-9.8,7.824,1.006,1.006,0,1,0,1.962.444,8.038,8.038,0,0,1,15.676,0,1.006,1.006,0,0,0,1.962-.444A10.063,10.063,0,0,0,12.056,2ZM3.195,13.05a1.006,1.006,0,0,0-.939,1.241A10.025,10.025,0,0,0,3.5,17.324,1.006,1.006,0,1,0,5.21,16.271a8.006,8.006,0,0,1-.992-2.424A1.006,1.006,0,0,0,3.195,13.05Zm15.422,4.186a1.006,1.006,0,0,0-.772.35c-.133.15-.231.263-.3.328a1.006,1.006,0,0,0,1.377,1.467,6.058,6.058,0,0,0,.428-.46,1.006,1.006,0,0,0-.733-1.685ZM7.273,18.746a1.006,1.006,0,0,0-.485,1.868,10.043,10.043,0,0,0,2.271,1.029,1.006,1.006,0,1,0,.605-1.919A8.043,8.043,0,0,1,7.847,18.9,1.006,1.006,0,0,0,7.273,18.746Zm7.447.935a1.006,1.006,0,0,0-.265.049A8.06,8.06,0,0,1,13.312,20a1.006,1.006,0,1,0,.312,1.988,10.061,10.061,0,0,0,1.428-.338,1.006,1.006,0,0,0-.332-1.968Z"
        />
      </svg>
    `;
    }
};
loading_FuturiIconLoading = loading_decorate([
    customElement('futuri-icon-loading')
], loading_FuturiIconLoading);


// EXTERNAL MODULE: ./src/components/icons/icon.scss
var icon = __webpack_require__(0);

// CONCATENATED MODULE: ./src/components/icons/roundCheck.ts
var roundCheck_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let roundCheck_FuturiIconRoundCheck = class FuturiIconRoundCheck extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <path
          class="fm-icon Futuri-Icon-Round-Check"
          d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5.707,7.707-7,7a1,1,0,0,1-1.414,0l-3-3a1,1,0,0,1,1.414-1.414L10,14.586l6.293-6.293a1,1,0,0,1,1.414,1.414Z"
          transform="translate(-2 -2)"
        />
      </svg>
    `;
    }
};
roundCheck_FuturiIconRoundCheck = roundCheck_decorate([
    customElement('futuri-icon-round-check')
], roundCheck_FuturiIconRoundCheck);


// EXTERNAL MODULE: ./src/components/buttons/button.scss
var buttons_button = __webpack_require__(3);

// CONCATENATED MODULE: ./src/components/buttons/button.ts
var button_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let button_Button = class Button extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.loading = false;
        this.success = false;
    }
    static get styles() {
        return [unsafeCSS(buttons_button)];
    }
    get getButtonContent() {
        if (this.success) {
            return lit_html_html `
        <span class="material-icons fm-icon-check-circle">
          check_circle
        </span>
        <slot></slot>
      `;
        }
        if (this.loading) {
            return lit_html_html `
        <futuri-icon-loading class="button-loading"></futuri-icon-loading>
      `;
        }
        return lit_html_html ` <slot></slot> `;
    }
    get classes() {
        return {
            'fm-button': true,
            'fm-button-loading': this.loading,
            'fm-button-disabled': this.disabled
        };
    }
    render() {
        return lit_html_html `
      <button .disabled=${this.disabled} class=${classMap(this.classes)}>
        ${this.getButtonContent}
      </button>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
button_decorate([
    property({ type: Boolean })
], button_Button.prototype, "disabled", void 0);
button_decorate([
    property({ type: Boolean })
], button_Button.prototype, "loading", void 0);
button_decorate([
    property({ type: Boolean })
], button_Button.prototype, "success", void 0);
button_Button = button_decorate([
    customElement('fm-button')
], button_Button);


// EXTERNAL MODULE: ./src/components/buttons/floatingAction/floatingActionButton.scss
var floatingActionButton = __webpack_require__(4);

// CONCATENATED MODULE: ./src/components/buttons/floatingAction/index.ts
var floatingAction_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let floatingAction_ButtonFloatingAction = class ButtonFloatingAction extends button_Button {
    constructor() {
        super(...arguments);
        this.icon = 'assignment_ind';
    }
    static get styles() {
        return [...super.styles, unsafeCSS(floatingActionButton)];
    }
    get floatingActionButtonContent() {
        return lit_html_html `
      <span class="material-icons fm-button__floating-action__icon">
        ${this.icon}
      </span>
      <slot class="fm-button__floating-action__label"></slot>
    `;
    }
    render() {
        return lit_html_html `
      <button class="fm-button fm-button-floating-action">
        ${this.floatingActionButtonContent}
      </button>
    `;
    }
};
floatingAction_decorate([
    property({ type: String })
], floatingAction_ButtonFloatingAction.prototype, "icon", void 0);
floatingAction_ButtonFloatingAction = floatingAction_decorate([
    customElement('fm-button-floating-action')
], floatingAction_ButtonFloatingAction);


// EXTERNAL MODULE: ./src/components/buttons/primary/primaryButton.scss
var primaryButton = __webpack_require__(5);

// CONCATENATED MODULE: ./src/components/buttons/primary/index.ts
var primary_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let primary_ButtonPrimary = class ButtonPrimary extends button_Button {
    static get styles() {
        return [...super.styles, unsafeCSS(primaryButton)];
    }
};
primary_ButtonPrimary = primary_decorate([
    customElement('fm-button-primary')
], primary_ButtonPrimary);


// EXTERNAL MODULE: ./src/components/buttons/secondary/secondaryButton.scss
var secondaryButton = __webpack_require__(6);

// CONCATENATED MODULE: ./src/components/buttons/secondary/index.ts
var secondary_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let secondary_ButtonSecondary = class ButtonSecondary extends button_Button {
    static get styles() {
        return [...super.styles, unsafeCSS(secondaryButton)];
    }
};
secondary_ButtonSecondary = secondary_decorate([
    customElement('fm-button-secondary')
], secondary_ButtonSecondary);


// EXTERNAL MODULE: ./src/components/cards/card.scss
var card = __webpack_require__(7);

// CONCATENATED MODULE: ./src/components/cards/index.ts
var cards_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let cards_Card = class Card extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.clickable = false;
        this.expandHeight = false;
        this.expandWidth = false;
    }
    static get styles() {
        return [unsafeCSS(card)];
    }
    get cardClasses() {
        return {
            'fm-card': true,
            'clickable-card': this.clickable,
            'expand-height': this.expandHeight,
            'expand-width': this.expandWidth,
        };
    }
    render() {
        return this.clickable
            ? lit_html_html `
        <div class=${classMap(this.cardClasses)}
          tabindex="0">
          <slot></slot>
        </div>
      `
            : lit_html_html `
      <div class=${classMap(this.cardClasses)}>
        <slot></slot>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
cards_decorate([
    property({ type: Boolean })
], cards_Card.prototype, "clickable", void 0);
cards_decorate([
    property({ type: Boolean })
], cards_Card.prototype, "expandHeight", void 0);
cards_decorate([
    property({ type: Boolean })
], cards_Card.prototype, "expandWidth", void 0);
cards_Card = cards_decorate([
    customElement('fm-card')
], cards_Card);


// CONCATENATED MODULE: ./node_modules/lit-html/directives/style-map.js
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * Stores the StyleInfo object applied to a given AttributePart.
 * Used to unset existing values when a new StyleInfo object is applied.
 */
const previousStylePropertyCache = new WeakMap();
/**
 * A directive that applies CSS properties to an element.
 *
 * `styleMap` can only be used in the `style` attribute and must be the only
 * expression in the attribute. It takes the property names in the `styleInfo`
 * object and adds the property values as CSS properties. Property names with
 * dashes (`-`) are assumed to be valid CSS property names and set on the
 * element's style object using `setProperty()`. Names without dashes are
 * assumed to be camelCased JavaScript property names and set on the element's
 * style object using property assignment, allowing the style object to
 * translate JavaScript-style names to CSS property names.
 *
 * For example `styleMap({backgroundColor: 'red', 'border-top': '5px', '--size':
 * '0'})` sets the `background-color`, `border-top` and `--size` properties.
 *
 * @param styleInfo {StyleInfo}
 */
const styleMap = directive_directive((styleInfo) => (part) => {
    if (!(part instanceof parts_AttributePart) || (part instanceof PropertyPart) ||
        part.committer.name !== 'style' || part.committer.parts.length > 1) {
        throw new Error('The `styleMap` directive must be used in the style attribute ' +
            'and must be the only part in the attribute.');
    }
    const { committer } = part;
    const { style } = committer.element;
    let previousStyleProperties = previousStylePropertyCache.get(part);
    if (previousStyleProperties === undefined) {
        // Write static styles once
        style.cssText = committer.strings.join(' ');
        previousStylePropertyCache.set(part, previousStyleProperties = new Set());
    }
    // Remove old properties that no longer exist in styleInfo
    // We use forEach() instead of for-of so that re don't require down-level
    // iteration.
    previousStyleProperties.forEach((name) => {
        if (!(name in styleInfo)) {
            previousStyleProperties.delete(name);
            if (name.indexOf('-') === -1) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                style[name] = null;
            }
            else {
                style.removeProperty(name);
            }
        }
    });
    // Add or update properties
    for (const name in styleInfo) {
        previousStyleProperties.add(name);
        if (name.indexOf('-') === -1) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            style[name] = styleInfo[name];
        }
        else {
            style.setProperty(name, styleInfo[name]);
        }
    }
});
//# sourceMappingURL=style-map.js.map
// EXTERNAL MODULE: ./src/components/menus/menuContent/menuContent.scss
var menuContent = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/menus/menuContent/index.ts
var menuContent_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let menuContent_MenuContent = class MenuContent extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.menuOptions = [];
        this.showMenu = false;
        this.contentPositionStyles = {};
        this.itemTextStyles = {};
        this._optionEventHandler = (e) => {
            var _a, _b;
            if (e instanceof KeyboardEvent && e.keyCode !== 13)
                return;
            const target = e.target;
            const key = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.key;
            try {
                const onClick = (_b = this === null || this === void 0 ? void 0 : this.menuOptions[Number(key)]) === null || _b === void 0 ? void 0 : _b.onClick;
                if (onClick && typeof onClick === 'function') {
                    onClick();
                }
            }
            catch (e) {
                console.warn('Error in callback provided to <fm-menu-content>', e);
            }
            finally {
                const itemSelectedEvent = new CustomEvent('fm-item-selected', {
                    detail: {
                        selected: this.menuOptions[Number(key)].label
                    }
                });
                this.dispatchEvent(itemSelectedEvent);
            }
        };
    }
    static get styles() {
        return [unsafeCSS(menuContent)];
    }
    get menuContentClasses() {
        return {
            'fm-menu-contents': true,
            'visible': this.showMenu,
        };
    }
    // Re: ts-styled-plugin(9999) errors: https://github.com/microsoft/typescript-styled-plugin/issues/100
    render() {
        return lit_html_html `
      <div class=${classMap(this.menuContentClasses)} style="${styleMap(this.contentPositionStyles)}">
        <ul class="fm-menu-contents__list">
          ${this.menuOptions.map((item, i) => lit_html_html `
                <li class="fm-menu-contents__list__item">
                  ${item.href
            ? lit_html_html `
                      <a class="fm-menu-contents__list__item__text"
                        style="${styleMap(this.itemTextStyles)}"
                        href="${item.href}"
                        target="${item.hrefTarget || '_self'}"
                        data-key="${i}"
                        @click="${this._optionEventHandler}"
                        @keyup="${this._optionEventHandler}">
                        ${item.label || 'No label provided'}
                      </a>
                    `
            : lit_html_html `
                      <div class="fm-menu-contents__list__item__text"
                        style="${styleMap(this.itemTextStyles)}"
                        data-key="${i}"
                        tabindex="0"
                        @click="${this._optionEventHandler}"
                        @keyup="${this._optionEventHandler}">
                        ${item.label || 'No label provided'}
                      </div>
                    `}
                </li>
              `)}
        </ul>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
menuContent_decorate([
    property({ type: Array })
], menuContent_MenuContent.prototype, "menuOptions", void 0);
menuContent_decorate([
    property({ type: Boolean })
], menuContent_MenuContent.prototype, "showMenu", void 0);
menuContent_decorate([
    property({ type: String })
], menuContent_MenuContent.prototype, "contentPositionStyles", void 0);
menuContent_decorate([
    property({ type: String })
], menuContent_MenuContent.prototype, "itemTextStyles", void 0);
menuContent_MenuContent = menuContent_decorate([
    customElement('fm-menu-content')
], menuContent_MenuContent);


// EXTERNAL MODULE: ./src/components/menus/inlineMenu/menu.scss
var menu = __webpack_require__(9);

// CONCATENATED MODULE: ./src/components/menus/inlineMenu/index.ts
var inlineMenu_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let inlineMenu_InlineMenu = class InlineMenu extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.menuOptions = [];
        this._isMenuContentsVisible = false;
        this._inspectToggleEvent = (e) => {
            e instanceof KeyboardEvent && e.keyCode === 13 && this._toggleMenu();
            e instanceof MouseEvent && this._toggleMenu();
        };
        this._addCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.addEventListener(event, this._inspectCloseEvents);
            });
        };
        this._inspectCloseEvents = (e) => {
            var _a, _b;
            // esc key hit
            if (e instanceof KeyboardEvent && (e === null || e === void 0 ? void 0 : e.keyCode) === 27) {
                this._toggleMenu();
                return;
            }
            // These two trigger _toggleMenu on their own
            const toggle = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.activator');
            const menu = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.fm-inline-menu-content');
            const path = e.composedPath();
            if (!(path === null || path === void 0 ? void 0 : path.includes(toggle)) && !(path === null || path === void 0 ? void 0 : path.includes(menu))) {
                this._toggleMenu();
            }
        };
        this._removeCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.removeEventListener(event, this._inspectCloseEvents);
            });
        };
        this._toggleMenu = () => {
            if (!this._isMenuContentsVisible) {
                this._addCloseEvents();
                this._isMenuContentsVisible = true;
            }
            else {
                this._removeCloseEvents();
                this._isMenuContentsVisible = false;
            }
        };
    }
    static get styles() {
        return [unsafeCSS(menu)];
    }
    get menuClasses() {
        return {
            'fm-inline-menu': true,
            'hide': this.menuOptions.length < 1
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.menuClasses)}>
        <div class="activator-container">
          <div class="material-icons activator"
            title="Show more actions" 
            tabindex="0"
            @click="${this._inspectToggleEvent}"
            @keyup="${this._inspectToggleEvent}">
            more_vert
          </div>
        </div>
        
        <fm-menu-content class="fm-inline-menu-content"
          .showMenu="${this._isMenuContentsVisible}"
          .menuOptions=${this.menuOptions}
          .contentPositionStyles="${{ right: '100%', bottom: '0' }}"
          @fm-item-selected="${this._toggleMenu}"></fm-menu-content>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
inlineMenu_decorate([
    property({ type: Array })
], inlineMenu_InlineMenu.prototype, "menuOptions", void 0);
inlineMenu_decorate([
    internalProperty()
], inlineMenu_InlineMenu.prototype, "_isMenuContentsVisible", void 0);
inlineMenu_InlineMenu = inlineMenu_decorate([
    customElement('fm-inline-menu')
], inlineMenu_InlineMenu);


// EXTERNAL MODULE: ./src/components/cards/actionBar/actionBar.scss
var actionBar = __webpack_require__(10);

// CONCATENATED MODULE: ./src/components/cards/actionBar/index.ts
var actionBar_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let actionBar_CardActionBar = class CardActionBar extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.firstAction = null;
        this.secondAction = null;
        this.menuOptions = [];
        this._optionClickHandler = (e) => {
            var _a, _b, _c;
            if (e instanceof KeyboardEvent && e.keyCode !== 13)
                return;
            const target = e.target;
            const key = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.key;
            try {
                if (key === '0' && typeof ((_b = this === null || this === void 0 ? void 0 : this.firstAction) === null || _b === void 0 ? void 0 : _b.onClick) === 'function') {
                    this.firstAction.onClick();
                }
                else if (key === '1' && typeof ((_c = this === null || this === void 0 ? void 0 : this.secondAction) === null || _c === void 0 ? void 0 : _c.onClick) === 'function') {
                    this.secondAction.onClick();
                }
            }
            catch (e) {
                console.warn('Error in callback provided to <fm-card-action-bar>', e);
            }
        };
    }
    static get styles() {
        return [unsafeCSS(actionBar)];
    }
    get actionBarClasses() {
        return {
            'fm-topline-card-action-bar': true,
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return lit_html_html `
      <div class=${classMap(this.actionBarClasses)}>
        ${this.firstAction
            ? this.firstAction.href
                ? lit_html_html `
              <a class="material-icons option"
                href="${this.firstAction.href}"
                target="${this.firstAction.hrefTarget || '_self'}"
                data-key="0"
                title="${((_a = this === null || this === void 0 ? void 0 : this.firstAction) === null || _a === void 0 ? void 0 : _a.hoverText) || 'No assistive text provided'}"
                @click="${this._optionClickHandler}"
                @keyup="${this._optionClickHandler}">
                ${((_b = this === null || this === void 0 ? void 0 : this.firstAction) === null || _b === void 0 ? void 0 : _b.icon) || ''}
              </a>
            `
                : lit_html_html `
              <span class="material-icons option"
                tabindex="0"
                data-key="0"
                title="${((_c = this === null || this === void 0 ? void 0 : this.firstAction) === null || _c === void 0 ? void 0 : _c.hoverText) || 'No assistive text provided'}"
                @click="${this._optionClickHandler}"
                @keyup="${this._optionClickHandler}">
                ${((_d = this === null || this === void 0 ? void 0 : this.firstAction) === null || _d === void 0 ? void 0 : _d.icon) || ''}
              </span>
            `
            : null}
          ${this.secondAction
            ? this.secondAction.href
                ? lit_html_html `
              <a class="material-icons option"
                href="${this.secondAction.href}"
                target="${this.secondAction.hrefTarget || '_self'}"
                data-key="1"
                title="${((_e = this === null || this === void 0 ? void 0 : this.secondAction) === null || _e === void 0 ? void 0 : _e.hoverText) || 'No assistive text provided'}"
                @click="${this._optionClickHandler}"
                @keyup="${this._optionClickHandler}">
                ${((_f = this === null || this === void 0 ? void 0 : this.secondAction) === null || _f === void 0 ? void 0 : _f.icon) || ''}
              </a>
            `
                : lit_html_html `
              <span class="material-icons option"
                tabindex="0"
                data-key="1"
                title="${((_g = this === null || this === void 0 ? void 0 : this.secondAction) === null || _g === void 0 ? void 0 : _g.hoverText) || 'No assistive text provided'}"
                @click="${this._optionClickHandler}"
                @keyup="${this._optionClickHandler}">
                ${((_h = this === null || this === void 0 ? void 0 : this.secondAction) === null || _h === void 0 ? void 0 : _h.icon) || ''}
              </span>
            `
            : null}
        <fm-inline-menu class="action-bar" .menuOptions="${this.menuOptions}"/>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
actionBar_decorate([
    property({ type: Object })
], actionBar_CardActionBar.prototype, "firstAction", void 0);
actionBar_decorate([
    property({ type: Object })
], actionBar_CardActionBar.prototype, "secondAction", void 0);
actionBar_decorate([
    property({ type: Array })
], actionBar_CardActionBar.prototype, "menuOptions", void 0);
actionBar_CardActionBar = actionBar_decorate([
    customElement('fm-card-action-bar')
], actionBar_CardActionBar);


// EXTERNAL MODULE: ./src/components/cards/cardLayout/cardLayout.scss
var cardLayout = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/cards/cardLayout/index.ts
var cardLayout_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let cardLayout_CardLayout = class CardLayout extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.product = 'topline';
        this.collapseImage = false;
    }
    static get styles() {
        return [unsafeCSS(cardLayout)];
    }
    get cardClasses() {
        return {
            'fm-card-topline-layout': this.product.toLowerCase() === 'topline',
            'collapse-image': this.collapseImage
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.cardClasses)}>
        <div class="image-container">
          <slot name="image"></slot>
        </div>
        
        <div class="meta-container">
          <slot name="meta"></slot>
        </div>

        <div class="main-content-container">
          <slot name="content"></slot>
        </div>
  
        <div class="action-bar-container">
          <slot name="actionBar"></slot>
        </div>
      </div>
    `;
    }
};
cardLayout_decorate([
    property({ type: String })
], cardLayout_CardLayout.prototype, "product", void 0);
cardLayout_decorate([
    property({ type: Boolean })
], cardLayout_CardLayout.prototype, "collapseImage", void 0);
cardLayout_CardLayout = cardLayout_decorate([
    customElement('fm-card-layout')
], cardLayout_CardLayout);


// EXTERNAL MODULE: ./src/components/navigation/clusterSwitcherBar.scss
var clusterSwitcherBar = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/navigation/clusterSwitcherBar.ts
var clusterSwitcherBar_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let clusterSwitcherBar_ClusterSwitcherBar = class ClusterSwitcherBar extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this._toggleDropdown = (e = null) => {
            if (e && typeof e.keyCode !== 'undefined' && e.keyCode !== 13) {
                return;
            }
            if (this._dropdownVisible()) {
                this._hideDropdown();
                window.removeEventListener('click', this._windowClickedHandler);
            }
            else {
                this._showDropdown();
                window.addEventListener('click', this._windowClickedHandler, {});
            }
        };
        this._windowClickedHandler = (e) => {
            var _a, _b;
            const path = e.composedPath();
            // These two call _toggleDropdown on their own
            const currentCluster = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('span.current-cluster');
            const toggle = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('span.toggle');
            // don't call _toggleDropdown if either of these were clicked
            // Otherwise they will toggle it open and this next line would immediately toggle it closed.
            if (!path.includes(currentCluster) &&
                !path.includes(toggle)) {
                this._toggleDropdown();
            }
        };
        this._keyupHandler = (e = null, onClick) => {
            if (e && typeof e.keyCode !== 'undefined' && e.keyCode !== 13) {
                return;
            }
            onClick();
            this._toggleDropdown();
        };
        this._dropdownVisible = () => {
            var _a;
            const dropdown = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('div.options-dropdown');
            return (dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.contains('visible')) || false;
        };
        this._hideDropdown = () => {
            var _a;
            const dropdown = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('div.options-dropdown');
            dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.remove('visible');
        };
        this._showDropdown = () => {
            var _a;
            const dropdown = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('div.options-dropdown');
            if (!(dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.contains('visible'))) {
                dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.add('visible');
            }
        };
        this.currentCluster = '';
        this.darkText = false;
        this.clusters = [];
    }
    static get styles() {
        return [unsafeCSS(clusterSwitcherBar)];
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
    render() {
        if (!this.clusters.length) {
            return lit_html_html ` <div class="container"></div> `;
        }
        return lit_html_html `
      <div class="container manager">
        <span class="${this.darkText ? 'dark-text' : ''}">You are viewing</span>
        <span
          class="current-cluster ${this.darkText ? 'dark-text' : ''}"
          @click="${this._toggleDropdown}"
          >${this.currentCluster}</span
        >
        <div class="cluster-select">
          <span
            class="material-icons toggle ${this.darkText ? 'dark-text' : ''}"
            tabindex="0"
            @keyup=${(e) => this._toggleDropdown(e)}
            @click="${this._toggleDropdown}"
          >
            expand_more
          </span>
          <div class="options-dropdown">
            <span class="triangle"></span>
            ${this.clusters.map((cluster) => lit_html_html `
                <div
                  class="list-item"
                  @click=${cluster.onClick}
                  @keyup=${(e) => this._keyupHandler(e, cluster.onClick)}
                  tabindex="0"
                >
                  <span>${cluster.name}</span>
                  <span class="material-icons go-to">chevron_right</span>
                </div>
                <hr />
              `)}
          </div>
        </div>

        <div class="spacer"></div>
        <slot name="messages"></slot>
      </div>
    `;
    }
};
clusterSwitcherBar_decorate([
    property({ type: String })
], clusterSwitcherBar_ClusterSwitcherBar.prototype, "currentCluster", void 0);
clusterSwitcherBar_decorate([
    property({ type: Boolean })
], clusterSwitcherBar_ClusterSwitcherBar.prototype, "darkText", void 0);
clusterSwitcherBar_decorate([
    property({ type: Array })
], clusterSwitcherBar_ClusterSwitcherBar.prototype, "clusters", void 0);
clusterSwitcherBar_ClusterSwitcherBar = clusterSwitcherBar_decorate([
    customElement('fm-cluster-switcher-bar')
], clusterSwitcherBar_ClusterSwitcherBar);


// EXTERNAL MODULE: ./src/components/banner/error/errorBanner.scss
var errorBanner = __webpack_require__(13);

// CONCATENATED MODULE: ./src/components/banner/error/index.ts
var error_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let error_ErrorBanner = class ErrorBanner extends banner_Banner {
    constructor() {
        super(...arguments);
        this.icon = 'report_problem';
    }
    static get styles() {
        return [...super.styles, unsafeCSS(errorBanner)];
    }
};
error_ErrorBanner = error_decorate([
    customElement('fm-banner-error')
], error_ErrorBanner);


// EXTERNAL MODULE: ./src/components/banner/info/infoBanner.scss
var infoBanner = __webpack_require__(14);

// CONCATENATED MODULE: ./src/components/banner/info/index.ts
var info_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let info_InfoBanner = class InfoBanner extends banner_Banner {
    constructor() {
        super(...arguments);
        this.icon = 'error_outline';
    }
    static get styles() {
        return [...super.styles, unsafeCSS(infoBanner)];
    }
};
info_InfoBanner = info_decorate([
    customElement('fm-banner-info')
], info_InfoBanner);


// CONCATENATED MODULE: ./src/components/icons/analytics.ts
var analytics_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let analytics_Analytics = class Analytics extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <style>
            .a {
              fill: #222046;
            }
            .b {
              fill: none;
            }
          </style>
        </defs>
        <path
          class="a"
          d="M3058.482,323.036l-7.253,1.095,2.111,2.111-4.194,4.195-2.2-2.064-5.578,5.718-2.031-2.031-6.442,6.3,1.916,1.954,4.5-4.413,2.074,2.074,5.646-5.773,2.178,2.041,6.068-6.067,2.111,2.11Zm-4.105,10.947v15.053h2.737V333.983Zm-5.474,2.737v12.316h2.737V336.72Zm-5.474,2.737v9.579h2.737v-9.579Zm-5.474,2.737v6.842h2.737v-6.842Zm-5.474,2.737v4.105h2.737v-4.105Z"
          transform="translate(-3029.482 -320.036)"
        />
        <rect class="b" width="32" height="32" />
      </svg>
    `;
    }
};
analytics_Analytics = analytics_decorate([
    customElement('fm-icon-analytics')
], analytics_Analytics);


// CONCATENATED MODULE: ./src/components/icons/audioLibrary.ts
var audioLibrary_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let audioLibrary_AudioLibrary = class AudioLibrary extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        library_music
      </span>
    `;
    }
};
audioLibrary_AudioLibrary = audioLibrary_decorate([
    customElement('fm-icon-audio-library')
], audioLibrary_AudioLibrary);


// CONCATENATED MODULE: ./src/components/icons/book.ts
var book_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let book_Book = class Book extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <style>
          .a {
            fill: none;
          }
          .b {
            fill: #222046;
          }
        </style>
      </defs>
      <rect class="a" width="32" height="32" />
      <path
        class="b"
        d="M18.8,4a3.6,3.6,0,0,0-3.6,3.6V20.8H12.8V7.6A3.6,3.6,0,0,0,9.2,4H2V20.8a2.4,2.4,0,0,0,2.4,2.4h7.532a2.381,2.381,0,0,0,4.135,0H23.6A2.4,2.4,0,0,0,26,20.8V4Z"
        transform="translate(2 2)"
      />
    </svg>`;
    }
};
book_Book = book_decorate([
    customElement('fm-icon-book')
], book_Book);


// CONCATENATED MODULE: ./src/components/icons/chevronDown.ts
var chevronDown_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let chevronDown_ChevronDown = class ChevronDown extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        expand_more
      </span>
    `;
    }
};
chevronDown_ChevronDown = chevronDown_decorate([
    customElement('fm-icon-chevron-down')
], chevronDown_ChevronDown);


// CONCATENATED MODULE: ./src/components/icons/chevronUp.ts
var chevronUp_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let chevronUp_ChevronUp = class ChevronUp extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        expand_less
      </span>
    `;
    }
};
chevronUp_ChevronUp = chevronUp_decorate([
    customElement('fm-icon-chevron-up')
], chevronUp_ChevronUp);


// CONCATENATED MODULE: ./src/components/icons/dollar.ts
var dollar_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let dollar_Dollar = class Dollar extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        attach_money
      </span>
    `;
    }
};
dollar_Dollar = dollar_decorate([
    customElement('fm-icon-dollar')
], dollar_Dollar);


// CONCATENATED MODULE: ./src/components/icons/doubleChevronLeft.ts
var doubleChevronLeft_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let doubleChevronLeft_DoubleChevronLeft = class DoubleChevronLeft extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.color = '#532aa2';
    }
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
      >
        <defs>
          <style>
            .a {
              fill: none;
            }
            .b {
              fill: ${this.color};
            }
          </style>
        </defs>
        <rect class="a" width="24" height="24" />
        <path
          class="b"
          d="M20194.992-1818.42l-6.574-6.569a1.424,1.424,0,0,1,0-2.017l6.574-6.574a1.426,1.426,0,0,1,2.018,0,1.442,1.442,0,0,1,0,2.017l-5.557,5.556,5.557,5.571a1.427,1.427,0,0,1,0,2.017,1.425,1.425,0,0,1-1.01.418A1.42,1.42,0,0,1,20194.992-1818.42Zm-7,0-6.574-6.569a1.424,1.424,0,0,1,0-2.017l6.574-6.574a1.426,1.426,0,0,1,2.018,0,1.442,1.442,0,0,1,0,2.017l-5.557,5.556,5.557,5.571a1.427,1.427,0,0,1,0,2.017,1.425,1.425,0,0,1-1.01.418A1.42,1.42,0,0,1,20187.992-1818.42Z"
          transform="translate(-20178 1838)"
        />
      </svg>
    `;
    }
};
doubleChevronLeft_decorate([
    property({ type: String })
], doubleChevronLeft_DoubleChevronLeft.prototype, "color", void 0);
doubleChevronLeft_DoubleChevronLeft = doubleChevronLeft_decorate([
    customElement('fm-icon-double-chevron-left')
], doubleChevronLeft_DoubleChevronLeft);


// CONCATENATED MODULE: ./src/components/icons/doubleChevronRight.ts
var doubleChevronRight_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let doubleChevronRight_DoubleChevronRight = class DoubleChevronRight extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.color = '#532aa2';
    }
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
      >
        <defs>
          <style>
            .a {
              fill: none;
            }
            .b {
              fill: ${this.color};
            }
          </style>
        </defs>
        <rect class="a" width="24" height="24" />
        <path
          class="b"
          d="M20141.418-1818.417a1.434,1.434,0,0,1,0-2.023l5.563-5.558-5.562-5.563a1.428,1.428,0,0,1,0-2.018,1.44,1.44,0,0,1,2.023-.015l6.574,6.579a1.421,1.421,0,0,1,0,2.018l-6.574,6.579a1.439,1.439,0,0,1-1.014.417A1.42,1.42,0,0,1,20141.418-1818.417Zm-7,0a1.427,1.427,0,0,1,0-2.023l5.559-5.558-5.559-5.563a1.421,1.421,0,0,1,0-2.018,1.44,1.44,0,0,1,2.023-.015l6.574,6.579a1.428,1.428,0,0,1,0,2.018l-6.574,6.579a1.435,1.435,0,0,1-1.014.417A1.426,1.426,0,0,1,20134.418-1818.417Z"
          transform="translate(-20129.398 1838)"
        />
      </svg>
    `;
    }
};
doubleChevronRight_decorate([
    property({ type: String })
], doubleChevronRight_DoubleChevronRight.prototype, "color", void 0);
doubleChevronRight_DoubleChevronRight = doubleChevronRight_decorate([
    customElement('fm-icon-double-chevron-right')
], doubleChevronRight_DoubleChevronRight);


// CONCATENATED MODULE: ./src/components/icons/equalizer.ts
var equalizer_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let equalizer_Equalizer = class Equalizer extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        graphic_eq
      </span>
    `;
    }
};
equalizer_Equalizer = equalizer_decorate([
    customElement('fm-icon-equalizer')
], equalizer_Equalizer);


// CONCATENATED MODULE: ./src/components/icons/folder.ts
var folder_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let folder_Folder = class Folder extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        folder
      </span>
    `;
    }
};
folder_Folder = folder_decorate([
    customElement('fm-icon-folder')
], folder_Folder);


// CONCATENATED MODULE: ./src/components/icons/gear.ts
var gear_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let gear_Gear = class Gear extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        settings
      </span>
    `;
    }
};
gear_Gear = gear_decorate([
    customElement('fm-icon-gear')
], gear_Gear);


// CONCATENATED MODULE: ./src/components/icons/help.ts
var help_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let help_HelpPurple = class HelpPurple extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.333"
        height="13.333"
        viewBox="0 0 13.333 13.333"
      >
        <defs>
          <style>
            .a {
              fill: #532aa2;
            }
          </style>
        </defs>
        <path
          class="a"
          d="M8.667,2a6.667,6.667,0,1,0,6.667,6.667A6.669,6.669,0,0,0,8.667,2Zm.667,11.333H8V12H9.333Zm1.38-5.167-.6.613a2.27,2.27,0,0,0-.78,1.887H8v-.333a2.683,2.683,0,0,1,.78-1.887l.827-.84A1.3,1.3,0,0,0,10,6.667a1.333,1.333,0,0,0-2.667,0H6a2.667,2.667,0,0,1,5.333,0A2.121,2.121,0,0,1,10.713,8.167Z"
          transform="translate(-2 -2)"
        />
      </svg>
    `;
    }
};
help_HelpPurple = help_decorate([
    customElement('fm-icon-help-purple')
], help_HelpPurple);


// CONCATENATED MODULE: ./src/components/icons/inspectChart.ts
var inspectChart_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let inspectChart_InspectChart = class InspectChart extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25.704"
        height="26"
        viewBox="0 0 25.704 26"
      >
        <defs>
          <style>
            .a {
              fill: #222046;
            }
          </style>
        </defs>
        <path
          class="a"
          d="M19.993,1.77,15.454,8.492H11.737L10.344,9.93,8.978,8.492H5.113A6.431,6.431,0,0,1,11,4.636a6.361,6.361,0,0,1,3.311.946l1.446-2.141A8.991,8.991,0,1,0,11,20.058a8.948,8.948,0,0,0,5.881-2.206l.545.545v1.662l7.711,7.711L27.7,25.2l-7.711-7.711H18.331l-.545-.545a8.948,8.948,0,0,0,2.206-5.881A8.808,8.808,0,0,0,19.222,7.5l.771-1.14,3.173,4.7H27.7V8.492H24.531Zm-2.626,8.482a6.143,6.143,0,0,1,.055.811,6.426,6.426,0,1,1-12.852,0h3.3l2.447,2.583,2.505-2.583H16.82Z"
          transform="translate(-2 -1.77)"
        />
      </svg>
    `;
    }
};
inspectChart_InspectChart = inspectChart_decorate([
    customElement('fm-icon-inspect-chart')
], inspectChart_InspectChart);


// CONCATENATED MODULE: ./src/components/icons/link.ts
var link_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let link_Link = class Link extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        link
      </span>
    `;
    }
};
link_Link = link_decorate([
    customElement('fm-icon-link')
], link_Link);


// CONCATENATED MODULE: ./src/components/icons/meeting.ts
var meeting_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let meeting_Meeting = class Meeting extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <style>
            .a {
              fill: none;
            }
            .b {
              fill: #222046;
            }
          </style>
        </defs>
        <rect class="a" width="32" height="32" />
        <path
          class="b"
          d="M6.9,2A2.6,2.6,0,1,0,9.5,4.6,2.6,2.6,0,0,0,6.9,2ZM22.5,2a2.6,2.6,0,1,0,2.6,2.6A2.6,2.6,0,0,0,22.5,2ZM5.6,9.8A2.6,2.6,0,0,0,3,12.4V26.7a1.3,1.3,0,0,0,2.6,0V20.2H8.2v6.5a1.3,1.3,0,0,0,2.6,0V15.221L13.781,18.2a1.3,1.3,0,0,0,1.838,0L18.6,15.221V26.7a1.3,1.3,0,0,0,2.6,0V20.2h2.6v6.5a1.3,1.3,0,1,0,2.6,0V12.4a2.6,2.6,0,0,0-2.6-2.6H21.2a2.589,2.589,0,0,0-1.846.772l0,0L14.7,15.223l-4.662-4.662-.033-.036L10,10.531A2.586,2.586,0,0,0,8.2,9.8Z"
          transform="translate(1 1)"
        />
      </svg>
    `;
    }
};
meeting_Meeting = meeting_decorate([
    customElement('fm-icon-meeting')
], meeting_Meeting);


// CONCATENATED MODULE: ./src/components/icons/news.ts
var news_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let news_News = class News extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <style>
            .a {
              fill: none;
            }
            .b {
              fill: #222046;
            }
          </style>
        </defs>
        <rect class="a" width="32" height="32" />
        <path
          class="b"
          d="M4.6,3A2.6,2.6,0,0,0,2,5.6V22.5a3.9,3.9,0,0,0,3.9,3.9H24.1A3.92,3.92,0,0,0,28,22.5V9.5a1.3,1.3,0,1,0-2.6,0v13a1.279,1.279,0,0,1-1.3,1.3,1.3,1.3,0,0,1-1.3-1.3V5.6A2.6,2.6,0,0,0,20.2,3ZM8.5,6.9h7.8a1.3,1.3,0,0,1,1.3,1.3V9.5a1.3,1.3,0,0,1-1.3,1.3H8.5A1.3,1.3,0,0,1,7.2,9.5V8.2A1.3,1.3,0,0,1,8.5,6.9Zm0,7.8h7.8a1.3,1.3,0,1,1,0,2.6H8.5a1.3,1.3,0,1,1,0-2.6Zm0,5.2h7.8a1.3,1.3,0,1,1,0,2.6H8.5a1.3,1.3,0,1,1,0-2.6Z"
          transform="translate(1 1)"
        />
      </svg>
    `;
    }
};
news_News = news_decorate([
    customElement('fm-icon-news')
], news_News);


// CONCATENATED MODULE: ./src/components/icons/planner.ts
var planner_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let planner_Planner = class Planner extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
    >
      <defs>
        <style>
          .a {
            fill: none;
          }
          .b {
            fill: #222046;
          }
        </style>
      </defs>
      <rect class="a" width="32" height="32" />
      <path
        class="b"
        d="M12,1A2.991,2.991,0,0,0,9.184,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2h5.588a7.849,7.849,0,0,1-.328-1h0c-.03-.118-.045-.241-.07-.361-.044-.212-.1-.422-.123-.639A7.668,7.668,0,0,1,10,18a8,8,0,0,1,8-8,7.668,7.668,0,0,1,1,.068c.217.027.428.079.639.123.12.026.243.04.361.07v0a7.849,7.849,0,0,1,1,.328V5a2,2,0,0,0-2-2H14.816A2.991,2.991,0,0,0,12,1Zm0,2a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm6,9a6,6,0,1,0,6,6A6.018,6.018,0,0,0,18,12Zm0,2a4,4,0,1,1-4,4A4.012,4.012,0,0,1,18,14Zm.9,1.2-1.7,2.9,2.2,2.2.9-1-1.5-1.4L20,15.8Z"
        transform="translate(-1)"
      />
    </svg>`;
    }
};
planner_Planner = planner_decorate([
    customElement('fm-icon-planner')
], planner_Planner);


// CONCATENATED MODULE: ./src/components/icons/plug.ts
var plug_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let plug_Plug = class Plug extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        power
      </span>
    `;
    }
};
plug_Plug = plug_decorate([
    customElement('fm-icon-plug')
], plug_Plug);


// CONCATENATED MODULE: ./src/components/icons/podcast.ts
var podcast_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let podcast_Podcast = class Podcast extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <style>
          .a {
            fill: none;
          }
          .b {
            fill: #222046;
          }
        </style>
      </defs>
      <rect class="a" width="32" height="32" />
      <path
        class="b"
        d="M14.552,1A12.548,12.548,0,0,0,8.761,24.682a.966.966,0,0,0,.894-1.712,10.62,10.62,0,1,1,9.8,0,.966.966,0,1,0,.892,1.712A12.548,12.548,0,0,0,14.552,1Zm0,3.862A8.685,8.685,0,0,0,8.515,19.8a.966.966,0,1,0,1.343-1.39,6.759,6.759,0,1,1,9.387,0,.966.966,0,0,0,1.343,1.39A8.685,8.685,0,0,0,14.552,4.862Zm0,5.793a2.9,2.9,0,1,0,2.9,2.9,2.9,2.9,0,0,0-2.9-2.9Zm0,7.724a2.9,2.9,0,0,0-2.9,2.9,2.861,2.861,0,0,0,.043.419h-.011l.026.153c0,.006,0,.013,0,.019l.92,5.433.008,0a1.921,1.921,0,0,0,3.817,0l.008,0,.92-5.433c0-.006,0-.013,0-.019l.026-.153H17.4a2.861,2.861,0,0,0,.043-.419A2.9,2.9,0,0,0,14.552,18.379Z"
        transform="translate(1 1)"
      />
    </svg>`;
    }
};
podcast_Podcast = podcast_decorate([
    customElement('fm-icon-podcast')
], podcast_Podcast);


// CONCATENATED MODULE: ./src/components/icons/presentation.ts
var presentation_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let presentation_Presentation = class Presentation extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <style>
            .a {
              fill: none;
            }
            .b {
              fill: #222046;
            }
          </style>
        </defs>
        <rect class="a" width="32" height="32" />
        <path
          class="b"
          d="M27.727,3H2.273A1.273,1.273,0,0,0,1,4.273H1A1.273,1.273,0,0,0,2.273,5.545h0v14a2.545,2.545,0,0,0,2.545,2.545h8.909v2.545A1.273,1.273,0,0,0,15,25.909h0a1.273,1.273,0,0,0,1.273-1.273V22.091h8.909a2.545,2.545,0,0,0,2.545-2.545v-14h0A1.273,1.273,0,0,0,29,4.273h0A1.273,1.273,0,0,0,27.727,3ZM14.921,14.08A5.094,5.094,0,1,1,9.011,8.17a.772.772,0,0,1,.9.762v4.25h4.25A.772.772,0,0,1,14.921,14.08Zm10.261,1.647h0A1.273,1.273,0,0,1,23.909,17H18.818a1.273,1.273,0,0,1-1.273-1.273h0a1.273,1.273,0,0,1,1.273-1.273h5.091A1.273,1.273,0,0,1,25.182,15.727Zm-7.636-5.091h0a1.273,1.273,0,0,1,1.273-1.273h5.091a1.273,1.273,0,0,1,1.273,1.273h0a1.273,1.273,0,0,1-1.273,1.273H18.818A1.273,1.273,0,0,1,17.545,10.636Z"
          transform="translate(1 2)"
        />
      </svg>
    `;
    }
};
presentation_Presentation = presentation_decorate([
    customElement('fm-icon-presentation')
], presentation_Presentation);


// CONCATENATED MODULE: ./src/components/icons/rssFeed.ts
var rssFeed_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let rssFeed_RSSFeed = class RSSFeed extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        rss_feed
      </span>
    `;
    }
};
rssFeed_RSSFeed = rssFeed_decorate([
    customElement('fm-icon-rss-feed')
], rssFeed_RSSFeed);


// CONCATENATED MODULE: ./src/components/icons/tag.ts
var tag_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let tag_Tag = class Tag extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        local_offer
      </span>
    `;
    }
};
tag_Tag = tag_decorate([
    customElement('fm-icon-tag')
], tag_Tag);


// CONCATENATED MODULE: ./src/components/icons/videoCam.ts
var videoCam_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let videoCam_VideoCam = class VideoCam extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        videocam
      </span>
    `;
    }
};
videoCam_VideoCam = videoCam_decorate([
    customElement('fm-icon-video-cam')
], videoCam_VideoCam);


// CONCATENATED MODULE: ./src/components/icons/upload.ts
var upload_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let upload_Upload = class Upload extends lit_element_LitElement {
    static get styles() {
        return unsafeCSS(icon);
    }
    render() {
        return lit_html_html `
      <span class="material-icons md-32">
        publish
      </span>
    `;
    }
};
upload_Upload = upload_decorate([
    customElement('fm-icon-upload')
], upload_Upload);


// CONCATENATED MODULE: ./src/components/icons/index.ts


























// EXTERNAL MODULE: ./src/components/heading/heading.scss
var heading = __webpack_require__(15);

// CONCATENATED MODULE: ./src/components/heading/index.ts
var heading_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let heading_Heading = class Heading extends lit_element_LitElement {
    static get styles() {
        return [unsafeCSS(heading)];
    }
    render() {
        return lit_html_html `
      <div class="fm-heading">
        <slot></slot>
      </div>
    `;
    }
};
heading_Heading = heading_decorate([
    customElement('fm-heading')
], heading_Heading);


// EXTERNAL MODULE: ./src/components/navigation/leftNavigation.scss
var leftNavigation = __webpack_require__(16);

// CONCATENATED MODULE: ./src/components/navigation/leftNavigation.ts
var leftNavigation_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let leftNavigation_LeftNavigation = class LeftNavigation extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this._isActive = (text) => {
            return text.toLowerCase() === this.activeItem.toLowerCase();
        };
        this._getIcon = (match) => {
            switch (match) {
                // TopLine icons
                case 'inspect-chart':
                    return lit_html_html `<fm-icon-inspect-chart />`;
                case 'book':
                    return lit_html_html `<fm-icon-book />`;
                case 'news':
                    return lit_html_html `<fm-icon-news />`;
                case 'dollar':
                    return lit_html_html `<fm-icon-dollar />`;
                case 'meeting':
                    return lit_html_html `<fm-icon-meeting />`;
                case 'presentation':
                    return lit_html_html `<fm-icon-presentation />`;
                case 'folder':
                    return lit_html_html `<fm-icon-folder />`;
                case 'analytics':
                    return lit_html_html `<fm-icon-analytics />`;
                case 'gear':
                    return lit_html_html `<fm-icon-gear />`;
                case 'podcast':
                    return lit_html_html `<fm-icon-podcast />`;
                case 'equalizer':
                    return lit_html_html `<fm-icon-equalizer />`;
                case 'link':
                    return lit_html_html `<fm-icon-link />`;
                case 'audio-library':
                    return lit_html_html `<fm-icon-audio-library />`;
                case 'plug':
                    return lit_html_html `<fm-icon-plug />`;
                case 'tag':
                    return lit_html_html `<fm-icon-tag />`;
                case 'upload':
                    return lit_html_html `<fm-icon-upload />`;
                case 'planner':
                    return lit_html_html `<fm-icon-planner />`;
                case 'rss-feed':
                    return lit_html_html `<fm-icon-rss-feed />`;
                case 'video-cam':
                    return lit_html_html `<fm-icon-video-cam />`;
                default:
                    return lit_html_html `<fm-icon-help-purple />`;
            }
        };
        this._handleClickedNavItem = (newActive, onClick) => {
            this.activeItem = newActive;
            onClick();
        };
        this._handleKeyedNavItem = (e, newActive, onClick) => {
            if (typeof e.keyCode !== 'undefined' && e.keyCode !== 13) {
                return;
            }
            this.activeItem = newActive;
            onClick();
            // Remove the focus
            let target = e.target;
            while (target && !target.classList.contains('nav-item')) {
                target = target.parentElement;
            }
            if (target) {
                target.blur();
            }
        };
        this._handleKeyupHelp = (e) => {
            if (typeof e.keyCode !== 'undefined' && e.keyCode !== 13) {
                return;
            }
            this.goToHelp();
        };
        this._toggleCollapse = (e) => {
            var _a, _b, _c, _d;
            // Catch key-ups that are not the enter/return key
            if (e && typeof e.keyCode !== 'undefined' && e.keyCode !== 13) {
                return;
            }
            const container = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('nav.container');
            const headers = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('h4,h5');
            const dividers = (_c = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('span.divider');
            const footerSpans = (_d = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelectorAll('.footer span');
            if (container === null || container === void 0 ? void 0 : container.classList.contains('collapsed')) {
                // logic for expanding sidebar, showing nav item names
                container.classList.remove('collapsed');
                headers === null || headers === void 0 ? void 0 : headers.forEach((hItem) => (hItem.style.display = 'block'));
                dividers === null || dividers === void 0 ? void 0 : dividers.forEach((divider) => (divider.style.display = 'none'));
                footerSpans === null || footerSpans === void 0 ? void 0 : footerSpans.forEach((span) => (span.style.display = 'inline'));
            }
            else {
                // logic for expanding sidebar, showing nav item names
                headers === null || headers === void 0 ? void 0 : headers.forEach((hItem) => (hItem.style.display = 'none'));
                dividers === null || dividers === void 0 ? void 0 : dividers.forEach((divider) => (divider.style.display = 'block'));
                footerSpans === null || footerSpans === void 0 ? void 0 : footerSpans.forEach((span) => (span.style.display = 'none'));
                container === null || container === void 0 ? void 0 : container.classList.add('collapsed');
            }
        };
        this.activeItem = 'default props';
        this.goToHelp = () => { };
        this.sections = [];
    }
    static get styles() {
        return unsafeCSS(leftNavigation);
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
    render() {
        return lit_html_html `
      <nav class="container">
        <!-- Contains all nav groups-->
        <div class="nav-items">
          ${this.sections.map((section, index) => lit_html_html `
              <!-- Contains a single group of nav items -->
              <div class="nav-group">
                ${section.title
            ? lit_html_html `
                      <span
                        class="divider ${index === 0 ? 'invisible' : ''}"
                      ></span>
                      <fm-heading>
                        <h5>${section.title}</h5>
                      </fm-heading>
                    `
            : ''}
                ${section.items.map((item) => lit_html_html ` <div
                      class="nav-item"
                      tabindex="0"
                      @keyup=${(e) => this._handleKeyedNavItem(e, item.text, item.onClick)}
                      @click=${() => this._handleClickedNavItem(item.text, item.onClick)}
                    >
                      <span
                        class=${this._isActive(item.text) ? 'active' : ''}
                      ></span>
                      <div class="icon-area">
                        ${this._getIcon(item.iconName)}
                      </div>
                      <fm-heading>
                        <h4>${item.text}</h4>
                      </fm-heading>
                    </div>`)}
              </div>
            `)}
        </div>

        <div class="footer">
          <div class="get-help">
            <fm-icon-help-purple
              tabindex="0"
              @click="${this.goToHelp}"
              @keyup=${(e) => this._handleKeyupHelp(e)}
            ></fm-icon-help-purple>
            <span @click="${this.goToHelp}">
              Get help
            </span>
          </div>
          <div class="collapse-controls" @click="${this._toggleCollapse}">
            <div
              class="icon"
              tabindex="0"
              @keyup=${(e) => this._toggleCollapse(e)}
            >
              <fm-icon-double-chevron-left></fm-icon-double-chevron-left>
              <fm-icon-double-chevron-right></fm-icon-double-chevron-right>
            </div>
            <span>
              Collapse Sidebar
            </span>
          </div>
        </div>
      </nav>
    `;
    }
};
leftNavigation_decorate([
    property({ type: String })
], leftNavigation_LeftNavigation.prototype, "activeItem", void 0);
leftNavigation_decorate([
    property()
], leftNavigation_LeftNavigation.prototype, "goToHelp", void 0);
leftNavigation_decorate([
    property({ type: Array })
], leftNavigation_LeftNavigation.prototype, "sections", void 0);
leftNavigation_LeftNavigation = leftNavigation_decorate([
    customElement('fm-left-navigation')
], leftNavigation_LeftNavigation);


// EXTERNAL MODULE: ./src/components/link/link.scss
var link_link = __webpack_require__(17);

// CONCATENATED MODULE: ./src/components/link/index.ts
var components_link_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let components_link_Link = class Link extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.href = '#';
        this.target = '_blank';
        this.external = false;
    }
    static get styles() {
        return [unsafeCSS(link_link)];
    }
    render() {
        if (this.external) {
            return lit_html_html `
        <a href=${this.href} class="fm-link">
          <slot></slot>
        </a>
      `;
        }
        return lit_html_html `
      <span class="fm-link" tabindex="0">
        <slot></slot>
      </span>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
components_link_decorate([
    property({ type: String })
], components_link_Link.prototype, "href", void 0);
components_link_decorate([
    property({ type: String })
], components_link_Link.prototype, "target", void 0);
components_link_decorate([
    property({ type: Boolean })
], components_link_Link.prototype, "external", void 0);
components_link_Link = components_link_decorate([
    customElement('fm-link')
], components_link_Link);


// EXTERNAL MODULE: ./src/components/modal/modal.scss
var modal = __webpack_require__(18);

// CONCATENATED MODULE: ./src/components/modal/index.ts
var modal_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let modal_Modal = class Modal extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.visible = false;
    }
    static get styles() {
        return [unsafeCSS(modal)];
    }
    get modalClasses() {
        return {
            'fm-modal': true,
            'fm-modal-visible': this.visible
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.modalClasses)}>
        <div class="fm-modal__backdrop"></div>
        <div class="fm-modal__content-container">
          <slot name="controlRow"></slot>
          <slot class="fm-modal__content-container__content" name="content"></slot>
          <slot name="actionRow"></slot>
        </div>
      </div>
    `;
    }
};
modal_decorate([
    property({ type: Boolean })
], modal_Modal.prototype, "visible", void 0);
modal_Modal = modal_decorate([
    customElement('fm-modal')
], modal_Modal);


// EXTERNAL MODULE: ./src/components/navigation/footer.scss
var footer = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/navigation/footer.ts
var footer_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let footer_NavFooter = class NavFooter extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this._toggleMenu = (e) => {
            const target = e.target;
            if (!target) {
                return;
            }
            // Handle Keyboard cases
            const keyEvent = e;
            if (keyEvent &&
                typeof keyEvent.keyCode !== 'undefined' &&
                keyEvent.keyCode !== 13) {
                return;
            }
            // Get a reference to the <ul> of this menu list
            // and the toggler icon, which needs to be rotated
            let traverser = target;
            while (traverser && !traverser.classList.contains('toggle-menu')) {
                traverser = traverser.parentElement;
            }
            const icon = traverser === null || traverser === void 0 ? void 0 : traverser.lastElementChild;
            const list = traverser === null || traverser === void 0 ? void 0 : traverser.nextElementSibling;
            if (list.classList.contains('expanded')) {
                // hide the menu
                list.classList.remove('expanded');
                list.classList.add('hidden');
                icon ? (icon.style.transform = 'rotate(0deg)') : '';
                // After the classes have completed their css height transitions
                setTimeout(() => {
                    list ? list.style.removeProperty('display') : '';
                }, 500);
            }
            else {
                // show the menu
                //prepare for the css transitions by making the UL part of the document flow
                list ? (list.style.display = 'block') : '';
                icon ? (icon.style.transform = 'rotate(180deg)') : '';
                // the timeout is for a race condition, make sure the display:block is in place
                // before the css transitions begin.
                setTimeout(() => {
                    list ? list.classList.add('expanded') : '';
                    list ? list.classList.remove('hidden') : '';
                }, 1);
            }
        };
        this.products = [];
        this.quickLinks = [];
        this.myAccount = [];
        this.help = [];
        this.logoUrl = 'https://topline.futurimedia.com/images/logo-new.png';
    }
    static get styles() {
        return [unsafeCSS(footer)];
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
    render() {
        return lit_html_html ` <div class="container">
      <div class="image-container">
        <img src=${this.logoUrl} />
      </div>
      ${this.products.length
            ? lit_html_html `
            <div class="menu-list">
              <div
                class="toggle-menu"
                tabindex="0"
                @keyup=${(e) => this._toggleMenu(e)}
                @click=${(e) => this._toggleMenu(e)}
              >
                <fm-heading>
                  <h5>
                    Products
                  </h5>
                </fm-heading>
                <fm-icon-chevron-down></fm-icon-chevron-down>
              </div>
              <ul class="hidden">
                ${this.products.map((item) => lit_html_html `
                    <li>
                      ${item.url
                ? lit_html_html `<fm-link external href=${item.url}
                            >${item.label}</fm-link
                          >`
                : lit_html_html `<fm-link
                            @keyup=${(e) => {
                    e.keyCode === 13 && item.onClick
                        ? item.onClick()
                        : '';
                }}
                            @click=${item.onClick ? item.onClick : ''}
                            >${item.label}</fm-link
                          >`}
                    </li>
                  `)}
              </ul>
            </div>
            <hr />
          `
            : ''}
      ${this.quickLinks.length
            ? lit_html_html `
            <div class="menu-list">
              <div
                class="toggle-menu"
                tabindex="0"
                @keyup=${(e) => this._toggleMenu(e)}
                @click=${(e) => this._toggleMenu(e)}
              >
                <fm-heading>
                  <h5>
                    Quick Links
                  </h5>
                </fm-heading>
                <fm-icon-chevron-down></fm-icon-chevron-down>
              </div>
              <ul class="hidden">
                ${this.quickLinks.map((item) => lit_html_html `
                    <li>
                      ${item.url
                ? lit_html_html `<fm-link external href=${item.url}
                            >${item.label}</fm-link
                          >`
                : lit_html_html `<fm-link
                            @keyup=${(e) => {
                    e.keyCode === 13 && item.onClick
                        ? item.onClick()
                        : '';
                }}
                            @click=${item.onClick ? item.onClick : ''}
                            >${item.label}</fm-link
                          >`}
                    </li>
                  `)}
              </ul>
            </div>
            <hr />
          `
            : ''}
      ${this.myAccount.length
            ? lit_html_html `
            <div class="menu-list">
              <div
                class="toggle-menu"
                tabindex="0"
                @keyup=${(e) => this._toggleMenu(e)}
                @click=${(e) => this._toggleMenu(e)}
              >
                <fm-heading>
                  <h5>
                    My Account
                  </h5>
                </fm-heading>
                <fm-icon-chevron-down></fm-icon-chevron-down>
              </div>
              <ul class="hidden">
                ${this.myAccount.map((item) => lit_html_html `
                    <li>
                      ${item.url
                ? lit_html_html `<fm-link external href=${item.url}
                            >${item.label}</fm-link
                          >`
                : lit_html_html `<fm-link
                            @keyup=${(e) => {
                    e.keyCode === 13 && item.onClick
                        ? item.onClick()
                        : '';
                }}
                            @click=${item.onClick ? item.onClick : ''}
                            >${item.label}</fm-link
                          >`}
                    </li>
                  `)}
              </ul>
            </div>
            <hr />
          `
            : ''}
      ${this.help.length
            ? lit_html_html `
            <div class="menu-list">
              <div
                class="toggle-menu"
                tabindex="0"
                @keyup=${(e) => this._toggleMenu(e)}
                @click=${(e) => this._toggleMenu(e)}
              >
                <fm-heading>
                  <h5>
                    Help
                  </h5>
                </fm-heading>
                <fm-icon-chevron-down></fm-icon-chevron-down>
              </div>
              <ul class="hidden">
                ${this.help.map((item) => lit_html_html `
                    <li>
                      ${item.url
                ? lit_html_html `<fm-link external href=${item.url}
                            >${item.label}</fm-link
                          >`
                : lit_html_html `<fm-link
                            @keyup=${(e) => {
                    e.keyCode === 13 && item.onClick
                        ? item.onClick()
                        : '';
                }}
                            @click=${item.onClick ? item.onClick : ''}
                            >${item.label}</fm-link
                          >`}
                    </li>
                  `)}
              </ul>
            </div>
          `
            : ''}
      <div class="spacer"></div>
    </div>`;
    }
};
footer_decorate([
    property({ type: Array })
], footer_NavFooter.prototype, "products", void 0);
footer_decorate([
    property({ type: Array })
], footer_NavFooter.prototype, "quickLinks", void 0);
footer_decorate([
    property({ type: Array })
], footer_NavFooter.prototype, "myAccount", void 0);
footer_decorate([
    property({ type: Array })
], footer_NavFooter.prototype, "help", void 0);
footer_decorate([
    property({ type: String })
], footer_NavFooter.prototype, "logoUrl", void 0);
footer_NavFooter = footer_decorate([
    customElement('fm-nav-footer')
], footer_NavFooter);


// EXTERNAL MODULE: ./src/components/pill/pill.scss
var pill = __webpack_require__(20);

// CONCATENATED MODULE: ./src/components/pill/index.ts
var pill_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let pill_Pill = class Pill extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.backgroundColor = '';
        this.fontColor = '';
        this.withCloseIcon = false;
        this._handleCloseEvent = (e) => {
            var _a;
            if (e instanceof KeyboardEvent && e.keyCode !== 13)
                return;
            const event = new CustomEvent('dismiss-pill');
            this.dispatchEvent(event);
            const closeIconContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.fm-pill__close-icon');
            const path = e.composedPath();
            e instanceof MouseEvent && path.includes(closeIconContainer) && closeIconContainer.blur();
        };
    }
    static get styles() {
        return [unsafeCSS(pill)];
    }
    get pillClasses() {
        return {
            'fm-pill': true,
            'fm-pill__no-right-padding': this.withCloseIcon,
        };
    }
    get propStyles() {
        const fontColor = this.fontColor ? { 'color': this.fontColor } : {};
        const backgroundColor = this.backgroundColor ? { 'background-color': this.backgroundColor } : {};
        return Object.assign(Object.assign({}, fontColor), backgroundColor);
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.pillClasses)} style=${styleMap(this.propStyles)}>
        <div class="fm-pill__label">
          <slot></slot>
        </div>
        ${this.withCloseIcon
            ? lit_html_html `
              &nbsp;<div class="fm-pill__close-icon"
                tabindex="0"
                @click="${this._handleCloseEvent}"
                @keyup=${this._handleCloseEvent}>
                <span class="material-icons">close</span>
              </div>
            `
            : null}
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
pill_decorate([
    property({ type: String })
], pill_Pill.prototype, "backgroundColor", void 0);
pill_decorate([
    property({ type: String })
], pill_Pill.prototype, "fontColor", void 0);
pill_decorate([
    property({ type: Boolean })
], pill_Pill.prototype, "withCloseIcon", void 0);
pill_Pill = pill_decorate([
    customElement('fm-pill')
], pill_Pill);


// EXTERNAL MODULE: ./src/components/banner/success/successBanner.scss
var successBanner = __webpack_require__(21);

// CONCATENATED MODULE: ./src/components/banner/success/index.ts
var success_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let success_SuccessBanner = class SuccessBanner extends banner_Banner {
    static get styles() {
        return [...super.styles, unsafeCSS(successBanner)];
    }
};
success_SuccessBanner = success_decorate([
    customElement('fm-banner-success')
], success_SuccessBanner);


// EXTERNAL MODULE: ./src/components/buttons/tertiary/tertiaryButton.scss
var tertiaryButton = __webpack_require__(22);

// CONCATENATED MODULE: ./src/components/buttons/tertiary/index.ts
var tertiary_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let tertiary_TertiaryButton = class TertiaryButton extends button_Button {
    static get styles() {
        return [...super.styles, unsafeCSS(tertiaryButton)];
    }
};
tertiary_TertiaryButton = tertiary_decorate([
    customElement('fm-button-tertiary')
], tertiary_TertiaryButton);


// EXTERNAL MODULE: ./src/components/buttons/tertiaryIcon/tertiaryButtonIcon.scss
var tertiaryButtonIcon = __webpack_require__(23);

// CONCATENATED MODULE: ./src/components/buttons/tertiaryIcon/index.ts
var tertiaryIcon_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let tertiaryIcon_TertiaryButtonIcon = class TertiaryButtonIcon extends button_Button {
    constructor() {
        super(...arguments);
        this.icon = 'chevron_left';
        this.iconPosition = 'before';
    }
    static get styles() {
        return [...super.styles, unsafeCSS(tertiaryButtonIcon)];
    }
    /**
     * @TODO: Figure out how to pass args
     * to these getter methods to eliminate
     * the need for both the "after" and "before"
     * - Trevor Kirpaul
     */
    get renderIconBefore() {
        if (this.iconPosition === 'before') {
            return lit_html_html `
        <span class="material-icons">
          ${this.icon}
        </span>
      `;
        }
        return null;
    }
    /**
     * @TODO: See comment for `renderIconBefore`
     * - Trevor Kirpaul
     */
    get renderIconAfter() {
        if (this.iconPosition === 'after') {
            return lit_html_html `
        <span class="material-icons">
          ${this.icon}
        </span>
      `;
        }
        return null;
    }
    get tertiaryIconContent() {
        return lit_html_html `
      ${this.renderIconBefore}
      <slot class="fm-button__slot_label"></slot>
      ${this.renderIconAfter}
    `;
    }
    render() {
        return lit_html_html `
      <button class="fm-button fm-button-tertiary-icon">
        ${this.tertiaryIconContent}
      </button>
    `;
    }
};
tertiaryIcon_decorate([
    property({ type: String })
], tertiaryIcon_TertiaryButtonIcon.prototype, "icon", void 0);
tertiaryIcon_decorate([
    property({ type: String })
], tertiaryIcon_TertiaryButtonIcon.prototype, "iconPosition", void 0);
tertiaryIcon_TertiaryButtonIcon = tertiaryIcon_decorate([
    customElement('fm-button-tertiary-icon')
], tertiaryIcon_TertiaryButtonIcon);


// EXTERNAL MODULE: ./src/components/buttons/tertiarySmall/tertiaryButtonSmall.scss
var tertiaryButtonSmall = __webpack_require__(24);

// CONCATENATED MODULE: ./src/components/buttons/tertiarySmall/index.ts
var tertiarySmall_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let tertiarySmall_TertiaryButtonSmall = class TertiaryButtonSmall extends button_Button {
    static get styles() {
        return [...super.styles, unsafeCSS(tertiaryButtonSmall)];
    }
};
tertiarySmall_TertiaryButtonSmall = tertiarySmall_decorate([
    customElement('fm-button-tertiary-small')
], tertiarySmall_TertiaryButtonSmall);


// EXTERNAL MODULE: ./src/components/menus/moreMenu/moreMenu.scss
var moreMenu = __webpack_require__(25);

// CONCATENATED MODULE: ./src/components/menus/moreMenu/index.ts
var moreMenu_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let moreMenu_MoreMenu = class MoreMenu extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.menuOptions = [];
        this._isMenuContentsVisible = false;
        this._inspectToggleEvent = (e) => {
            e instanceof KeyboardEvent && e.keyCode === 13 && this._toggleMenu();
            e instanceof MouseEvent && this._toggleMenu();
        };
        this._addCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.addEventListener(event, this._inspectCloseEvents);
            });
        };
        this._inspectCloseEvents = (e) => {
            var _a, _b;
            // esc key hit
            if (e instanceof KeyboardEvent && (e === null || e === void 0 ? void 0 : e.keyCode) === 27) {
                this._toggleMenu();
                return;
            }
            // These two trigger _toggleMenu on their own
            const toggle = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.activator');
            const menu = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.fm-more-menu-content');
            const path = e.composedPath();
            if (!(path === null || path === void 0 ? void 0 : path.includes(toggle)) && !(path === null || path === void 0 ? void 0 : path.includes(menu))) {
                this._toggleMenu();
            }
        };
        this._removeCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.removeEventListener(event, this._inspectCloseEvents);
            });
        };
        this._toggleMenu = () => {
            if (!this._isMenuContentsVisible) {
                this._addCloseEvents();
                this._isMenuContentsVisible = true;
            }
            else {
                this._removeCloseEvents();
                this._isMenuContentsVisible = false;
            }
        };
    }
    static get styles() {
        return [unsafeCSS(moreMenu)];
    }
    get menuClasses() {
        return {
            'fm-more-menu': true,
            'hide': this.menuOptions.length < 1
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.menuClasses)}>
        <div class="activator-container">
          <div class="activator"
            tabindex="0"
            @click="${this._inspectToggleEvent}"
            @keyup="${this._inspectToggleEvent}">
            More
          </div>
        </div>
        
        <fm-menu-content class="fm-more-menu-content"
          .showMenu="${this._isMenuContentsVisible}"
          .menuOptions="${this.menuOptions}"
          .contentPositionStyles="${{ top: '60px', left: '-15px' }}"
          .itemTextStyles="${{ color: '#222046', 'letter-spacing': '1.44px', font: 'normal normal bold 16px/24px Roboto', 'text-transform': 'uppercase' }}"
          @fm-item-selected="${this._toggleMenu}">
        </fm-menu-content>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
moreMenu_decorate([
    property({ type: Array })
], moreMenu_MoreMenu.prototype, "menuOptions", void 0);
moreMenu_decorate([
    internalProperty()
], moreMenu_MoreMenu.prototype, "_isMenuContentsVisible", void 0);
moreMenu_MoreMenu = moreMenu_decorate([
    customElement('fm-more-menu')
], moreMenu_MoreMenu);


// EXTERNAL MODULE: ./src/components/menus/userMenu/userMenu.scss
var userMenu = __webpack_require__(26);

// CONCATENATED MODULE: ./src/components/menus/userMenu/index.ts
var userMenu_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let userMenu_UserMenu = class UserMenu extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.userInitials = 'AB';
        this._menuOptions = [
            {
                label: 'Sign out',
                href: 'https://futurimedia.com/'
            }
        ];
        this._isMenuContentsVisible = false;
        this._inspectToggleEvent = (e) => {
            e instanceof KeyboardEvent && e.keyCode === 13 && this._toggleMenu();
            e instanceof MouseEvent && this._toggleMenu();
        };
        this._addCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.addEventListener(event, this._inspectCloseEvents);
            });
        };
        this._inspectCloseEvents = (e) => {
            var _a, _b;
            // esc key hit
            if (e instanceof KeyboardEvent && (e === null || e === void 0 ? void 0 : e.keyCode) === 27) {
                this._toggleMenu();
                return;
            }
            // These two trigger _toggleMenu on their own
            const toggle = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.activator');
            const menu = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.fm-user-menu-content');
            const path = e.composedPath();
            if (!(path === null || path === void 0 ? void 0 : path.includes(toggle)) && !(path === null || path === void 0 ? void 0 : path.includes(menu))) {
                this._toggleMenu();
            }
        };
        this._removeCloseEvents = () => {
            ['click', 'keyup'].forEach(event => {
                document.removeEventListener(event, this._inspectCloseEvents);
            });
        };
        this._toggleMenu = () => {
            if (!this._isMenuContentsVisible) {
                this._addCloseEvents();
                this._isMenuContentsVisible = true;
            }
            else {
                this._removeCloseEvents();
                this._isMenuContentsVisible = false;
            }
        };
    }
    static get styles() {
        return [unsafeCSS(userMenu)];
    }
    get menuClasses() {
        return {
            'fm-user-menu': true,
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.menuClasses)}>
        <div class="activator"
          tabindex="0"
          @click="${this._inspectToggleEvent}"
          @keyup="${this._inspectToggleEvent}">
          <div class="activator__user-initials">
            <span class="activator__user-initials__text">
              ${this.userInitials}
            </span>
          </div>
          <div class="activator__icon-container">
            <div class="material-icons activator__icon-container__chevron-icon">
              ${this._isMenuContentsVisible
            ? 'expand_less'
            : 'expand_more'}
            </div>
          </div>
        </div>
        
        <fm-menu-content class="fm-user-menu-content"
          .showMenu="${this._isMenuContentsVisible}"
          .menuOptions="${this._menuOptions}"
          .contentPositionStyles="${{ top: '50px', left: '0', width: '104px' }}"
          @fm-item-selected="${this._toggleMenu}">
        </fm-menu-content>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
userMenu_decorate([
    property({ type: String })
], userMenu_UserMenu.prototype, "userInitials", void 0);
userMenu_decorate([
    internalProperty()
], userMenu_UserMenu.prototype, "_menuOptions", void 0);
userMenu_decorate([
    internalProperty()
], userMenu_UserMenu.prototype, "_isMenuContentsVisible", void 0);
userMenu_UserMenu = userMenu_decorate([
    customElement('fm-user-menu')
], userMenu_UserMenu);


// CONCATENATED MODULE: ./src/assets/top-nav/futuri-logo.png
/* harmony default export */ var futuri_logo = ("data:image/png;base64,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");
// CONCATENATED MODULE: ./src/assets/top-nav/topicpulse-logo.svg
/* harmony default export */ var topicpulse_logo = ("data:image/svg+xml;base64,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");
// CONCATENATED MODULE: ./src/assets/top-nav/prepplus-logo.svg
/* harmony default export */ var prepplus_logo = ("data:image/svg+xml;base64,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");
// CONCATENATED MODULE: ./src/assets/top-nav/post-logo.svg
/* harmony default export */ var post_logo = ("data:image/svg+xml;base64,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");
// CONCATENATED MODULE: ./src/assets/top-nav/topline-logo.svg
/* harmony default export */ var topline_logo = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/components/navigation/topNavigation/topNavigation.scss
var topNavigation = __webpack_require__(27);

// CONCATENATED MODULE: ./src/components/navigation/topNavigation/index.ts
var topNavigation_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let topNavigation_TopNavigation = class TopNavigation extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.activeProduct = '';
    }
    static get styles() {
        return [unsafeCSS(topNavigation)];
    }
    get _moreMenuProducts() {
        const products = [
            {
                label: 'TopicPulse',
                href: 'https://futurimedia.com/products/topicpulse/radio/',
                hrefTarget: '_blank',
            },
            {
                label: 'PrepPlus',
                href: 'https://futurimedia.com/products/prepplus/',
                hrefTarget: '_blank',
            },
            {
                label: 'POST',
                href: 'https://futurimedia.com/products/post/',
                hrefTarget: '_blank',
            },
            {
                label: 'TopLine',
                href: 'https://futurimedia.com/products/topline/',
                hrefTarget: '_blank',
            },
            {
                label: 'All Products',
                href: 'https://futurimedia.com',
                hrefTarget: '_blank',
            },
        ];
        const index = products.findIndex((product) => product.label.toLowerCase() === this.activeProduct.toLowerCase());
        products.splice(index, 1);
        return products;
    }
    render() {
        return lit_html_html `
      <nav class="fm-top-nav">
        <div class="fm-top-nav__products">
          <div class="fm-top-nav__products__item nav-item-futuri">
            <a class="nav-link" href="https://futurimedia.com/" target="_blank">
              <img class="nav-image logo-futuri" src="${futuri_logo}">
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'active': this.activeProduct === 'topicpulse'
        })}">
            <a class="nav-link" href="${this.activeProduct === 'topicpulse' ? '#' : 'https://futurimedia.com/products/topicpulse/radio/'}" target="_blank">
              <img class="nav-image logo-topicpulse" src="${topicpulse_logo}">
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'active': this.activeProduct === 'prepplus'
        })}">
            <a class="nav-link" href="${this.activeProduct === 'prepplus' ? '#' : 'https://futurimedia.com/products/prepplus/'}" target="_blank">
              <img class="nav-image logo-prepplus" src="${prepplus_logo}">
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'active': this.activeProduct === 'post'
        })}">
            <a class="nav-link" href="${this.activeProduct === 'post' ? '#' : 'https://futurimedia.com/products/post/'}" target="_blank">
              <img class="nav-image logo-post" src="${post_logo}">
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'active': this.activeProduct === 'topline'
        })}">
            <a class="nav-link" href="${this.activeProduct === 'topline' ? '#' : 'https://futurimedia.com/products/topline/'}" target="_blank">
              <img class="nav-image logo-topline" src="${topline_logo}">
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'active': this.activeProduct === 'allproducts',
            'nav-item-all-products': true,
            'border-color-override': this.activeProduct === 'allproducts',
        })}">
            <a class="nav-link" href="https://futurimedia.com/" target="_blank">
              <span class="logo-all-products">All Products</span>
            </a>
          </div>
          <div class="${classMap({
            'fm-top-nav__products__item': true,
            'nav-item-more-menu': true,
        })}">
            <fm-more-menu .menuOptions="${this._moreMenuProducts}">
            </fm-more-menu>
          </div>
        </div>

        <div class="fm-top-nav__right">
          <div class="fm-top-nav__right__item">
            <div class="beamer-container">
              <slot name="beamer"></slot>
            </div>
          </div>

          <div class="fm-top-nav__right__item">
            <fm-user-menu></fm-user-menu>
          </div>

          <div class="fm-top-nav__right__item nav-item-mobile-menu">
            <div class="mobile-menu-activator" title="Just a placeholder for now">
              menu
            </div>
          </div>
        </div>
      </nav>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
topNavigation_decorate([
    property({ type: String })
], topNavigation_TopNavigation.prototype, "activeProduct", void 0);
topNavigation_TopNavigation = topNavigation_decorate([
    customElement('fm-top-navigation')
], topNavigation_TopNavigation);


// EXTERNAL MODULE: ./src/components/banner/warning/warningBanner.scss
var warningBanner = __webpack_require__(28);

// CONCATENATED MODULE: ./src/components/banner/warning/index.ts
var warning_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let warning_WarningBanner = class WarningBanner extends banner_Banner {
    constructor() {
        super(...arguments);
        this.icon = 'error_outline';
    }
    static get styles() {
        return [...super.styles, unsafeCSS(warningBanner)];
    }
};
warning_WarningBanner = warning_decorate([
    customElement('fm-banner-warning')
], warning_WarningBanner);


// EXTERNAL MODULE: ./src/components/modal/actionRow/actionRow.scss
var actionRow = __webpack_require__(29);

// CONCATENATED MODULE: ./src/components/modal/actionRow/index.ts
var actionRow_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let actionRow_ModalActionRow = class ModalActionRow extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        // PRIMARY BUTTON PROPS
        this.buttonPrimaryLabel = 'buttonPrimaryLabel';
        this.buttonPrimaryDisabled = false;
        this.buttonPrimaryLoading = false;
        this.buttonPrimarySuccess = false;
        this._dispatchPrimaryButtonEvent = () => {
            const clickEvent = new CustomEvent('fm-modal-primary-click');
            this.dispatchEvent(clickEvent);
        };
        // TERTIARY BUTTON PROPS
        this.buttonTertiaryLabel = 'buttonTertiaryLabel';
        this.buttonTertiaryDisabled = false;
        this.buttonTertiaryLoading = false;
        this.buttonTertiarySuccess = false;
        this._dispatchTertiaryButtonEvent = () => {
            const clickEvent = new CustomEvent('fm-modal-tertiary-click');
            this.dispatchEvent(clickEvent);
        };
    }
    static get styles() {
        return [unsafeCSS(actionRow)];
    }
    render() {
        return lit_html_html `
      <div class="fm-modal-action-row">
        <fm-button-tertiary
          class="fm-button-tertiary"
          @click=${this._dispatchPrimaryButtonEvent}
          .disabled=${this.buttonTertiaryDisabled}
          .loading=${this.buttonTertiaryLoading}
          .success=${this.buttonTertiarySuccess}
        >
          ${this.buttonTertiaryLabel}
        </fm-button-tertiary>
        <fm-button-primary
          class="fm-button-primary"
          @click=${this._dispatchTertiaryButtonEvent}
          .disabled=${this.buttonPrimaryDisabled}
          .loading=${this.buttonPrimaryLoading}
          .success=${this.buttonPrimarySuccess}
        >
          ${this.buttonPrimaryLabel}
        </fm-button-primary>
      </div>
    `;
    }
};
actionRow_decorate([
    property({ type: String })
], actionRow_ModalActionRow.prototype, "buttonPrimaryLabel", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonPrimaryDisabled", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonPrimaryLoading", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonPrimarySuccess", void 0);
actionRow_decorate([
    property({ type: String })
], actionRow_ModalActionRow.prototype, "buttonTertiaryLabel", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonTertiaryDisabled", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonTertiaryLoading", void 0);
actionRow_decorate([
    property({ type: Boolean })
], actionRow_ModalActionRow.prototype, "buttonTertiarySuccess", void 0);
actionRow_ModalActionRow = actionRow_decorate([
    customElement('fm-modal-action-row')
], actionRow_ModalActionRow);


// EXTERNAL MODULE: ./src/components/modal/controlRow/controlRow.scss
var controlRow = __webpack_require__(30);

// CONCATENATED MODULE: ./src/components/modal/controlRow/index.ts
var controlRow_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let controlRow_ModalControlRow = class ModalControlRow extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this._dispatchCloseEvent = () => {
            const closeEvent = new CustomEvent('fm-modal-close');
            this.dispatchEvent(closeEvent);
        };
    }
    static get styles() {
        return [unsafeCSS(controlRow)];
    }
    render() {
        return lit_html_html `
      <div class="fm-modal-control-row">
        <button
          class="fm-modal-control-row__button"
          @click=${this._dispatchCloseEvent}
        >
          <span class="material-icons fm-modal-control-row__button__icon">
            close
          </span>
        </button>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
controlRow_ModalControlRow = controlRow_decorate([
    customElement('fm-modal-control-row')
], controlRow_ModalControlRow);


// EXTERNAL MODULE: ./src/components/body/body.scss
var body = __webpack_require__(31);

// CONCATENATED MODULE: ./src/components/body/index.ts
var body_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let body_Body = class Body extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'LARGE';
    }
    static get styles() {
        return [unsafeCSS(body)];
    }
    get classes() {
        return {
            'fm-body': true,
            'fm-body-large': this.variant === 'LARGE',
            'fm-body-medium': this.variant === 'MEDIUM',
            'fm-body-disclaimer': this.variant === 'DISCLAIMER',
            'fm-body-button-text': this.variant === 'BUTTON-TEXT'
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.classes)}>
        <slot></slot>
      </div>
    `;
    }
};
body_decorate([
    property({ type: String })
], body_Body.prototype, "variant", void 0);
body_Body = body_decorate([
    customElement('fm-body')
], body_Body);


// EXTERNAL MODULE: ./src/components/fields/input/input.scss
var input = __webpack_require__(32);

// CONCATENATED MODULE: ./src/components/fields/input/index.ts
var input_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const hasError = (x) => typeof x === 'string' && x.length > 0;
let input_Input = class Input extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.label = '';
        this.placeholder = '';
        this.assistiveText = '';
        this.error = '';
        this.link = {
            label: undefined,
            onClick: () => undefined
        };
        this._inputEventHandler = (e) => {
            const target = e.target;
            this.value = target.value;
        };
    }
    static get styles() {
        return [unsafeCSS(input)];
    }
    get classes() {
        return {
            'fm-input': true,
            'fm-input-error': hasError(this.error)
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.classes)} @input="${this._inputEventHandler}" >
        <fm-field-label label=${this.label} .link=${this.link}></fm-field-label>
        <input
          class="fm-input__input"
          type="text"
          placeholder=${this.placeholder}
          value="${this.value}"
        />

        <fm-assistive assistiveText=${this.assistiveText} error=${this.error}>
        </fm-assistive>
      </div>
    `;
    }
};
input_decorate([
    property({ type: String })
], input_Input.prototype, "value", void 0);
input_decorate([
    property({ type: String })
], input_Input.prototype, "label", void 0);
input_decorate([
    property({ type: String })
], input_Input.prototype, "placeholder", void 0);
input_decorate([
    property({ type: String })
], input_Input.prototype, "assistiveText", void 0);
input_decorate([
    property({ type: String })
], input_Input.prototype, "error", void 0);
input_decorate([
    property({ type: Object })
], input_Input.prototype, "link", void 0);
input_Input = input_decorate([
    customElement('fm-input')
], input_Input);


// EXTERNAL MODULE: ./src/components/searchBar/searchBar.scss
var searchBar = __webpack_require__(33);

// CONCATENATED MODULE: ./src/components/searchBar/index.ts
var searchBar_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let searchBar_SearchBar = class SearchBar extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = 'Search by keyword or title';
        this.value = '';
        this.searchTerm = '';
        this._inputEventHandler = (e) => {
            const target = e.target;
            this.value = target.value;
        };
    }
    static get styles() {
        return [unsafeCSS(searchBar)];
    }
    get classes() {
        return {
            'fm-search-bar': true
        };
    }
    _submitEventHandler(e) {
        e.preventDefault();
        const customEvent = new CustomEvent('fm-search', {
            detail: {
                value: this.value
            }
        });
        this.dispatchEvent(customEvent);
    }
    render() {
        return lit_html_html `
      <form class=${classMap(this.classes)} @submit="${this._submitEventHandler}">
        <div class="input-wrap">
          <span class="material-icons fm-search-bar__icon">
            search
          </span>
          <input
            tabindex="1"
            class="fm-search-bar__input"
            type="text"
            placeholder=${this.placeholder}
            value=${this.searchTerm}
            @input=${this._inputEventHandler}
          />

          <button
            tabindex="2"
            type="submit"
            class="fm-search-bar__button"
          >
            <span class="search-button-label">
              Search
            </span>
          </button>
        </div>
      </form>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
searchBar_decorate([
    property({ type: String })
], searchBar_SearchBar.prototype, "placeholder", void 0);
searchBar_decorate([
    property({ type: String })
], searchBar_SearchBar.prototype, "value", void 0);
searchBar_decorate([
    property({ type: String })
], searchBar_SearchBar.prototype, "searchTerm", void 0);
searchBar_SearchBar = searchBar_decorate([
    customElement('fm-search-bar')
], searchBar_SearchBar);


// EXTERNAL MODULE: ./src/components/select/select.scss
var select_select = __webpack_require__(34);

// CONCATENATED MODULE: ./src/components/select/index.ts
var select_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


const hasPlaceholder = (x) => typeof x === 'string' && x.length > 0;
let select_Select = class Select extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.label = '';
        this.value = '';
        this.link = {
            label: undefined,
            onClick: () => undefined
        };
        this.assistiveText = '';
        this.error = '';
        this.options = [];
        this._inputEventHandler = (e) => {
            const target = e.target;
            this.value = target.value;
        };
    }
    static get styles() {
        return [unsafeCSS(select_select)];
    }
    get getPlaceholderElement() {
        if (hasPlaceholder(this.placeholder)) {
            return lit_html_html `
        <option class="fm-select__placeholder">${this.placeholder}</option>
      `;
        }
        return null;
    }
    /* eslint-disable indent */
    render() {
        return lit_html_html `
      <div class="fm-select">
        <fm-field-label label=${this.label} .link=${this.link}></fm-field-label>
        <div class="select-wrapper">
          <select
            class="fm-select__input"
            @input=${this._inputEventHandler}
            .value=${this.value}
          >
            ${this.getPlaceholderElement}
            ${this.options.map((option) => lit_html_html `
                <option value=${option.value}>${option.label}</option>
              `)}
          </select>
          <span class="material-icons">
            expand_more
          </span>
        </div>
        <fm-assistive assistiveText=${this.assistiveText} error=${this.error}>
        </fm-assistive>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
select_decorate([
    property({ type: String })
], select_Select.prototype, "placeholder", void 0);
select_decorate([
    property({ type: String })
], select_Select.prototype, "label", void 0);
select_decorate([
    property({ type: String })
], select_Select.prototype, "value", void 0);
select_decorate([
    property({ type: Object })
], select_Select.prototype, "link", void 0);
select_decorate([
    property({ type: String })
], select_Select.prototype, "assistiveText", void 0);
select_decorate([
    property({ type: String })
], select_Select.prototype, "error", void 0);
select_decorate([
    property({ type: Array })
], select_Select.prototype, "options", void 0);
select_Select = select_decorate([
    customElement('fm-select')
], select_Select);


// EXTERNAL MODULE: ./src/components/fields/label/label.scss
var label = __webpack_require__(35);

// CONCATENATED MODULE: ./src/components/fields/label/index.ts
var label_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const shouldRender = ({ link, label }) => {
    const missingLabel = !label || label.length === 0;
    const missingLink = !(link === null || link === void 0 ? void 0 : link.label);
    if (missingLabel && missingLink)
        return false;
    return true;
};
let label_FieldLabel = class FieldLabel extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.link = {
            label: undefined,
            onClick: () => undefined
        };
    }
    static get styles() {
        return [unsafeCSS(label)];
    }
    get renderAssistiveLink() {
        if (this.link.label) {
            return lit_html_html `
        <button
          class="fm-field-label__assistive-link__button"
          .onclick=${this.link.onClick}
        >
          <span class="fm-field-label__assistive-link__label"
            >${this.link.label}</span
          >
        </button>
      `;
        }
        return null;
    }
    get classes() {
        return {
            'fm-field-label': true
        };
    }
    render() {
        if (!shouldRender({
            link: this.link,
            label: this.label
        })) {
            return null;
        }
        return lit_html_html `
      <div class=${classMap(this.classes)}>
        <label class="fm-field-label__label">${this.label}</label>
        ${this.renderAssistiveLink}
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
label_decorate([
    property({ type: String })
], label_FieldLabel.prototype, "label", void 0);
label_decorate([
    property({ type: Object })
], label_FieldLabel.prototype, "link", void 0);
label_FieldLabel = label_decorate([
    customElement('fm-field-label')
], label_FieldLabel);


// EXTERNAL MODULE: ./src/components/fields/assistive/assistive.scss
var assistive = __webpack_require__(36);

// CONCATENATED MODULE: ./src/components/fields/assistive/index.ts
var assistive_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const assistive_hasError = (x) => typeof x === 'string' && x.length > 0;
let assistive_FieldAssistive = class FieldAssistive extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.assistiveText = '';
        this.error = '';
    }
    static get styles() {
        return [unsafeCSS(assistive)];
    }
    get renderErrorText() {
        return lit_html_html `
      <div
        class=${classMap({
            'fm-assistive__error-row': true,
            'fm-assistive__error-row__hide': !assistive_hasError(this.error)
        })}
      >
        <span class="material-icons fm-assistive__error-icon">
          report_problem
        </span>

        <span class="fm-assistive__error-label">
          ${this.error}
        </span>
      </div>
    `;
    }
    get classes() {
        return {
            'fm-assistive': true,
            'fm-assistive-error': assistive_hasError(this.error)
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.classes)}>
        <div class="fm-assistive__text-row">
          <span class="fm-assistive__assistive-text">
            ${this.assistiveText}
          </span>
        </div>
        ${this.renderErrorText}
      </div>
    `;
    }
};
assistive_decorate([
    property({ type: String })
], assistive_FieldAssistive.prototype, "assistiveText", void 0);
assistive_decorate([
    property({ type: String })
], assistive_FieldAssistive.prototype, "error", void 0);
assistive_FieldAssistive = assistive_decorate([
    customElement('fm-assistive')
], assistive_FieldAssistive);


// EXTERNAL MODULE: ./src/components/datePicker/datePicker.scss
var datePicker = __webpack_require__(37);

// CONCATENATED MODULE: ./src/components/datePicker/index.ts
var datePicker_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let datePicker_DatePicker = class DatePicker extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.min = '';
        this.max = '';
        this.label = '';
        this.link = {
            label: undefined,
            onClick: () => undefined
        };
        this.assistiveText = '';
        this.error = '';
        this._inputEventHandler = (e) => {
            const target = e.target;
            this.value = target.value;
        };
    }
    static get styles() {
        return [unsafeCSS(datePicker)];
    }
    render() {
        return lit_html_html `
      <div class="fm-time-picker-container">
        <fm-field-label .label=${this.label} .link=${this.link}></fm-field-label>
        <input
          @input="${this._inputEventHandler}"
          class="fm-date-picker"
          type="date"
          min="${this.min}"
          max="${this.max}"
          value="${this.value}"
        />
        <fm-assistive assistiveText=${this.assistiveText} error=${this.error}>
        </fm-assistive>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "value", void 0);
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "min", void 0);
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "max", void 0);
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "label", void 0);
datePicker_decorate([
    property({ type: Object })
], datePicker_DatePicker.prototype, "link", void 0);
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "assistiveText", void 0);
datePicker_decorate([
    property({ type: String })
], datePicker_DatePicker.prototype, "error", void 0);
datePicker_DatePicker = datePicker_decorate([
    customElement('fm-date-picker')
], datePicker_DatePicker);


// EXTERNAL MODULE: ./src/components/timePicker/timePicker.scss
var timePicker = __webpack_require__(38);

// CONCATENATED MODULE: ./src/components/timePicker/index.ts
var timePicker_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let timePicker_TimePicker = class TimePicker extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.min = '';
        this.max = '';
        this.inlineLabel = '';
        this.label = '';
        this.link = {
            label: undefined,
            onClick: () => undefined
        };
        this.assistiveText = '';
        this.error = '';
        this._inputEventHandler = (e) => {
            const target = e.target;
            this.value = target.value;
        };
    }
    static get styles() {
        return [unsafeCSS(timePicker)];
    }
    render() {
        return lit_html_html `
      <div class="fm-time-picker-container">
        <fm-field-label .label=${this.label} .link=${this.link}></fm-field-label>
        <input
          @input=${this._inputEventHandler}
          class="fm-time-picker"
          type="time"
          data-label="${this.inlineLabel}"
          value="${this.value}"
          min="${this.min}"
          max="${this.max}"
        />
        <fm-assistive assistiveText=${this.assistiveText} error=${this.error}>
        </fm-assistive>
      </div>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "value", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "min", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "max", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "inlineLabel", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "label", void 0);
timePicker_decorate([
    property({ type: Object })
], timePicker_TimePicker.prototype, "link", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "assistiveText", void 0);
timePicker_decorate([
    property({ type: String })
], timePicker_TimePicker.prototype, "error", void 0);
timePicker_TimePicker = timePicker_decorate([
    customElement('fm-time-picker')
], timePicker_TimePicker);


// EXTERNAL MODULE: ./src/components/table/table.scss
var table = __webpack_require__(39);

// CONCATENATED MODULE: ./src/components/table/index.ts
var table_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




function isComplexTableHeaderItem(x) {
    return x.label !== undefined;
}
function isComplexTableCell(x) {
    var _a;
    return !(x instanceof String) && !(x instanceof HTMLElement)
        && ((_a = x) === null || _a === void 0 ? void 0 : _a.cell) !== undefined;
}
let table_Table = class Table extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.headers = [];
        this.data = [];
    }
    static get styles() {
        return [unsafeCSS(table)];
    }
    renderTableHeaders(headers) {
        if (isComplexTableHeaderItem(headers[0])) {
            return lit_html_html `
        <tr class="fm-table__header">
          <!-- casting to prevent a TS error -->
          ${headers.map((headerItem, i) => {
                if (isComplexTableHeaderItem(headerItem)) {
                    return lit_html_html `
                  <th @click=${headerItem.onClick} tabindex=${i + 1}>
                    <div class="center">
                      ${headerItem.label}
                      <span class="material-icons fm-table-header__drop-down">
                        ${headerItem.arrowUp
                        ? 'arrow_drop_up'
                        : 'arrow_drop_down'}
                      </span>
                    </div>
                  </th>
                `;
                }
                return null;
            })}
        </tr>
      `;
        }
        return lit_html_html `
      <tr class="fm-table__header">
        <!-- casting to prevent a TS error -->
        ${headers.map((headerItem) => lit_html_html `
            <th>
              <div class="center">
                ${headerItem}
                <span class="material-icons fm-table-header__drop-down">
                  arrow_drop_down
                </span>
              </div>
            </th>
          `)}
      </tr>
    `;
    }
    renderTableData(tableHeaders, tableData) {
        const numHeaders = tableHeaders.length;
        return lit_html_html `
      ${tableData.map((mappedTableData) => {
            let headersRemain = numHeaders;
            return lit_html_html `
          <tr class="fm-table__row">
            <!-- casting to prevent a TS error -->
            ${tableHeaders.map((tableHeader) => {
                const mappedCellData = isComplexTableHeaderItem(tableHeader)
                    ? mappedTableData[tableHeader.label]
                    : mappedTableData[tableHeader];
                const cell = isComplexTableCell(mappedCellData)
                    ? mappedCellData
                    : { cell: mappedCellData, colspan: undefined };
                const { cell: value, colspan } = cell;
                if (colspan !== undefined) {
                    headersRemain -= colspan;
                    return lit_html_html `
                  <td colspan="${colspan}">
                    ${value}
                  </td>
                `;
                }
                else if (headersRemain > 0) {
                    headersRemain--;
                    return lit_html_html `
                    <td>
                      ${value}
                    </td>
                  `;
                }
                else {
                    return lit_html_html `
                  `;
                }
            })}
          </tr>
        `;
        })}
    `;
    }
    render() {
        return lit_html_html `
      <table class="fm-table">
        ${this.renderTableHeaders(this.headers)}
        ${this.renderTableData(this.headers, this.data)}
      </table>
    `;
    }
    firstUpdated() {
        if (window.applyFocusVisiblePolyfill != null) {
            window.applyFocusVisiblePolyfill(this.shadowRoot);
        }
    }
};
table_decorate([
    property({ type: Array })
], table_Table.prototype, "headers", void 0);
table_decorate([
    property({ type: Array })
], table_Table.prototype, "data", void 0);
table_Table = table_decorate([
    customElement('fm-table')
], table_Table);


// EXTERNAL MODULE: ./src/components/drawer/drawer.scss
var drawer = __webpack_require__(40);

// CONCATENATED MODULE: ./src/components/drawer/index.ts
var drawer_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let drawer_Drawer = class Drawer extends lit_element_LitElement {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.visibleWidth = '596px';
    }
    static get styles() {
        return [unsafeCSS(drawer)];
    }
    get drawerClasses() {
        return {
            'fm-drawer': true,
            'fm-drawer-visible': this.visible
        };
    }
    get backdropClasses() {
        return {
            'fm-drawer__backdrop': true,
            'fm-drawer__backdrop-visible': this.visible
        };
    }
    render() {
        return lit_html_html `
      <div class=${classMap(this.backdropClasses)}></div>
      <div
        class=${classMap(this.drawerClasses)}
        style=${styleMap({
            width: this.visible ? this.visibleWidth : '0px'
        })}
      >
        <slot name="content"></slot>
      </div>
    `;
    }
};
drawer_decorate([
    property({ type: Boolean })
], drawer_Drawer.prototype, "visible", void 0);
drawer_decorate([
    property({ type: String })
], drawer_Drawer.prototype, "visibleWidth", void 0);
drawer_Drawer = drawer_decorate([
    customElement('fm-drawer')
], drawer_Drawer);


// CONCATENATED MODULE: ./src/index.ts










































/***/ })
/******/ ]);